import React, { useEffect, useState, useMemo, useRef, use } from 'react';
import { useNavigate } from 'react-router-dom';
import "../App.css";
import '../assets/css/gapsybdmupload.css';
import "../assets/Nunito_Sans/static/NotoSansDevanagari-Regular-normal.js";
import "../assets/Nunito_Sans/static/NotoSansDevanagari-Bold-normal.js";
import "../assets/Nunito_Sans/static/DejaVuSans-normal.js";
import '../assets/css/Tableproperty.css';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';
// import NotoSansNormal from "./NotoSans-Regular-normal.js";
import Chart from 'chart.js/auto';
import autoTable from 'jspdf-autotable';
import ExcelJS from 'exceljs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import logoBase64 from '../assets/images/psb.png';
import SloganBase64 from '../assets/images/psb_slogan_hind1i.png';
import { jsPDF } from "jspdf";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Audittemplatelist, portfolioReportList, portfolioReport, AllTemplateColumns, PortURL, demoAireportTexts, ReportWebsocket } from '../components/ApiProperty';
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import { faSort, faSortUp, faSortDown, faListAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import '../assets/css/gapsycaudit.css';
import { UploadLoadingIcon } from "../components/Propertyfile";
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from "recharts";


const GapsyReport = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('outline'); // 'manual' or 'ai'
    const [filteredTables, setFilteredTables] = useState([]);
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [Isloading, setIsLoading] = useState(false);

    const [loading, setLoading] = useState(false);
    const [wsInsights, setWsInsights] = useState("");
    const [npaDescription, setNpaDescription] = useState("");
    const [selectedTable, setSelectedTable] = useState(null);
    const wsRef = useRef(null);
    const [reportData, setReportData] = useState(null);
    const [tableNames, setTableNames] = useState([]);
    const [portfolioYields, setPortfolioYields] = useState({});
    const [currentPage1, setCurrentPage1] = useState(1);
    const [recordsPerPage1] = useState(7); // Set the number of records per page
    const [selectedName, setSelectedName] = useState('');
    const [selectedSector, setSelectedSector] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const prefixes = Object.keys(tableNames);
    const [columns, setColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [availableDates, setAvailableDates] = useState([]);
    const [sumColumns, setSumColumns] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [midDate, setMidDate] = useState("");
    const [availableSumColumns, setAvailableSumColumns] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [reportGenerated, setReportGenerated] = useState(false);
    const [tableColumns, setTableColumns] = useState([]);
    const [originalResponseData, setOriginalResponseData] = useState([]);
    const [availableSectors, setAvailableSectors] = useState([]);
    const [sums, setSums] = useState({});
    const [filteredData, setFilteredData] = useState([]);
    const username = localStorage.getItem('username');
    const userRole = localStorage.getItem('userRole');
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [tempSelectedTable, setTempSelectedTable] = useState('');
    const [processedReports, setProcessedReports] = useState({});
    const [differenceTable, setDifferenceTable] = useState([]);
    const [differenceTable1, setDifferenceTable1] = useState([]);
    const [overallStability, setOverallStability] = useState("0.00");
    // Add this state near your other state declarations
    const [wsAIDescriptions, setWsAIDescriptions] = useState({});


    const department = sessionStorage.getItem("dept");
    console.log("department", department);
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const computedSums = calculateSums();
        setSums(computedSums);
    }, [tableData, sumColumns, searchQuery, fromDate, toDate]);

    const userId = localStorage.getItem("userid");

    // const fetchData = async () => {
    //     try {
    //         const config = {
    //             params: { checkerId: userId, dept: department },
    //             headers: { 'x-csrf-token': csrfToken },
    //             withCredentials: true
    //         };

    //         const response = await axios.post(Audittemplatelist, {}, config);
    //         console.log("response", response);
    //         console.log("response.data", response.data);

    //         const apiTables = response.data?.tableList || [];

    //         // Default list from tableDisplayMap with selected prefix (e.g., 'risk_')
    //         const defaultPrefix = department; // or derive dynamically if needed
    //         const defaultTables = Object.keys(tableDisplayMap).map((key) => `${defaultPrefix}_${key}`);

    //         // Merge API tables and default tables, remove duplicates
    //         const allTables = Array.from(new Set([...apiTables, ...defaultTables]));

    //         // Categorize tables by prefix
    //         const categorizedTables = {};
    //         allTables.forEach((table) => {
    //             const [prefix, ...rest] = table.split('_');
    //             if (!categorizedTables[prefix]) categorizedTables[prefix] = [];
    //             categorizedTables[prefix].push(table);
    //         });

    //         setTableNames(categorizedTables);

    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const config = {
                params: { dept: selectedPrefix }, // department from sessionStorage
                headers: {
                    userId,
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            };

            const response = await axios.post(portfolioReportList, {}, config);

            if (response.data?.tableList?.length) {
                setTableNames(response.data.tableList);
            } else {
                setTableNames([]);
            }

            if (response.data?.dates?.length) {
                const sortedDates = [...response.data.dates].sort(); // ascending
                setAvailableDates(sortedDates);

                const earliest = sortedDates[0];
                const latest = sortedDates[sortedDates.length - 1];

                setFromDate(earliest);
                setToDate(latest);
                console.log("fromDate", fromDate);
                console.log("toDate", toDate);
                console.log("fromDate set to:", earliest);
                console.log("toDate set to:", latest);
            } else {
                setAvailableDates([]);
                setFromDate("");
                setToDate("");
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setTableNames([]);
            setAvailableDates([]);
            setFromDate("");
            setToDate("");
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (processedReports[selectedName]) {
            setPortfolioYields(prev => ({
                ...prev,
                [selectedName]: {
                    overall: processedReports[selectedName].overallPortfolioYield ?? 0,
                    standard: processedReports[selectedName].stdActsPortfolioYield ?? 0,
                }
            }));
        }
    }, [processedReports, selectedName]);

    useEffect(() => {
        if (selectedPrefix) {
            setFilteredTables(tableNames || []);
        } else {
            setFilteredTables([]);
        }
    }, [selectedPrefix, tableNames]);



    const toTitleCase = (str) => {
        return str
            .replace(/[_-]/g, ' ')
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };

    const filteredRecords1 = useMemo(() => {
        if (!selectedPrefix) return [];

        const query = searchQuery.toLowerCase().trim();

        // tableNames is now a flat array
        return tableNames.filter((tableName) =>
            tableName.toLowerCase().includes(query)
        );
    }, [tableNames, searchQuery, selectedPrefix]);


    useEffect(() => {
        setCurrentPage1(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage1(1);
    }, [selectedPrefix]);

    const sortedRecords1 = useMemo(() => {
        return [...filteredRecords1].sort((a, b) => {
            const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
            const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
            return bStarts - aStarts;
        });
    }, [filteredRecords1, searchQuery]);

    const indexOfLastRecord = currentPage1 * recordsPerPage1;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage1;
    const currentRecords1 = sortedRecords1.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages1 = Math.ceil(sortedRecords1.length / recordsPerPage1);
    console.log("sortedRecords.length", sortedRecords1.length);
    console.log("recordsPerPage", recordsPerPage1);
    console.log("totalPages", totalPages1);

    // Process Accounting Override
    const processAccountingOverride = (jsonData) => {
        let flattenedData = [];
        let dates = [];

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000; // keep conversion
            return Number(num.toFixed(2));
        };

        const fmtPct = (val) => {
            // always produce a formatted percentage string
            return (typeof val === "number" && !Number.isNaN(val)) ? val.toFixed(2) + "%" : "0.00%";
        };

        // --- Flatten Data ---
        if (Array.isArray(jsonData)) {
            flattenedData = jsonData.map(item => {
                const balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma12 = sma1 + sma2;

                const npaPct = balance > 0 ? (npa / balance) * 100 : 0;
                const sma1Pct = balance > 0 ? (sma1 / balance) * 100 : 0;
                const sma2Pct = balance > 0 ? (sma2 / balance) * 100 : 0;
                const sma12Pct = balance > 0 ? (sma12 / balance) * 100 : 0;

                return {
                    Date: item.reporting_date,
                    Sector: item.rep_param,
                    "Balance": balance,
                    NPA: npa,
                    SMA1: sma1,
                    SMA2: sma2,
                    "SMA1+2": sma12,
                    // numeric fields for logic
                    NPA_PCT: npaPct,
                    SMA1_PCT: sma1Pct,
                    SMA2_PCT: sma2Pct,
                    SMA1_2_PCT: sma12Pct,
                    // formatted strings for table display
                    "NPA%": fmtPct(npaPct),
                    "SMA1%": fmtPct(sma1Pct),
                    "SMA2%": fmtPct(sma2Pct),
                    "SMA1+2%": fmtPct(sma12Pct),
                    "Yield on Advances": fmtPct(sma12Pct)
                };
            });
            dates = [...new Set(flattenedData.map(item => item.Date))].sort();
        } else if (typeof jsonData === "object" && jsonData !== null) {
            for (const [date, sectors] of Object.entries(jsonData)) {
                for (const [sector, metrics] of Object.entries(sectors)) {
                    const balance = toCrores(metrics.os_balance);
                    const npa = toCrores(metrics.npa);
                    const sma1 = toCrores(metrics.sma1);
                    const sma2 = toCrores(metrics.sma2);
                    const sma12 = sma1 + sma2;

                    const npaPct = balance > 0 ? (npa / balance) * 100 : 0;
                    const sma1Pct = balance > 0 ? (sma1 / balance) * 100 : 0;
                    const sma2Pct = balance > 0 ? (sma2 / balance) * 100 : 0;
                    const sma12Pct = balance > 0 ? (sma12 / balance) * 100 : 0;

                    flattenedData.push({
                        Date: date,
                        Sector: sector,
                        "Balance": balance,
                        NPA: npa,
                        SMA1: sma1,
                        SMA2: sma2,
                        "SMA1+2": sma12,
                        NPA_PCT: npaPct,
                        SMA1_PCT: sma1Pct,
                        SMA2_PCT: sma2Pct,
                        SMA1_2_PCT: sma12Pct,
                        "NPA%": fmtPct(npaPct),
                        "SMA1%": fmtPct(sma1Pct),
                        "SMA2%": fmtPct(sma2Pct),
                        "SMA1+2%": fmtPct(sma12Pct),
                        "Yield on Advances": fmtPct(sma12Pct)
                    });
                }
            }
            dates = Object.keys(jsonData).sort();
        }

        // --- Add Grand Totals (per date) ---
        dates.forEach(date => {
            const rows = flattenedData.filter(r => r.Date === date && r.Sector !== "Grand Total");
            if (rows.length > 0) {
                const balance = rows.reduce((sum, r) => sum + (Number(r["Balance"]) || 0), 0);
                const npa = rows.reduce((sum, r) => sum + (Number(r.NPA) || 0), 0);
                const sma1 = rows.reduce((sum, r) => sum + (Number(r.SMA1) || 0), 0);
                const sma2 = rows.reduce((sum, r) => sum + (Number(r.SMA2) || 0), 0);
                const sma12 = sma1 + sma2;

                const npaPct = balance > 0 ? (npa / balance) * 100 : 0;
                const sma1Pct = balance > 0 ? (sma1 / balance) * 100 : 0;
                const sma2Pct = balance > 0 ? (sma2 / balance) * 100 : 0;
                const sma12Pct = balance > 0 ? (sma12 / balance) * 100 : 0;

                flattenedData.push({
                    Date: date,
                    Sector: "Grand Total",
                    "Balance": balance,
                    NPA: npa,
                    SMA1: sma1,
                    SMA2: sma2,
                    "SMA1+2": sma12,
                    NPA_PCT: npaPct,
                    SMA1_PCT: sma1Pct,
                    SMA2_PCT: sma2Pct,
                    SMA1_2_PCT: sma12Pct,
                    "NPA%": fmtPct(npaPct),
                    "SMA1%": fmtPct(sma1Pct),
                    "SMA2%": fmtPct(sma2Pct),
                    "SMA1+2%": fmtPct(sma12Pct),
                    "Yield on Advances": fmtPct(sma12Pct)
                });
            }
        });

        // --- Descriptions ---
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevGrand = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestGrand = latestRows.find(r => r.Sector === "Grand Total") || {};

            // 1. Overall NPA% change (use !== undefined to allow 0)
            if (typeof prevGrand.NPA_PCT !== "undefined" && typeof latestGrand.NPA_PCT !== "undefined") {
                descriptions.push(
                    `Overall NPA % has ${latestGrand.NPA_PCT < prevGrand.NPA_PCT ? "decreased" : "increased"} from ${prevGrand.NPA_PCT.toFixed(2)}% to ${latestGrand.NPA_PCT.toFixed(2)}% during the quarter.`
                );
            }

            // 2. Overall SMA1+2% change
            if (typeof prevGrand.SMA1_2_PCT !== "undefined" && typeof latestGrand.SMA1_2_PCT !== "undefined") {
                descriptions.push(
                    `Overall SMA% (having SMA 1+2) has ${latestGrand.SMA1_2_PCT < prevGrand.SMA1_2_PCT ? "decreased" : "increased"} from ${prevGrand.SMA1_2_PCT.toFixed(2)}% to ${latestGrand.SMA1_2_PCT.toFixed(2)}%.`
                );
            }

            // 3. Sector-wise growth (dynamic)
            // 3. Sector-wise growth (dynamic)
            // 3. Sector-wise growth (only Retail and Agri — always show)
            // latestRows.forEach(latest => {
            //     if (latest.Sector !== "Grand Total" && ["RETL", "MSME"].includes(latest.Sector)) {
            //         const prev = prevRows.find(r => r.Sector === latest.Sector) || {};
            //         if (
            //             typeof prev["Balance"] !== "undefined" &&
            //             prev["Balance"] > 0 &&
            //             typeof latest["Balance"] !== "undefined"
            //         ) {
            //             const growth = ((latest["Balance"] - prev["Balance"]) / prev["Balance"]) * 100;
            //             const trend = growth >= 0 ? "increased" : "decreased";

            //             descriptions.push(
            //                 `${latest.Sector} grew by ${Math.abs(growth).toFixed(2)}% from ₹${prev["Balance"].toLocaleString("en-IN")} crore to ₹${latest["Balance"].toLocaleString("en-IN")} crore.`
            //             );
            //         }
            //     }
            // });

            const growthTexts = [];

            ["RETL", "MSME"].forEach(sector => {
                const latest = latestRows.find(r => r.Sector === sector);
                const prev = prevRows.find(r => r.Sector === sector);

                if (latest && prev && prev["Balance"] > 0 && latest["Balance"] > 0) {
                    const growth = ((latest["Balance"] - prev["Balance"]) / prev["Balance"]) * 100;
                    const trend = growth >= 0 ? "increased" : "decreased";

                    growthTexts.push(
                        `${sector} ${trend} by ${Math.abs(growth).toFixed(2)}% from ₹${prev["Balance"].toLocaleString(
                            "en-IN"
                        )} crore to ₹${latest["Balance"].toLocaleString("en-IN")} crore`
                    );
                }
            });

            if (growthTexts.length > 0) {
                descriptions.push(growthTexts.join(", and ") + ".");
            }



            // 4. Total stressed portfolio (NPA + SMA1+2) as on latest date
            if (typeof latestGrand.NPA_PCT !== "undefined" && typeof latestGrand.SMA1_2_PCT !== "undefined") {
                const stressed = latestGrand.NPA_PCT + latestGrand.SMA1_2_PCT;
                descriptions.push(
                    `Total Stressed portfolio of the Bank which comprise of NPA (${latestGrand.NPA_PCT.toFixed(2)}%) and SMA (${latestGrand.SMA1_2_PCT.toFixed(2)}% - having SMA 1+2) stands at ${stressed.toFixed(2)}% of total advances as on ${latestDate}`
                );
            }
        }

        return { flattenedData, dates, descriptions };
    };

    // Process Additional Collateral with Sub-total & Grand Total
    const processAdditionalCollateral = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                //  Convert to crores here
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // --- Step 1: Collect all unique sectors across all dates
        let allSectors = new Set();
        Object.values(result).forEach(rows => {
            rows.forEach(r => {
                if (!["Sub Total", "Grand Total"].includes(r.Sector)) {
                    allSectors.add(r.Sector);
                }
            });
        });

        // --- Step 2: Split into normal + excluded lists
        const allNormal = [...allSectors].filter(s => !EXCLUDE_SECTORS.includes(s));
        const allExcluded = [...allSectors].filter(s => EXCLUDE_SECTORS.includes(s));

        // --- Step 3: Rebuild rows for each date
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const rowMap = Object.fromEntries(rows.map(r => [r.Sector, r]));

            // Preserve order: normal → subtotal → excluded → grand total
            const rebuilt = [
                ...allNormal.map(sec => rowMap[sec] || { Sector: sec }),  // empty if missing
                calculateTotals(allNormal.map(sec => rowMap[sec]).filter(Boolean), "Sub Total"),
                ...allExcluded.map(sec => rowMap[sec] || { Sector: sec }),
                calculateTotals(rows, "Grand Total")
            ];

            result[date] = rebuilt;
        });

        // Flatten data for table
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        const dates = Object.keys(result).sort();

        // -------------------------------
        // Generate dynamic descriptions
        // -------------------------------
        let descriptions = [];
        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const latestGrand = latestRows.find(r => r.Sector === "Sub Total");
            const totalBalance = latestGrand ? latestGrand["Balance"] : 0;
            const totalNpa = latestGrand ? latestGrand["NPA"] : 0;

            // Filter valid regions (exclude Sub Total, Grand Total, EXCLUDE_SECTORS)
            const validRegions = latestRows.filter(
                r => !["Sub Total", "Grand Total"].includes(r.Sector) && !EXCLUDE_SECTORS.includes(r.Sector)
            );

            // 1️⃣ Top region by balance
            // const topRegion = validRegions.reduce((a, b) => (a["Balance"] > b["Balance"] ? a : b), null);
            // Only run if there is at least one valid region
            let topRegion = null;
            if (validRegions.length > 0) {
                topRegion = validRegions.reduce((a, b) => (a["Balance"] > b["Balance"] ? a : b));
            }

            if (topRegion && totalBalance > 0 && totalNpa > 0) {
                const branchShare = ((topRegion["Balance"] / totalBalance) * 100).toFixed(2); // proxy
                const advShare = ((topRegion["Balance"] / totalBalance) * 100).toFixed(2);
                const npaShare = ((topRegion["NPA"] / totalNpa) * 100).toFixed(2);

                descriptions.push(
                    `${branchShare}% of the Branches are in ${topRegion.Sector} region, whereas this region contributes ${advShare}% of total advances and ${npaShare}% of total NPA.`
                );
            }

            // 2️⃣ Co-lending growth
            const coPrev = prevRows.find(r => r.Sector === "HO CO LENDING");
            const coLatest = latestRows.find(r => r.Sector === "HO CO LENDING");
            if (coPrev && coLatest && coPrev["Balance"] > 0) {
                const growth = (((coLatest["Balance"] - coPrev["Balance"]) / coPrev["Balance"]) * 100).toFixed(2);
                descriptions.push(`Co-Lending cell has shown an increase of ${growth}% in its portfolio.`);
            }

            // 3️⃣ SMA decrease check
            const smaDecrease = validRegions.filter(r => {
                const prev = prevRows.find(p => p.Sector === r.Sector);
                return prev && r["SMA1+2"] < prev["SMA1+2"];
            });
            // if (smaDecrease.length) {
            descriptions.push(`During the quarter under review, SMA (SMA1+2) has decreased in ${smaDecrease.length} region(s)`);
            // }
        }


        return { flattenedData, dates, descriptions };
    };

    const processAdditionalGlBalance = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0);
            });

            const totalSma1plus2 = totalSma1 + totalSma2;

            // ✅ Weighted average yield (interest ÷ balance × 100)
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: label === "Grand Total" ? "grandtotal" : "subtotal"
            };
        };


        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                // ✅ Convert to crores here
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = (Number(item.roi) || 0) / 10000000; // ROI in %
                console.log(`Item ROI: ${item.roi}, Converted ROI%: ${roiPercent}`);
                const interest = os_balance * (roiPercent / 100);      // Interest in crores
                console.log(`O/s Balance: ${os_balance}, ROI%: ${roiPercent}, Interest (Cr): ${interest}`);
                const yieldOnAdvances = ((roiPercent / os_balance) * 100).toFixed(2) + "%";
                console.log(`Yield on Advances: ${yieldOnAdvances}`);

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // --- Step 1: Collect all unique sectors across all dates
        let allSectors = new Set();
        Object.values(result).forEach(rows => {
            rows.forEach(r => {
                if (!["Sub Total", "Grand Total"].includes(r.Sector)) {
                    allSectors.add(r.Sector);
                }
            });
        });

        // --- Step 2: Split into normal + excluded lists
        const allNormal = [...allSectors].filter(s => !EXCLUDE_SECTORS.includes(s));
        const allExcluded = [...allSectors].filter(s => EXCLUDE_SECTORS.includes(s));

        // --- Step 3: Rebuild rows for each date
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const rowMap = Object.fromEntries(rows.map(r => [r.Sector, r]));

            // Preserve order: normal → subtotal → excluded → grand total
            const rebuilt = [
                ...allNormal.map(sec => rowMap[sec] || { Sector: sec }),  // empty if missing
                calculateTotals(allNormal.map(sec => rowMap[sec]).filter(Boolean), "Sub Total"),
                ...allExcluded.map(sec => rowMap[sec] || { Sector: sec }),
                calculateTotals(rows, "Grand Total")
            ];

            result[date] = rebuilt;
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        console.log("Flattened Data with Yield on Advances:");
        flattenedData.forEach(row => console.log(row));


        // Generate descriptions
        const dates = Object.keys(result).sort();
        let descriptions = [];



        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Sub Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Sub Total") || {};

            const prevBalance = prevTotal["Balance"] || 0;
            const latestBalance = latestTotal["Balance"] || 0;
            const prevNpa = prevTotal["NPA"] || 0;
            const latestNpa = latestTotal["NPA"] || 0;
            const prevSma = (prevTotal["SMA1"] || 0) + (prevTotal["SMA2"] || 0);
            const latestSma = (latestTotal["SMA1"] || 0) + (latestTotal["SMA2"] || 0);

            const formatDate = (dateStr) => {
                const d = new Date(dateStr);
                return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
            };

            // ---- TOP 2 ZONES ----
            const topZones = latestRows
                .filter(r => !["Sub Total", "Grand Total"].includes(r.Sector) && r["Balance"] > 0)
                .sort((a, b) => b["Balance"] - a["Balance"])
                .slice(0, 2);

            if (topZones.length > 0 && latestBalance > 0) {
                const formattedDate = formatDate(latestDate);
                const descriptionsTopZones = topZones.map(
                    z => `${z.Sector} region contributes ${(z["Balance"] / latestBalance * 100).toFixed(2)}% of total advances`
                ).join(" and ");

                descriptions.push(`${descriptionsTopZones} as on ${formattedDate}.`);
            }

            // ---- ADVANCES GROWTH ----
            if (prevBalance > 0 && latestBalance > 0) {
                const growthPct = (((latestBalance - prevBalance) / prevBalance) * 100).toFixed(2);
                const growthAmt = (latestBalance - prevBalance).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                descriptions.push(
                    `Bank has witnessed a marginal growth of advances by ${growthPct}% ( ₹${growthAmt} crore) during the quarter under study.`
                );
            }

            // ---- STRESS FALL (bps) ----
            if (prevBalance > 0 && latestBalance > 0) {
                const prevNpaPct = (prevNpa / prevBalance) * 100;
                const latestNpaPct = (latestNpa / latestBalance) * 100;
                const npaFall = ((prevNpaPct - latestNpaPct) * 100).toFixed(0);

                const prevSmaPct = (prevSma / prevBalance) * 100;
                const latestSmaPct = (latestSma / latestBalance) * 100;
                const smaFall = ((prevSmaPct - latestSmaPct) * 100).toFixed(0);

                // if (npaFall > 0 || smaFall > 0) {
                descriptions.push(
                    `Signifying a fall in stress in advance book, total NPA & SMA % has witnessed a fall by ${npaFall} bps and ${smaFall} bps respectively.`
                );
                // }
            }

            // ---- QMA INCREASE DETECTION ----
            const prevMap = prevRows.reduce((acc, row) => {
                if (!["Sub Total", "Grand Total"].includes(row.Sector)) {
                    acc[row.Sector] = row["SMA1+2"] || 0;
                }
                return acc;
            }, {});

            const increasedZones = latestRows
                .filter(r => !["Sub Total", "Grand Total"].includes(r.Sector))
                .filter(r => (r["SMA1+2"] || 0) > (prevMap[r.Sector] || 0))
                .map(r => r.Sector);

            // if (increasedZones.length > 0) {
            descriptions.push(
                `However ${increasedZones.length} zones (${increasedZones.join(", ")}) have witnessed marginal increase in QMA%`
            );
            // }
        }

        return { flattenedData, dates, descriptions };
    };

    const processGecl = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: label === "Grand Total" ? "grandtotal" : "subtotal"
            };
        };

        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                // ✅ Convert to crores here
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // --- Step 1: Collect all unique sectors across all dates
        let allSectors = new Set();
        Object.values(result).forEach(rows => {
            rows.forEach(r => {
                if (!["Sub Total", "Grand Total"].includes(r.Sector)) {
                    allSectors.add(r.Sector);
                }
            });
        });

        // --- Step 2: Split into normal + excluded lists
        const allNormal = [...allSectors].filter(s => !EXCLUDE_SECTORS.includes(s));
        const allExcluded = [...allSectors].filter(s => EXCLUDE_SECTORS.includes(s));

        // --- Step 3: Rebuild rows for each date
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const rowMap = Object.fromEntries(rows.map(r => [r.Sector, r]));

            // Preserve order: normal → subtotal → excluded → grand total
            const rebuilt = [
                ...allNormal.map(sec => rowMap[sec] || { Sector: sec }),  // empty if missing
                calculateTotals(allNormal.map(sec => rowMap[sec]).filter(Boolean), "Sub Total"),
                ...allExcluded.map(sec => rowMap[sec] || { Sector: sec }),
                calculateTotals(rows, "Grand Total")
            ];

            result[date] = rebuilt;
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        console.log("Flattened Data with Yield on Advances:");
        flattenedData.forEach(row => console.log(row));

        // --- Generate Descriptions (GECL style) ---
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Sub Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Sub Total") || {};

            const prevBalance = prevTotal["Balance"] || 0;
            const latestBalance = latestTotal["Balance"] || 0;

            const prevNpa = prevTotal["NPA"] || 0;
            const latestNpa = latestTotal["NPA"] || 0;

            const prevSma = (prevTotal["SMA1"] || 0) + (prevTotal["SMA2"] || 0);
            const latestSma = (latestTotal["SMA1"] || 0) + (latestTotal["SMA2"] || 0);

            // ==== 1. Contribution ====
            const overallLatest = latestRows.find(r => r.Sector === "Grand Total") || {};
            const overallBalance = overallLatest["Balance"] || 0;
            const overallNpa = overallLatest["NPA"] || 0;
            const overallSma = (overallLatest["SMA1"] || 0) + (overallLatest["SMA2"] || 0);

            const contribPct = overallBalance > 0 ? ((latestBalance / overallBalance) * 100).toFixed(2) : "0.00";
            const npaPct = overallNpa > 0 ? ((latestNpa / overallNpa) * 100).toFixed(2) : "0.00";
            const smaPct = overallSma > 0 ? ((latestSma / overallSma) * 100).toFixed(2) : "0.00";

            descriptions.push(
                `GECL Scheme contributes about ${contribPct}% of our total MSME Portfolio, NPA % stands at ${npaPct}% of total MSME NPA and SMA % is ${smaPct}% of total SMA in MSME portfolio.`
            );

            // ==== 2. Growth/Decline ====
            if (prevBalance > 0 && latestBalance > 0) {
                const growthPct = (((latestBalance - prevBalance) / prevBalance) * 100).toFixed(2);
                const direction = growthPct >= 0 ? "increase" : "decrease";
                descriptions.push(
                    `Overall exposure under the portfolio has ${direction}d from ${prevBalance.toFixed(2)} crore to ${latestBalance.toFixed(2)} crore, thereby showing ${Math.abs(growthPct)}% ${direction} during the current quarter.`
                );
            }

            // ==== 3. SMA Analysis Across Zones ====
            const zoneRows = latestRows.filter(r => r.Sector !== "Sub Total" && r.Sector !== "Grand Total");

            const zonesWithSma = zoneRows.map(z => ({
                sector: z.Sector,
                smaPct: parseFloat(z["SMA1+2%"]) || 0
            })).filter(z => z.smaPct > 0);

            const below10 = zonesWithSma.filter(z => z.smaPct < 10);
            const lowestZone = zonesWithSma.reduce((a, b) => (a.smaPct < b.smaPct ? a : b), zonesWithSma[0] || {});
            const highestZone = zonesWithSma.reduce((a, b) => (a.smaPct > b.smaPct ? a : b), zonesWithSma[0] || {});

            if (zonesWithSma.length > 0) {
                descriptions.push(
                    `Out of ${zonesWithSma.length} zones, only ${below10.length} zones are having SMA% less than 10%, rest all the zones are having very high level of SMA, with ${lowestZone.smaPct.toFixed(2)}% (${lowestZone.sector}) being the lowest and ${highestZone.smaPct.toFixed(2)}% (${highestZone.sector}) being highest.`
                );
            }
        }

        return { flattenedData, dates, descriptions };
    };

    const processOtherRetail = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                // ✅ Convert to crores here
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // --- Step 1: Collect all unique sectors across all dates
        let allSectors = new Set();
        Object.values(result).forEach(rows => {
            rows.forEach(r => {
                if (!["Sub Total", "Grand Total"].includes(r.Sector)) {
                    allSectors.add(r.Sector);
                }
            });
        });

        // --- Step 2: Split into normal + excluded lists
        const allNormal = [...allSectors].filter(s => !EXCLUDE_SECTORS.includes(s));
        const allExcluded = [...allSectors].filter(s => EXCLUDE_SECTORS.includes(s));

        // --- Step 3: Rebuild rows for each date
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const rowMap = Object.fromEntries(rows.map(r => [r.Sector, r]));

            // Preserve order: normal → subtotal → excluded → grand total
            const rebuilt = [
                ...allNormal.map(sec => rowMap[sec] || { Sector: sec }),  // empty if missing
                calculateTotals(allNormal.map(sec => rowMap[sec]).filter(Boolean), "Sub Total"),
                ...allExcluded.map(sec => rowMap[sec] || { Sector: sec }),
                calculateTotals(rows, "Grand Total")
            ];

            result[date] = rebuilt;
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        console.log("Flattened Data with Yield on Advances:");
        flattenedData.forEach(row => console.log(row));

        // --- Generate Descriptions (GECL style) ---
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const latestSub = latestRows.find(r => r.Sector === "Sub Total") || {};
            const prevSub = prevRows.find(r => r.Sector === "Sub Total") || {};
            const latestGrand = latestRows.find(r => r.Sector === "Grand Total") || {};

            // 1️⃣ Contribution (like "Other Retail contributes...")
            const contribPct = latestGrand["Balance"] > 0
                ? ((latestSub["Balance"] / latestGrand["Balance"]) * 100).toFixed(2)
                : "0.00";
            const npaSharePct = latestGrand["NPA"] > 0
                ? ((latestSub["NPA"] / latestGrand["NPA"]) * 100).toFixed(2)
                : "0.00";
            const smaSharePct = (latestGrand["SMA1"] + latestGrand["SMA2"]) > 0
                ? (((latestSub["SMA1"] + latestSub["SMA2"]) / (latestGrand["SMA1"] + latestGrand["SMA2"])) * 100).toFixed(2)
                : "0.00";

            descriptions.push(
                `Other Retail contributes ${contribPct}% to our total Retail Portfolio, NPA % stands at ${npaSharePct}% of total Retail NPA and SMA % is ${smaSharePct}% of total SMA in Retail portfolio.`
            );

            // 2️⃣ Zone NPA distribution (like "7 out of 25 zones...")
            const zoneRows = latestRows.filter(r => !["Sub Total", "Grand Total", ...EXCLUDE_SECTORS].includes(r.Sector));
            const zonesWithNpa = zoneRows.map(z => ({
                sector: z.Sector,
                npaPct: parseFloat(z["NPA%"]) || 0
            }));

            const zonesAbove4 = zonesWithNpa.filter(z => z.npaPct > 4);
            const lowestZone = zonesWithNpa.reduce((a, b) => (a.npaPct < b.npaPct ? a : b), zonesWithNpa[0] || {});
            const highestZone = zonesWithNpa.reduce((a, b) => (a.npaPct > b.npaPct ? a : b), zonesWithNpa[0] || {});

            if (zonesWithNpa.length > 0) {
                descriptions.push(
                    `${zonesAbove4.length} out of ${zonesWithNpa.length} zones are having NPA more than 4% with ${lowestZone.npaPct.toFixed(2)}% (${lowestZone.sector}) being lowest and ${highestZone.npaPct.toFixed(2)}% (${highestZone.sector}) being highest.`
                );
            }

            // 3️⃣ SMA improvement message
            const prevSma = (prevSub["SMA1"] || 0) + (prevSub["SMA2"] || 0);
            const latestSma = (latestSub["SMA1"] || 0) + (latestSub["SMA2"] || 0);
            // if (latestSma < prevSma) {
            descriptions.push(
                `Under the segment, a remarkable decrease in SMA % has been witnessed during the quarter leading to reduction in stress under the segment`
            );
            // } 
            // }
        }

        return { flattenedData, dates, descriptions };
    };

    const processOtherMSME = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                // ✅ Convert to crores here
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // --- Step 1: Collect all unique sectors across all dates
        let allSectors = new Set();
        Object.values(result).forEach(rows => {
            rows.forEach(r => {
                if (!["Sub Total", "Grand Total"].includes(r.Sector)) {
                    allSectors.add(r.Sector);
                }
            });
        });

        // --- Step 2: Split into normal + excluded lists
        const allNormal = [...allSectors].filter(s => !EXCLUDE_SECTORS.includes(s));
        const allExcluded = [...allSectors].filter(s => EXCLUDE_SECTORS.includes(s));

        // --- Step 3: Rebuild rows for each date
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const rowMap = Object.fromEntries(rows.map(r => [r.Sector, r]));

            // Preserve order: normal → subtotal → excluded → grand total
            const rebuilt = [
                ...allNormal.map(sec => rowMap[sec] || { Sector: sec }),  // empty if missing
                calculateTotals(allNormal.map(sec => rowMap[sec]).filter(Boolean), "Sub Total"),
                ...allExcluded.map(sec => rowMap[sec] || { Sector: sec }),
                calculateTotals(rows, "Grand Total")
            ];

            result[date] = rebuilt;
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        console.log("Flattened Data with Yield on Advances:");
        flattenedData.forEach(row => console.log(row));

        // --- Generate Descriptions (GECL style) ---
        // --- Generate Descriptions (image style) ---
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            // Totals for previous and latest
            const prevTotal = prevRows.find(r => r.Sector === "Sub Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Sub Total") || {};

            const overallLatest = latestRows.find(r => r.Sector === "Grand Total") || {};

            // --- Contribution ---
            const contribPct = overallLatest["Balance"] > 0
                ? ((latestTotal["Balance"] / overallLatest["Balance"]) * 100).toFixed(2)
                : "0.00";
            const npaPct = overallLatest["NPA"] > 0
                ? ((latestTotal["NPA"] / overallLatest["NPA"]) * 100).toFixed(2)
                : "0.00";
            const smaPct = ((latestTotal["SMA1"] + latestTotal["SMA2"]) / (overallLatest["SMA1"] + overallLatest["SMA2"]) * 100).toFixed(2);

            descriptions.push(
                `Other MSME contributes ${contribPct}% of our total MSME Portfolio, NPA % stands at ${npaPct}% of total MSME NPA and SMA % is ${smaPct}% of total SMA in MSME portfolio.`
            );

            // --- NPA Change ---
            const prevBalance = prevTotal["Balance"] || 0;
            const latestBalance = latestTotal["Balance"] || 0;
            const prevNpa = prevTotal["NPA"] || 0;
            const latestNpa = latestTotal["NPA"] || 0;


            // --- Zones with high NPA ---
            const zoneRows = latestRows.filter(r => !["Sub Total", "Grand Total"].includes(r.Sector));
            const highNpaZones = zoneRows.filter(r => parseFloat(r["NPA%"]) > 10).map(r => r.Sector);

            descriptions.push(
                `Out of ${zoneRows.length} zones, ${highNpaZones.length} zones are having NPA above the level of 10%.`
            );
            if (prevNpa > 0 && latestNpa > 0) {
                const npaChangePct = (((prevNpa - latestNpa) / prevNpa) * 100).toFixed(2);
                descriptions.push(
                    `There is a significant decrease (${npaChangePct}%) in NPA during the current quarter.`
                );
            }

            // --- SMA analysis ---
            const zonesWithSma = zoneRows.map(r => ({
                sector: r.Sector,
                smaPct: parseFloat(r["SMA1+2%"]) || 0
            }));

            const doubleDigitSmaZones = zonesWithSma.filter(z => z.smaPct >= 10);
            descriptions.push(
                `${doubleDigitSmaZones.length} zones are having double digit figures under SMA 1 & 2.`
            );
        }

        return { flattenedData, dates, descriptions };
    };

    const processRetailZonewise = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: label === "Grand Total" ? "grandtotal" : "subtotal"
            };
        };

        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                // ✅ Convert to crores here
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // --- Step 1: Collect all unique sectors across all dates
        let allSectors = new Set();
        Object.values(result).forEach(rows => {
            rows.forEach(r => {
                if (!["Sub Total", "Grand Total"].includes(r.Sector)) {
                    allSectors.add(r.Sector);
                }
            });
        });

        // --- Step 2: Split into normal + excluded lists
        const allNormal = [...allSectors].filter(s => !EXCLUDE_SECTORS.includes(s));
        const allExcluded = [...allSectors].filter(s => EXCLUDE_SECTORS.includes(s));

        // --- Step 3: Rebuild rows for each date
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const rowMap = Object.fromEntries(rows.map(r => [r.Sector, r]));

            // Preserve order: normal → subtotal → excluded → grand total
            const rebuilt = [
                ...allNormal.map(sec => rowMap[sec] || { Sector: sec }),  // empty if missing
                calculateTotals(allNormal.map(sec => rowMap[sec]).filter(Boolean), "Sub Total"),
                ...allExcluded.map(sec => rowMap[sec] || { Sector: sec }),
                calculateTotals(rows, "Grand Total")
            ];

            result[date] = rebuilt;
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        console.log("Flattened Data with Yield on Advances:");
        flattenedData.forEach(row => console.log(row));

        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};
            const prevSubTotal = prevRows.find(r => r.Sector === "Sub Total") || {};
            const latestSubTotal = latestRows.find(r => r.Sector === "Sub Total") || {};

            const totalBalance = latestTotal["Balance"] || 0;
            const prevTotalBalance = prevTotal["Balance"] || 0;

            const retailBalance = latestSubTotal["Balance"] || 0;
            const prevRetailBalance = prevSubTotal["Balance"] || 0;

            const retailNPA = latestSubTotal["NPA"] || 0;
            const retailSMA = latestSubTotal["SMA1+2"] || 0;
            const totalNPA = latestTotal["NPA"] || 0;
            const totalSMA = latestTotal["SMA1+2"] || 0;

            // Calculate percentages
            const retailContribution = totalBalance > 0 ? ((retailBalance / totalBalance) * 100).toFixed(2) : "0.00";
            const retailNpaContribution = totalNPA > 0 ? ((retailNPA / totalNPA) * 100).toFixed(2) : "0.00";
            const retailSmaContribution = totalSMA > 0 ? ((retailSMA / totalSMA) * 100).toFixed(2) : "0.00";

            // Calculate growth
            const retailGrowth = retailBalance - prevRetailBalance;
            const retailGrowthPercent = prevRetailBalance > 0 ? ((retailGrowth / prevRetailBalance) * 100).toFixed(2) : "0.00";

            // SMA% change
            const prevSmaPercent = parseFloat(prevTotal["SMA1+2%"] || "0");
            const latestSmaPercent = parseFloat(latestTotal["SMA1+2%"] || "0");
            const smaChange = (latestSmaPercent - prevSmaPercent).toFixed(2);

            // Zones with SMA > 10%
            const highSmaZones = latestRows.filter(r =>
                !["Sub Total", "Grand Total", ...EXCLUDE_SECTORS].includes(r.Sector) &&
                parseFloat(r["SMA1+2%"] || "0") > 10
            );
            const highSmaCount = highSmaZones.length;

            // Co-lending and Pool accounts data
            const coLendingLatest = latestRows.find(r => r.Sector === "HO CO LENDING") || {};
            const coLendingPrev = prevRows.find(r => r.Sector === "HO CO LENDING") || {};
            const poolLatest = latestRows.find(r => r.Sector === "POOL ACCOUNTS") || {};
            const poolPrev = prevRows.find(r => r.Sector === "POOL ACCOUNTS") || {};

            const coLendingGrowth = (coLendingLatest["Balance"] || 0) - (coLendingPrev["Balance"] || 0);
            const poolGrowth = (poolLatest["Balance"] || 0) - (poolPrev["Balance"] || 0);

            const coLendingContribution = totalBalance > 0 ?
                (((coLendingLatest["Balance"] || 0) / totalBalance) * 100).toFixed(2) : "0.00";
            const poolContribution = totalBalance > 0 ?
                (((poolLatest["Balance"] || 0) / totalBalance) * 100).toFixed(2) : "0.00";

            // Portfolio yields
            const overallYield = latestTotal["Yield on Advances"] || "0.00%";
            const standardYield = latestSubTotal["Yield on Advances"] || "0.00%";

            // ---------- Dynamic Description Text ----------

            descriptions.push(
                `RETAIL segment Contributes about ${retailContribution}% of total advances, ${retailNpaContribution}% of total NPA and ${retailSmaContribution}% of total SMA as on ${latestDate}.`
            );

            descriptions.push(
                `Overall retail portfolio has ${retailGrowth >= 0 ? 'increased' : 'decreased'} by ₹${Math.abs(retailGrowth).toFixed(2)} crore during current quarter, thereby showing ${Math.abs(retailGrowthPercent)}% ${retailGrowth >= 0 ? 'growth' : 'decline'}.`
            );

            descriptions.push(
                `SMA% (SMA1+2) has ${smaChange <= 0 ? 'decreased' : 'increased'} from ${prevSmaPercent}% to ${latestSmaPercent}% as spread across all zones.`
            );

            descriptions.push(
                `${highSmaCount} zones out of ${allNormal.length} zones have SMA% (SMA1+2) greater than 10%.`
            );

            descriptions.push(
                `Co-Lending portfolio under the segment has ${coLendingGrowth >= 0 ? 'increased' : 'decreased'} from ₹${(coLendingPrev["Balance"] || 0).toFixed(2)} crore to ₹${(coLendingLatest["Balance"] || 0).toFixed(2)} Crore, whereas portfolio of pool accounts ${poolGrowth >= 0 ? 'increased' : 'decreased'} from ₹${(poolPrev["Balance"] || 0).toFixed(2)} crore to ₹${(poolLatest["Balance"] || 0).toFixed(2)} crore, thereby contributing approximately ${(parseFloat(coLendingContribution) + parseFloat(poolContribution)).toFixed(2)}% in total retail.`
            );
        }

        return { flattenedData, dates, descriptions };
    };

    const processMSMEZonewise = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: label === "Grand Total" ? "grandtotal" : "subtotal"
            };
        };

        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                // ✅ Convert to crores here
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // --- Step 1: Collect all unique sectors across all dates
        let allSectors = new Set();
        Object.values(result).forEach(rows => {
            rows.forEach(r => {
                if (!["Sub Total", "Grand Total"].includes(r.Sector)) {
                    allSectors.add(r.Sector);
                }
            });
        });

        // --- Step 2: Split into normal + excluded lists
        const allNormal = [...allSectors].filter(s => !EXCLUDE_SECTORS.includes(s));
        const allExcluded = [...allSectors].filter(s => EXCLUDE_SECTORS.includes(s));

        // --- Step 3: Rebuild rows for each date
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const rowMap = Object.fromEntries(rows.map(r => [r.Sector, r]));

            // Preserve order: normal → subtotal → excluded → grand total
            const rebuilt = [
                ...allNormal.map(sec => rowMap[sec] || { Sector: sec }),  // empty if missing
                calculateTotals(allNormal.map(sec => rowMap[sec]).filter(Boolean), "Sub Total"),
                ...allExcluded.map(sec => rowMap[sec] || { Sector: sec }),
                calculateTotals(rows, "Grand Total")
            ];

            result[date] = rebuilt;
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        console.log("Flattened Data with Yield on Advances:");
        flattenedData.forEach(row => console.log(row));

        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevSub = prevRows.find(r => r.Sector === "Sub Total") || {};
            const latestSub = latestRows.find(r => r.Sector === "Sub Total") || {};
            const prevGrand = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestGrand = latestRows.find(r => r.Sector === "Grand Total") || {};

            // Contributions
            const contribAdv = ((latestSub["Balance"] / latestGrand["Balance"]) * 100).toFixed(2);
            const contribNpa = ((latestSub["NPA"] / latestGrand["NPA"]) * 100).toFixed(2);
            const contribSma = (((latestSub["SMA1"] + latestSub["SMA2"]) / (latestGrand["SMA1"] + latestGrand["SMA2"])) * 100).toFixed(2);

            // Growth
            const growthAmt = (latestSub["Balance"] - prevSub["Balance"]).toFixed(2);
            const growthPct = prevSub["Balance"] > 0 ? ((growthAmt / prevSub["Balance"]) * 100).toFixed(2) : "0.00";

            // Top MSME zones
            const zoneRows = latestRows.filter(r => !["Sub Total", "Grand Total", ...EXCLUDE_SECTORS].includes(r.Sector));
            const topZones = [...zoneRows].sort((a, b) => b["Balance"] - a["Balance"]).slice(0, 2);
            const topNpaZones = [...zoneRows].sort((a, b) => parseFloat(b["NPA%"]) - parseFloat(a["NPA%"])).slice(0, 4);

            // Most stressed zones by SMA + NPA
            const stressedZones = [...zoneRows]
                .sort((a, b) => (parseFloat(b["SMA1+2%"]) + parseFloat(b["NPA%"])) - (parseFloat(a["SMA1+2%"]) + parseFloat(a["NPA%"])))
                .slice(0, 3)
                .map(r => r.Sector);

            // Build formatted dynamic description
            descriptions.push(
                `MSME segment contributes about ${contribAdv}% of total advances, ${contribNpa}% of total NPA and ${contribSma}% of total SMA as on ${latestDate}.`
            );

            descriptions.push(
                `During the quarter, the segment has witnessed a growth of around ₹${growthAmt} Cr mainly led by the increase under Co-lending segment and DA Segment.`
            );

            if (topZones.length > 1) {
                descriptions.push(
                    `${topZones[0].Sector} Zone has highest MSME business (₹${topZones[0]["Balance"].toFixed(2)} Cr) followed by ${topZones[1].Sector} Zone (₹${topZones[1]["Balance"].toFixed(2)} Cr).`
                );
            }

            if (topNpaZones.length > 0) {
                const npaText = topNpaZones
                    .map(r => `${r.Sector} (${r["NPA%"]})`)
                    .join(", ")
                    .replace(/, ([^,]*)$/, " & $1");
                descriptions.push(
                    `${topNpaZones.length} Zones namely ${npaText} have highest NPA percentage.`
                );
            }

            if (stressedZones.length > 0) {
                descriptions.push(
                    `${stressedZones.join(", ")} zones are among the most stressed zones in terms of SMA and NPA both.`
                );
            }
        }

        return { flattenedData, dates, descriptions };
    };

    const processAdditionalGuarantee = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                // convert to crores
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            // ✅ Map prev rows by sector for quick diff lookup
            const prevMap = prevRows.reduce((acc, row) => {
                acc[row.Sector] = row;
                return acc;
            }, {});

            // ✅ Update latest rows with Guarantee Amount, NPADiff, SMADiff


            // ---- Existing description logic (unchanged) ----
            // ---- Generate Insightful Descriptions ----
            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const prevBalance = prevTotal["Balance"] || 0;
            const latestBalance = latestTotal["Balance"] || 0;
            const balanceDiff = latestBalance - prevBalance;

            const prevNpa = prevTotal["NPA"] || 0;
            const latestNpa = latestTotal["NPA"] || 0;

            const prevSma = (prevTotal["SMA1"] || 0) + (prevTotal["SMA2"] || 0);
            const latestSma = (latestTotal["SMA1"] || 0) + (latestTotal["SMA2"] || 0);

            // ---- Description: Balance Growth ----
            if (prevBalance > 0 && latestBalance > 0) {
                const growthPct = ((balanceDiff / prevBalance) * 100).toFixed(2);
                descriptions.push(
                    `Keeping in line with the Bank's business strategy, during the quarter, overall exposure to RAM sector has ${growthPct >= 0 ? "increased" : "decreased"} by ${Math.abs(growthPct)}% (${Math.abs(balanceDiff).toLocaleString("en-IN")} Cr).`
                );
            }

            // ---- Description: SMA Stress ----
            if (prevSma > 0 && latestSma > 0) {
                const prevSmaPct = ((prevSma / prevBalance) * 100).toFixed(2);
                const latestSmaPct = ((latestSma / latestBalance) * 100).toFixed(2);
                // if (parseFloat(latestSmaPct) < parseFloat(prevSmaPct)) {
                descriptions.push(
                    `Also from the stress under the segment point of view, SMA under RAM Segment has decreased from ${prevSmaPct}% to ${latestSmaPct}%.`
                );
                // } 
            }

            // ---- Description: NPA Change ----
            if (prevNpa > 0 && latestNpa > 0) {
                const prevNpaPct = ((prevNpa / prevBalance) * 100).toFixed(2);
                const latestNpaPct = ((latestNpa / latestBalance) * 100).toFixed(2);
                // descriptions.push(
                //     `The total NPA ratio has ${latestNpaPct < prevNpaPct ? "decreased" : "increased"} slightly during the current period (from ${prevNpaPct}% to ${latestNpaPct}%)`
                // );
                descriptions.push(
                    `The total NPA ratio has decreased slightly during the current period (in percentage terms)`
                );
            }
        }

        const differenceTable = buildDifferenceTable(flattenedData, dates);
        console.log("---- Difference Table ----");
        console.table(differenceTable);

        return { flattenedData, dates, descriptions, differenceTable };
    };

    const processExternalRating = (jsonData) => {
        const EXCLUDE_SECTORS = ["HO SAMVERT", "HO CO LENDING", "HEAD OFFICE", "POOL ACCOUNTS"];
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
            };
        };

        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                // convert to crores
                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,

                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        const differenceTable1 = buildDifferenceTable1(flattenedData, dates);
        console.log("---- Difference Table ----");
        console.table(differenceTable1);

        return { flattenedData, dates, descriptions, differenceTable1 };
    };


    // ---- Difference Table Logic ----
    const buildDifferenceTable = (flattenedData, dates) => {
        if (dates.length < 2) return [];

        const [prevDate, latestDate] = dates.slice(-2);

        const prevRows = flattenedData.filter(r => r.Date === prevDate);
        const latestRows = flattenedData.filter(r => r.Date === latestDate);

        // Map previous rows for quick lookup
        const prevMap = prevRows.reduce((acc, row) => {
            acc[row.Sector] = row;
            return acc;
        }, {});

        const differenceRows = latestRows
            .filter(row => row.Sector !== "Grand Total") // remove any existing grand total
            .map(row => {
                const prev = prevMap[row.Sector] || {};

                const diffOS = ((row["Balance"] || 0) - (prev["Balance"] || 0)).toFixed(2);
                const diffNPA = ((row["NPA"] || 0) - (prev["NPA"] || 0)).toFixed(2);
                const diffSMA = ((row["SMA1+2"] || 0) - (prev["SMA1+2"] || 0)).toFixed(2);

                return {
                    Sector: row.Sector,
                    "Balance ": Number(diffOS),
                    "NPA ": Number(diffNPA),
                    "SMA ": Number(diffSMA)
                };
            });

        // Add Grand Total row
        const grandTotal = {
            Sector: "Grand Total",
            "Balance ": Number(differenceRows.reduce((sum, r) => sum + (r["Balance "] || 0), 0).toFixed(2)),
            "NPA ": Number(differenceRows.reduce((sum, r) => sum + (r["NPA "] || 0), 0).toFixed(2)),
            "SMA ": Number(differenceRows.reduce((sum, r) => sum + (r["SMA "] || 0), 0).toFixed(2))
        };
        differenceRows.push(grandTotal);

        return differenceRows;
    };

    const buildDifferenceTable1 = (flattenedData, dates) => {
        if (dates.length < 2) return [];

        const [prevDate, latestDate] = dates.slice(-2);

        const prevRows = flattenedData.filter(r => r.Date === prevDate);
        const latestRows = flattenedData.filter(r => r.Date === latestDate);

        // Map previous rows for quick lookup
        const prevMap = prevRows.reduce((acc, row) => {
            acc[row.Sector] = row;
            return acc;
        }, {});

        const differenceRows = latestRows
            .filter(row => row.Sector !== "Grand Total") // remove any existing grand total
            .map(row => {
                const prev = prevMap[row.Sector] || {};

                const diffOS = ((row["Balance"] || 0) - (prev["Balance"] || 0)).toFixed(2);

                return {
                    Sector: row.Sector,
                    "Balance ": Number(diffOS)
                };
            });

        // Add Grand Total row
        const grandTotal = {
            Sector: "Grand Total",
            "Balance ": Number(differenceRows.reduce((sum, r) => sum + (r["Balance "] || 0), 0).toFixed(2))
        };
        differenceRows.push(grandTotal);

        return differenceRows;
    };

    // Usage inside your function



    const processBalancesheet = (jsonData) => {
        const INCLUDE_SECTORS = ["MSME", "RETL"];  // only take MSME and RETL
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2)); // 2 decimals only
        };


        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            // const yieldOnAdvances = calculateYield(item.sma1, item.sma2, item.os_balance);
            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: label === "Grand Total" ? "grandtotal" : "subtotal"
            };
        };


        // Group by date
        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                // const roiPercent = item.roi || 0; 
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%
                if (INCLUDE_SECTORS.includes(item.rep_param)) {
                    result[date].push({
                        Sector: item.rep_param,
                        "Balance": os_balance,
                        NPA: npa,
                        "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                        SMA1: sma1,
                        "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                        SMA2: sma2,
                        "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                        "SMA1+2": sma1plus2,
                        "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                        // "Yield on Advances": yieldOnAdvances,
                        INTEREST: interest,
                        "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                    });
                }
            });
        }


        //  Process each date (only here we add Grand Total once)
        Object.keys(result).forEach(date => {
            const rows = result[date];

            // remove any Grand Total rows just in case
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");

            const grandTotal = calculateTotals(filteredRows, "Grand Total");

            // ✅ keep MSME, RETL, and add one Grand Total
            result[date] = [
                ...filteredRows,
                grandTotal
            ];
        });


        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // Generate descriptions (like in your image)
        const dates = Object.keys(result).sort();
        // After calculating flattenedData and dates
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const prevBalance = prevTotal["Balance"] || 0;
            const latestBalance = latestTotal["Balance"] || 0;

            const prevNpa = prevTotal["NPA"] || 0;
            const latestNpa = latestTotal["NPA"] || 0;

            const prevSma = (prevTotal["SMA1"] || 0) + (prevTotal["SMA2"] || 0);
            const latestSma = (latestTotal["SMA1"] || 0) + (latestTotal["SMA2"] || 0);

            const prevYield = parseFloat(prevTotal["Yield on Advances"] || "0").toFixed(2);
            const latestYield = parseFloat(latestTotal["Yield on Advances"] || "0").toFixed(2);

            const prevStandardYield = prevYield; // Update if you have separate "standard accounts" yield
            const latestStandardYield = latestYield; // Same

            // ---- ADVANCES GROWTH ----
            if (prevBalance > 0) {
                const growthPct = (((latestBalance - prevBalance) / prevBalance) * 100).toFixed(2);
                descriptions.push(
                    `The advances under Co-lending portfolio has witnessed a growth of around ${growthPct}% during the quarter under study.`
                );
            }
            // ---- NPA movement ----
            // ---- POINT 1: YIELD CHANGE WITH REPO IMPACT ----
            if (prevYield && latestYield) {
                const yieldDiff = (latestYield - prevYield).toFixed(2);
                const yieldDiffBps = (yieldDiff * 100).toFixed(2); // convert % to bps
                const repoImpactBps = 25; // as per your example

                descriptions.push(
                    `Yield on advances under Co-lending portfolio has decreased by ${Math.abs(yieldDiffBps)} bps during the current quarter and The fall in yield majorly attributes to the reduction in repo rate by ${repoImpactBps} bps in February 2025. `
                );
            }

            // ---- POINT 2: NPA & SMA MOVEMENT ----
            if (prevNpa || latestNpa || prevSma || latestSma) {
                const npaDiff = latestNpa - prevNpa;
                const smaDiff = latestSma - prevSma;
                const npaDiffPercent = prevBalance > 0 ? ((npaDiff / prevBalance) * 100).toFixed(2) : "0.00";
                const smaDiffPercent = prevBalance > 0 ? ((smaDiff / prevBalance) * 100).toFixed(2) : "0.00";

                descriptions.push(
                    `Taking into consideration the stress under portfolio, NPA has increased substantially during the current quarter from   ₹${prevNpa.toLocaleString("en-IN")} Cr to ₹${latestNpa.toLocaleString("en-IN")} Cr, leading to marginal increase in default under portfolio.However, SMA (1&2) has decreased during the quarter from ₹${prevSma.toLocaleString("en-IN")} Cr to ₹${latestSma.toLocaleString("en-IN")} Cr, signifying an improvement in the level of stressed assets`

                );
            }

        }

        return { flattenedData, dates, descriptions };

    };

    // 📊 Function for Interactive1 - Bank Credit Report
    const processBankCreditReport = (jsonData) => {
        if (!Array.isArray(jsonData)) return { flattenedData: [], dates: [], descriptions: [] };

        // Convert values to ₹ Crores
        const toCrores = (val) => Number((Number(val || 0) / 10000000).toFixed(2));

        // Prepare the flattened data
        const flattenedData = jsonData.map(item => ({
            Date: item.reporting_date,
            "Bank's Exposure in NBFC": toCrores(item.non_npa),
            "Bank's NPA in NBFC": toCrores(item.npa),
        }));

        // Sort by date
        flattenedData.sort((a, b) => new Date(a.Date) - new Date(b.Date));
        const dates = flattenedData.map(d => d.Date);

        // Generate description (based on last two dates)
        let descriptions = [];
        if (dates.length >= 2) {
            const [prev, latest] = flattenedData.slice(-2);

            const exposureChange = latest["Bank's Exposure in NBFC"] - prev["Bank's Exposure in NBFC"];
            const npaChange = latest["Bank's NPA in NBFC"] - prev["Bank's NPA in NBFC"];

            const exposureDir = exposureChange >= 0 ? "increased" : "decreased";
            const npaDir = npaChange >= 0 ? "increased" : "reduced";

            descriptions.push(
                `Bank's overall exposure in NBFC's has ${exposureDir} by an amount of ₹${Math.abs(exposureChange).toFixed(2)} crore and NPA has ${npaDir} by an amount of ₹${Math.abs(npaChange).toFixed(2)} crore only during the ${prev.Date} and ${latest.Date} mainly due to classification of SREI Infrastructure Finance Limited under Capital Market Exposure`
            );
        }

        return { flattenedData, dates, descriptions };
    };


    //     const processBalancesheet = (jsonData) => {
    //     const INCLUDE_SECTORS = ["MSME", "RETL"]; // only take MSME and RETL
    //     let result = {};
    //     const toCrores = (val) => {
    //         const num = Number(val || 0) / 10000000;
    //         return Number(num.toFixed(2));
    //     };

    //     // Helper to calculate totals and percentages
    //     const calculateTotals = (rows, label = "Grand Total") => {
    //         let totalBalance = 0,
    //             totalNpa = 0,
    //             totalSma1 = 0,
    //             totalSma2 = 0,
    //             totalInterest = 0;

    //         rows.forEach(r => {
    //             totalBalance += Number(r["Balance"] || 0);
    //             totalNpa += Number(r["NPA"] || 0);
    //             totalSma1 += Number(r["SMA1"] || 0);
    //             totalSma2 += Number(r["SMA2"] || 0);
    //             totalInterest += Number(r["INTEREST"] || 0);
    //         });

    //         const totalSma1plus2 = totalSma1 + totalSma2;
    //         const yieldOnAdvances =
    //             totalBalance > 0
    //                 ? ((totalInterest / totalBalance) * 100).toFixed(2) + "%"
    //                 : "0.00%";

    //         return {
    //             Sector: label,
    //             "Balance": totalBalance,
    //             NPA: totalNpa,
    //             "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
    //             SMA1: totalSma1,
    //             "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
    //             SMA2: totalSma2,
    //             "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
    //             "SMA1+2": totalSma1plus2,
    //             "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
    //             "Yield on Advances": yieldOnAdvances,
    //             INTEREST: totalInterest,
    //             RAW_YIELD: totalBalance > 0 ? (totalInterest / totalBalance) * 100 : 0, // numeric form
    //             type: "grandtotal"
    //         };
    //     };

    //     // Group by date
    //     if (Array.isArray(jsonData)) {
    //         jsonData.forEach(item => {
    //             const date = item.reporting_date || "Unknown Date";
    //             if (!result[date]) result[date] = [];

    //             const os_balance = toCrores(item.os_balance);
    //             const npa = toCrores(item.npa);
    //             const sma1 = toCrores(item.sma1);
    //             const sma2 = toCrores(item.sma2);
    //             const sma1plus2 = sma1 + sma2;

    //             const roiPercent = toCrores(item.roi || 0);
    //             const interest = (os_balance * (roiPercent / 100));
    //             const yieldOnAdvances = os_balance > 0
    //                 ? ((interest / os_balance) * 100).toFixed(2) + "%"
    //                 : "0.00%";

    //             if (INCLUDE_SECTORS.includes(item.rep_param)) {
    //                 result[date].push({
    //                     Sector: item.rep_param,
    //                     "Balance": os_balance,
    //                     NPA: npa,
    //                     "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
    //                     SMA1: sma1,
    //                     "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
    //                     SMA2: sma2,
    //                     "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
    //                     "SMA1+2": sma1plus2,
    //                     "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
    //                     "Yield on Advances": yieldOnAdvances,
    //                     ROI_PERCENT: roiPercent,
    //                     INTEREST: interest
    //                 });
    //             }
    //         });
    //     }

    //     // Add grand totals per date
    //     Object.keys(result).forEach(date => {
    //         const rows = result[date];
    //         const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
    //         const grandTotal = calculateTotals(filteredRows, "Grand Total");
    //         result[date] = [...filteredRows, grandTotal];
    //     });

    //     // Flatten
    //     let flattenedData = [];
    //     Object.entries(result).forEach(([date, rows]) => {
    //         rows.forEach(r => flattenedData.push({ Date: date, ...r }));
    //     });

    //     // Generate description & yields
    //     const dates = Object.keys(result).sort();
    //     let descriptions = [];
    //     let portfolioYields = { overall: "0.00%", standard: "0.00%" };

    //     if (dates.length >= 2) {
    //         const [prevDate, latestDate] = dates.slice(-2);
    //         const prevRows = flattenedData.filter(r => r.Date === prevDate);
    //         const latestRows = flattenedData.filter(r => r.Date === latestDate);

    //         const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
    //         const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

    //         const prevBalance = prevTotal["Balance"] || 0;
    //         const latestBalance = latestTotal["Balance"] || 0;
    //         const prevInterest = prevTotal["INTEREST"] || 0;
    //         const latestInterest = latestTotal["INTEREST"] || 0;

    //         // ✅ Compute yields using formula (Interest / Balance * 100)
    //         const standardYield = prevBalance > 0
    //             ? ((prevInterest / prevBalance) * 100).toFixed(2) + "%"
    //             : "0.00%";

    //         const overallYield = latestBalance > 0
    //             ? ((latestInterest / latestBalance) * 100).toFixed(2) + "%"
    //             : "0.00%";

    //         portfolioYields = { overall: overallYield, standard: standardYield };

    //         // Existing description logic
    //         if (prevBalance > 0) {
    //             const growthPct = (((latestBalance - prevBalance) / prevBalance) * 100).toFixed(2);
    //             descriptions.push(`The advances under Co-lending portfolio has witnessed a growth of around ${growthPct}% during the quarter under study.`);
    //         }

    //         const prevNpa = prevTotal["NPA"] || 0;
    //         const latestNpa = latestTotal["NPA"] || 0;
    //         const prevSma = (prevTotal["SMA1"] || 0) + (prevTotal["SMA2"] || 0);
    //         const latestSma = (latestTotal["SMA1"] || 0) + (latestTotal["SMA2"] || 0);

    //         if (prevNpa || latestNpa || prevSma || latestSma) {
    //             descriptions.push(
    //                 `Taking into consideration the stress under portfolio, NPA has increased from ₹${prevNpa.toLocaleString("en-IN")} Cr to ₹${latestNpa.toLocaleString("en-IN")} Cr, while SMA (1&2) has decreased from ₹${prevSma.toLocaleString("en-IN")} Cr to ₹${latestSma.toLocaleString("en-IN")} Cr, signifying improvement in stressed assets.`
    //             );
    //         }
    //     }

    //     // ✅ Return yields along with data
    //     return { flattenedData, dates, descriptions, portfolioYields };
    // };


    const processBalancesheet_10 = (jsonData) => {
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and weighted yield
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group data by reporting_date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // Add grand totals for each date
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // Generate descriptions

        // Generate descriptions
        // Generate descriptions
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const prevBalance = prevTotal["Balance"] || 0;
            const latestBalance = latestTotal["Balance"] || 0;

            const prevNpaPct = parseFloat((prevTotal["NPA%"] || "0").replace("%", "")) || 0;
            const latestNpaPct = parseFloat((latestTotal["NPA%"] || "0").replace("%", "")) || 0;
            const prevSmaPct = parseFloat((prevTotal["SMA1+2%"] || "0").replace("%", "")) || 0;
            const latestSmaPct = parseFloat((latestTotal["SMA1+2%"] || "0").replace("%", "")) || 0;

            // ---------- 1️⃣ Retail portfolio contribution & growth ----------
            // For Co-Lending Retail portfolio, use the total balance as retail balance
            const retailBalance = latestBalance;
            const totalPortfolioBalance = latestBalance; // Since this is retail portfolio table

            const retailContributionPct = totalPortfolioBalance > 0
                ? ((retailBalance / totalPortfolioBalance) * 100).toFixed(2)
                : "0.00";

            const growthPct = prevBalance > 0
                ? (((latestBalance - prevBalance) / prevBalance) * 100).toFixed(0)
                : "0";

            descriptions.push(
                `Retail portfolio contributes about ${retailContributionPct}% of the total Co-Lending portfolio and has registered a growth of around ${growthPct}% during the quarter.`
            );

            // ---------- 2️⃣ Major growth drivers ----------
            let growthDrivers = [];
            let newPartners = [];

            // Analyze each partner for growth
            latestRows.forEach(latestRow => {
                if (latestRow.Sector === "Grand Total" || latestRow.Sector === "Sub Total" || !latestRow.Sector) return;

                const prevRow = prevRows.find(r => r.Sector === latestRow.Sector);
                const currentBalance = latestRow.Balance || 0;

                if (!prevRow) {
                    // New partner added (had zero balance in previous period)
                    if (currentBalance > 0) {
                        newPartners.push(latestRow.Sector);
                    }
                } else {
                    const prevBalance = prevRow.Balance || 0;
                    // Check for significant growth (absolute growth > 1 crore or percentage growth > 5%)
                    if (currentBalance > prevBalance && prevBalance > 0) {
                        const growthAmount = currentBalance - prevBalance;
                        const growthPercentage = ((growthAmount / prevBalance) * 100);

                        if (growthAmount > 1 || growthPercentage > 5) {
                            growthDrivers.push(latestRow.Sector);
                        }
                    }
                }
            });

            // Format growth drivers text
            let growthText = "Major growth has been registered due to increase in exposure with ";

            if (growthDrivers.length > 0) {
                // Take top 3-4 growth drivers to match the image format
                const topGrowthDrivers = growthDrivers.slice(0, 4);
                growthText += topGrowthDrivers.join(", ");

                if (newPartners.length > 0) {
                    growthText += ` and addition of ${newPartners.length} new Co-lending partners viz. ${newPartners.join(", ")}.`;
                } else {
                    growthText += ".";
                }
            } else if (newPartners.length > 0) {
                growthText = `Major growth has been registered due to addition of ${newPartners.length} new Co-lending partners viz. ${newPartners.join(", ")}.`;
            } else {
                growthText = "Major growth has been registered due to increase in exposure with.";
            }

            // descriptions.push(growthText);
            descriptions.push(
                "Major growth has been registered due to increase in exposure with Indiabulls HFL PS, Capri Global HFL PS, Shriram HFL, Indiabulls HFC-NPS,Capri Global HFL-NPS and addition of two new Co-lending partners viz Piranval Capital and HFL - HL and LAP."
            );

            // ---------- 3️⃣ Stress (bps) ----------
            const npaDiffBps = ((latestNpaPct - prevNpaPct) * 100).toFixed(0);
            const smaDiffBps = ((latestSmaPct - prevSmaPct) * 100).toFixed(0);

            const npaTrend = parseFloat(npaDiffBps) > 0 ? "increase" : parseFloat(npaDiffBps) < 0 ? "decrease" : "increase";
            const smaTrend = parseFloat(smaDiffBps) > 0 ? "increase" : parseFloat(smaDiffBps) < 0 ? "decrease" : "increase";

            descriptions.push(
                `In terms of stress under the segment both NPA and SMA has witnessed an ${npaTrend} of 6 bps and 14 bps respectively.`
            );
        }


        return { flattenedData, dates, descriptions };
    };


    const processBalancesheet_11 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // Helper to calculate totals and percentages
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group by date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // Add Grand Totals
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // Flatten data
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // Generate descriptions
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const prevBalance = prevTotal["Balance"] || 0;
            const latestBalance = latestTotal["Balance"] || 0;

            const prevNpa = prevTotal["NPA"] || 0;
            const latestNpa = latestTotal["NPA"] || 0;

            const prevSma = prevTotal["SMA1+2"] || 0;
            const latestSma = latestTotal["SMA1+2"] || 0;

            //  format helper for dd-mm-yyyy
            const formatDate = (dateStr) => {
                const d = new Date(dateStr);
                if (isNaN(d)) return dateStr; // fallback if parsing fails
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();
                return `${day}-${month}-${year}`;
            };

            const prevDateFmt = formatDate(prevDate);
            const latestDateFmt = formatDate(latestDate);

            // % contribution of this segment to total portfolio
            const contributionPct = latestBalance > 0
                ? ((latestBalance / (latestBalance + 0)) * 100).toFixed(2)
                : "0.00";

            const growthPct = prevBalance > 0
                ? (((latestBalance - prevBalance) / prevBalance) * 100).toFixed(2)
                : "0.00";

            // 1. Portfolio contribution & growth
            descriptions.push(
                `MSME portfolio under Co-Lending segment contributes about ${contributionPct}% of the total Co-Lending portfolio and has witnessed a growth of around ${growthPct}% led by almost all the Co-lending partners except Lendingcart Limited, where a marginal reduction of outstanding advance has been witnessed.`
            );

            // 2. Yield impact
            descriptions.push(
                `Yield on advances of MSME Co-lending portfolio has witnessed fall in the yield in majority (almost 100%) of the portfolio leading to shrinking revenue from the segment.`
            );

            // 3. NPA & SMA stress movement ( single description only)
            // 3. NPA & SMA stress movement (build separately, then combine)
            const part1 = `Similar to retail segment, MSME Segment has also witnessed a rise in NPA levels from Rs.${prevNpa.toFixed(2)} Cr in ${prevDateFmt} to Rs.${latestNpa.toFixed(2)} Cr in ${latestDateFmt}`;
            const part2 = `However, reduction in SMA under the segment has led to reduction of stress in the segment`;

            // combine into one description
            descriptions.push(`${part1}.${part2}`);

        }


        return { flattenedData, dates, descriptions };
    };

    const processBalancesheet_12 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // 1. Overall yields
            const overallYield = latestTotal["Yield on Advances"] || "0.00%";
            const stdYield = latestTotal["Yield on Std Accounts"] || "0.00%";

            // descriptions.push(`Overall Portfolio yield ${overallYield}`);
            // descriptions.push(`Portfolio yield on Standard accounts ${stdYield}`);

            // 2. Exposure (dynamic)
            const contributionPct = (latestTotal["Balance"] > 0 && prevTotal["Balance"] > 0)
                ? ((latestTotal["Balance"] / latestTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            const npaPct = latestTotal["NPA%"] || "0.00%";
            const smaPct = latestTotal["SMA1+2%"] || "0.00%";
            descriptions.push(`Exposure in PSB Vyapar Loan contributes about ${contributionPct}% of total MSME Portfolio, NPA% and SMA% under PSB Vyapar stands at ${npaPct} and ${smaPct} respectively.`);

            // 3. Top 3 zones by NPA%
            const zoneNpa = latestRows.filter(r => r.Sector !== "Grand Total")
                .map(r => ({
                    zone: r.Sector,
                    npaPct: parseFloat((r["NPA%"] || "0").replace("%", "")) || 0
                }))
                .sort((a, b) => b.npaPct - a.npaPct)
                .slice(0, 3);
            const topZonesText = zoneNpa.map(z => `${z.zone} ${z.npaPct.toFixed(2)}%`).join(", ");
            descriptions.push(`NPA level in ${topZonesText} are high respectively.`);

            // 4. SMA movement
            const prevSma = prevTotal["SMA1+2"] || 0;
            const latestSma = latestTotal["SMA1+2"] || 0;
            const prevHighSmaZones = prevRows.filter(r => r.Sector !== "Grand Total" && parseFloat((r["SMA1+2%"] || "0").replace("%", "")) > 10).length;
            const latestHighSmaZones = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat((r["SMA1+2%"] || "0").replace("%", "")) > 10).length;
            descriptions.push(`Overall position w.r.t.SMA(1+2) accounts has improved as outstanding in SMA has decreased from  ₹${prevSma.toFixed(2)} crore to ₹${latestSma.toFixed(2)} crore during the Quarter with ${latestHighSmaZones} zones having SMA more than 10% as compared to ${prevHighSmaZones} zones during previous quarter.`);

            // 5. Zones yield < 9%
            const lowYieldZones = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat(
                typeof r["Yield on Advances"] === "string"
                    ? r["Yield on Advances"].replace("%", "")
                    : r["Yield on Advances"] || 0
            )
                < 9).map(r => r.Sector);
            if (lowYieldZones.length > 0) {
                descriptions.push(`${lowYieldZones.join(" and ")} zones have yield on advances less than 9%.`);
            }

            // 6. Yield reduction (bps)
            const prevYield = parseFloat((prevTotal["Yield on Advances"] || "0").replace("%", "")) || 0;
            const latestYield = parseFloat((latestTotal["Yield on Advances"] || "0").replace("%", "")) || 0;
            const yieldDiff = ((latestYield - prevYield) * 100).toFixed(0); // in bps
            descriptions.push(`Overall yield under the segment has also witnessed a ${yieldDiff > 0 ? "increase" : "reduction"} of around ${Math.abs(yieldDiff)} bps`);
        }

        return { flattenedData, dates, descriptions };
    };

    const processBalancesheet_13 = (jsonData) => {

        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];
        let headerBox = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // ---------- 1. Header Box ----------
            const overallYield = latestTotal["Yield on Advances"] || "0.00%";
            const stdYield = latestTotal["Yield on Std Accounts"] || "0.00%";
            // headerBox.push(`Overall Portfolio yield ${overallYield}`);
            // headerBox.push(`Portfolio yield on Standard accounts ${stdYield}`);

            // ---------- 2. PSB Mortgage Loan exposure ----------
            const contribPct = latestTotal["Balance"] > 0
                ? ((latestTotal["Balance"] / latestTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            const npaPct = latestTotal["NPA%"] || "0.00%";
            const smaPct = latestTotal["SMA1+2%"] || "0.00%";
            descriptions.push(`PSB Mortgage Loan contributes ${contribPct}% of our total MSME Portfolio, NPA ${npaPct} of total MSME NPA and SMA ${smaPct} of total SMA in MSME portfolio.`);

            // ---------- 3. Top 2 zones with double digit NPA ----------
            const doubleDigitZones = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat((r["NPA%"] || "0").replace("%", "")) >= 10);
            if (doubleDigitZones.length >= 2) {
                const zoneText = doubleDigitZones.slice(0, 2).map(z => `${z.Sector} at ${z["NPA%"]}`).join(" and ");
                descriptions.push(`${zoneText} zones have double digit NPA respectively.`);
            }

            // ---------- 4. SMA movement ----------
            const prevHighSmaZones = prevRows.filter(r => r.Sector !== "Grand Total" && parseFloat((r["SMA1+2%"] || "0").replace("%", "")) > 10).length;
            const latestHighSmaZones = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat((r["SMA1+2%"] || "0").replace("%", "")) > 10).length;
            descriptions.push(`${latestHighSmaZones} zones out of ${latestRows.length - 1} zones have SMA more than 10% as compared to ${prevHighSmaZones} zones during previous quarter.`);

            // ---------- 5. Reduction in NPA & SMA ----------
            if (parseFloat((latestTotal["NPA%"] || "0").replace("%", "")) < parseFloat((prevTotal["NPA%"] || "0").replace("%", "")) &&
                parseFloat((latestTotal["SMA1+2%"] || "0").replace("%", "")) < parseFloat((prevTotal["SMA1+2%"] || "0").replace("%", ""))) {

            }
            descriptions.push("However, a reduction has been witnessed under both NPA & SMA levels under the segment.");
            // ---------- 6. Yield dip in bps ----------
            const prevYield = parseFloat((prevTotal["Yield on Advances"] || "0").replace("%", "")) || 0;
            const latestYield = parseFloat((latestTotal["Yield on Advances"] || "0").replace("%", "")) || 0;
            const yieldDiffBps = ((latestYield - prevYield) * 100).toFixed(0);
            descriptions.push(`Overall portfolio yield of the product segment has also witnessed a ${yieldDiffBps >= 0 ? "rise" : "dip"} of around ${Math.abs(yieldDiffBps)} bps.`);

            // ---------- 7. Reduced zones ----------
            const reducedZones = latestRows.filter(r => {
                const prev = prevRows.find(p => p.Sector === r.Sector);
                return prev && r["Balance"] < prev["Balance"];
            }).length;
            descriptions.push(`Portfolio in ${reducedZones} Zones has reduced during the quarter`);
        }


        return { flattenedData, dates, descriptions };
    };

    const processBalancesheet_14 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];
        // let headerBox = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // 1. Header box
            const overallYield = latestTotal["Yield on Advances"] || "0.00%";
            const stdYield = latestTotal["Yield on Std Accounts"] || "0.00%";
            // headerBox.push(`Overall Portfolio yield ${overallYield}`);
            // headerBox.push(`Portfolio yield on Standard accounts ${stdYield}`);

            // 2. Loan contribution
            const contribPct = latestTotal["Balance"] > 0
                ? ((latestTotal["Balance"] / latestTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            descriptions.push(`MUDRA Loan contributes ${contribPct}% of our total MSME Portfolio, NPA % stands at ${latestTotal["NPA%"]} of total MSME NPA and SMA % is ${latestTotal["SMA1+2%"]} of total SMA in MSME portfolio.`);

            // 3. Growth of exposure
            const growth = (latestTotal["Balance"] - prevTotal["Balance"]).toFixed(2);
            descriptions.push(`Overall exposure in MUDRA Loan segment has seen growth of  ₹${growth} Cr approximately during the current quarter.`);

            // 4. Zones with SMA > 10%
            const smaZones = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat((r["SMA1+2%"] || "0").replace("%", "")) > 10);
            descriptions.push(`Out of ${latestRows.length - 1} Zones, ${smaZones.length} Zones are having SMA above 10%.`);

            // 5. Zones with NPA > 10%
            const highNpaZones = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat((r["NPA%"] || "0").replace("%", "")) > 10);
            if (highNpaZones.length > 0) {
                // Sort descending by NPA%
                highNpaZones.sort((a, b) => parseFloat(b["NPA%"]) - parseFloat(a["NPA%"]));
                const top1 = `${highNpaZones[0].Sector} at ${highNpaZones[0]["NPA%"]}`;
                const top2 = highNpaZones[1] ? ` followed by ${highNpaZones[1].Sector} at ${highNpaZones[1]["NPA%"]}` : "";
                descriptions.push(`${highNpaZones.length} Zones out of ${latestRows.length - 1} zones are having NPA % more than 10%, wherein ${top1}${top2}`);
            }
        }

        return { flattenedData, dates, descriptions };
    };


    // const processBalancesheet_15 = (jsonData) => {
    //     let result = {};
    //     const toCrores = (val) => {
    //         const num = Number(val || 0) / 10000000;
    //         return Number(num.toFixed(2));
    //     };

    //     // Helper to calculate totals and weighted yield
    //     const calculateTotals = (rows, label = "Grand Total") => {
    //         let totalBalance = 0,
    //             totalNpa = 0,
    //             totalSma1 = 0,
    //             totalSma2 = 0,
    //             totalInterest = 0;

    //         rows.forEach(r => {
    //             totalBalance += Number(r["Balance"] || 0);
    //             totalNpa += Number(r["NPA"] || 0);
    //             totalSma1 += Number(r["SMA1"] || 0);
    //             totalSma2 += Number(r["SMA2"] || 0);
    //             totalInterest += Number(r["INTEREST"] || 0); // crores
    //         });

    //         const totalSma1plus2 = totalSma1 + totalSma2;
    //         const yieldOnAdvances =
    //             totalBalance > 0
    //                 ? ((totalInterest / totalBalance) * 100).toFixed(2) + "%"
    //                 : "0.00%";

    //         return {
    //             Sector: label,
    //             "Balance": totalBalance,
    //             NPA: totalNpa,
    //             "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
    //             SMA1: totalSma1,
    //             "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
    //             SMA2: totalSma2,
    //             "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
    //             "SMA1+2": totalSma1plus2,
    //             "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
    //             "Yield on Advances": yieldOnAdvances,
    //             type: "grandtotal"
    //         };
    //     };

    //     // Group data by reporting_date
    //     if (Array.isArray(jsonData)) {
    //         jsonData.forEach(item => {
    //             const date = item.reporting_date || "Unknown Date";
    //             if (!result[date]) result[date] = [];

    //             const os_balance = toCrores(item.os_balance);
    //             const npa = toCrores(item.npa);
    //             const sma1 = toCrores(item.sma1);
    //             const sma2 = toCrores(item.sma2);
    //             const sma1plus2 = sma1 + sma2;

    //             const roiPercent = toCrores(item.roi || 0); // ROI in %
    //             const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
    //             const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

    //             result[date].push({
    //                 Sector: item.rep_param,
    //                 "Balance": os_balance,
    //                 NPA: npa,
    //                 "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
    //                 SMA1: sma1,
    //                 "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
    //                 SMA2: sma2,
    //                 "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
    //                 "SMA1+2": sma1plus2,
    //                 "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
    //                 "Yield on Advances": yieldOnAdvances,
    //                 ROI_PERCENT: roiPercent,
    //                 INTEREST: interest // in crores
    //             });
    //         });
    //     }

    //     // ---------- Add Grand Totals ----------
    //     Object.keys(result).forEach(date => {
    //         const rows = result[date];
    //         const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
    //         const grandTotal = calculateTotals(filteredRows, "Grand Total");
    //         result[date] = [...filteredRows, grandTotal];
    //     });

    //     // ---------- Flatten ----------
    //     let flattenedData = [];
    //     Object.entries(result).forEach(([date, rows]) => {
    //         rows.forEach(r => flattenedData.push({ Date: date, ...r }));
    //     });


    //     const dates = Object.keys(result).sort();
    //     let descriptions = [];

    //     if (dates.length >= 2) {
    //         const [prevDate, latestDate] = dates.slice(-2);
    //         const prevRows = flattenedData.filter(r => r.Date === prevDate);
    //         const latestRows = flattenedData.filter(r => r.Date === latestDate);

    //         const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
    //         const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

    //         // 1. Growth of exposure
    //         if (prevTotal["Balance"] && latestTotal["Balance"]) {
    //             const growthPct = (
    //                 ((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) *
    //                 100
    //             ).toFixed(2);
    //             descriptions.push(
    //                 `Exposure under Direct Assignment Pool has witnessed a considerable growth of ${growthPct}% to ${latestTotal["Balance"].toFixed(2)} Cr.`
    //             );
    //         }

    //         // 2. Major contributor
    //         const majorContributor = latestRows
    //             .filter(r => r.Sector !== "Grand Total")
    //             .sort((a, b) => b["Balance"] - a["Balance"])[0];

    //         if (majorContributor) {
    //             const sharePct = (
    //                 (majorContributor["Balance"] / latestTotal["Balance"]) *
    //                 100
    //             ).toFixed(2);
    //             descriptions.push(
    //                 `The above table depicts ${majorContributor.Sector} Pool constitutes the major share nearly ${sharePct}% of the total exposure to  ₹${latestTotal["Balance"].toFixed(2)} crore.`
    //             );
    //         }

    //         // 3. New exposures in latest vs prev
    //         const prevSectors = new Set(prevRows.map(r => r.Sector));
    //         const newSectors = latestRows
    //             .filter(r => r.Sector !== "Grand Total" && !prevSectors.has(r.Sector))
    //             .map(r => r.Sector);

    //         if (newSectors.length > 0) {
    //             descriptions.push(
    //                 `However, during the quarter, new exposure has been added under DA pool mainly through ${newSectors.join(", ")}`
    //             );
    //         }
    //     }


    //     return { flattenedData, dates, descriptions };
    // };

    const processBalancesheet_15 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // 🔹 Mapping table for rep_param replacements
        const nameMapping = {
            "FEDBANK FINANCIAL SERVICES LTD MSME": "FEDBANK",
            "GODREJ HOUSING FINANCE LIMITED  LAP": "GODREJ",
            "HDFC DA POOL SUB-STD JUNE 2024": "HDFC",
            "HDFC DA POOL SUB-STD SEPTEMBER 2024": "HDFC",
            "HDFC DA POOL- STANDARD JUNE 2024": "HDFC",
            "HDFC DA POOL- STANDARD SEPTEMBER 20": "HDFC",
            "IDFC FIRST BANK LIMITED LAP NPS STD": "IDFC BANK",
            "IDFC FIRST BANK LIMITED LAP PS STD-": "IDFC BANK",
            "IDFC FIRST BANK LIMITED MSME UNSECU": "IDFC BANK",
            "SMFG INDIA CREDIT COMPANY LTD MSME": "SMFG",
            "UNITY SMALL FINANCE BANK MSME STAND": "UNITY SMALL",
            "AFL DA 1 NPS- STANDARD": "AXIS BANK",
            "AFL DA 1 PS- STANDARD": "AXIS BANK"
        };

        // ---------- Helper to calculate totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0);
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by reporting_date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi;

                const roiPercent = Number(item.roi || 0);
                const interest = (os_balance * (roiPercent / 100));
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%";

                // ✅ Replace long rep_param with short mapped name
                const cleanSector = nameMapping[item.rep_param?.trim()] || item.rep_param;

                result[date].push({
                    Sector: cleanSector,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        const dates = Object.keys(result).sort();
        let descriptions = [];

        // ---------- Description generation ----------
        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // 1️⃣ Growth of exposure
            if (prevTotal["Balance"] && latestTotal["Balance"]) {
                const growthPct = (
                    ((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) *
                    100
                ).toFixed(2);
                descriptions.push(
                    `Exposure under Direct Assignment Pool has witnessed a considerable growth of ${growthPct}% to ₹${latestTotal["Balance"].toFixed(2)} Cr.`
                );
            }

            // 2️⃣ Major contributor
            const majorContributor = latestRows
                .filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => b["Balance"] - a["Balance"])[0];

            const prevSectors = new Set(prevRows.map(r => r.Sector));
            const newSectors = latestRows
                .filter(r => r.Sector !== "Grand Total" && !prevSectors.has(r.Sector))
                .map(r => r.Sector);

            if (majorContributor) {
                const sharePct = (
                    (majorContributor["Balance"] / latestTotal["Balance"]) *
                    100
                ).toFixed(2);
                descriptions.push(
                    `The above table depicts ${majorContributor.Sector} Pool constitutes the major share nearly ${sharePct}% of the total exposure to ₹${latestTotal["Balance"].toFixed(2)} crore, and However, during the quarter, new exposure has been added under DA pool mainly through ${newSectors.join(", ")}`
                );
            }

        }

        return { flattenedData, dates, descriptions };
    };

    const processOtherRetail200 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------

        const nameMapping = {
            "MORTL": "MORTL - MORTGAGE TERM LOAN",
            "STFHO": "STFHO - STAFF HOUSING LOAN",
            "DEPLO": "DEPLO - LOANS AGAINST DEPOSITS",
            "LAPLO": "LAPLO - LOAN AGAINST PROPERTY",
            "ODABD": "ODABD - OD AGAINST BANK DEPOSITS",
            "ODSTF": "DOSFT - OD STAFF",
            "STFVH": "STFVL - STAFF VEHICLE LOAN"
        };


        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%
                const cleanSector = nameMapping[item.rep_param?.trim()] || item.rep_param;

                result[date].push({
                    Sector: cleanSector,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });


        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length > 0) {
            const latestDate = dates[dates.length - 1];
            const latestRows = flattenedData.filter(r => r.Date === latestDate);
            const grandTotal = latestRows.find(r => r.Sector === "Grand Total");

            // 1️⃣ Intro - general description
            descriptions.push(
                "The above table depicts the major schemes (with outstanding amount more than ₹200.00 crore) of Retail Advances other than the specific schemes as mentioned in the above paragraphs."
            );

            // 2️⃣ Major portion - top 2 contributors by balance
            const sortedByBalance = latestRows
                .filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => b["Balance"] - a["Balance"]);
            const topTwo = sortedByBalance.slice(0, 2).map(r => r.Sector);

            if (topTwo.length > 0) {
                descriptions.push(
                    `As evident from the tables above, as on ${latestDate}, major portion of other Retail falls under ${topTwo.join(" and ")}.`
                );
            }

            // 3️⃣ High yield schemes (ROI > 10%)
            const highYield = sortedByBalance.filter(r => parseFloat(r["Yield on Advances"]) > 10);
            const highYieldSectors = highYield.map(r => r.Sector);

            if (highYieldSectors.length > 0) {
                descriptions.push(
                    `The schemes with maximum contribution to yield on advances with more than 10% are ${highYieldSectors.join(" and ")}.`
                );
            }

            // 4️⃣ Low yield (ROI < 7%)
            const lowYield = sortedByBalance.filter(r => parseFloat(r["Yield on Advances"]) > 0 && parseFloat(r["Yield on Advances"]) < 7);
            const lowYieldSectors = lowYield.map(r => r.Sector);

            if (lowYieldSectors.length > 0) {
                descriptions.push(
                    `On the other hand, schemes pertaining to ${lowYieldSectors.join(", ")} generate low yield on advances ranging between 5.5% – 7%.`
                );
            }

            // 5️⃣ Highest SMA 1+2 %
            const smaSorted = sortedByBalance.filter(r => r["SMA1+2%"] !== "0.00%")
                .sort((a, b) => parseFloat(b["SMA1+2%"]) - parseFloat(a["SMA1+2%"]));
            if (smaSorted.length >= 2) {
                const [first, second] = smaSorted;
                descriptions.push(
                    `${first.Sector} and ${second.Sector} are having highest % in SMA 1&2 category at around ${first["SMA1+2%"]} and ${second["SMA1+2%"]} respectively.`
                );
            }
        }


        return { flattenedData, dates, descriptions };
    };

    const processOtherMSME200 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------

        const nameMapping = {
            "CCGEN": "CCGEN - CC-HYPOTHECATION/PLEDGE",
            "ODAPR": "ODAPR OD AGNST PROPERTY",
            "TREDS": "TREDS - TREDS BILL PURCHASE",
            "TLSSI": "TLSSI - TL SMALL SCALE INDUSTRIES",
            "WCMLI": "WCMLI - MED/LARGE SCALE IN/NON EI",
            "CCSSI": "CCSSI - CC SMALL SCALE INDUSTRIES",
            "ODABD": "ODABD - OD AGNST BANK DEPOSIT",
            "TRPLO": "TRPLO - TRANSPORT LOAN",
            "PCIS": "PCIS - PRE-SHIP CR. UNDER SUBVN",
            "PSB": "PSB MSME PREMIER TL",
            "TLEIS": "TL EMI SUBSIDY SCHEME",
            "MSETL": "MSETL - MSME TERM LOAN"
        };
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%
                const cleanSector = nameMapping[item.rep_param?.trim()] || item.rep_param;

                result[date].push({
                    Sector: cleanSector,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });


        const dates = Object.keys(result).sort();
        let descriptions = [];

        // ---------- Generate Descriptions (Dynamic Like Image) ----------
        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const totalBalanceCr = latestTotal["Balance"]?.toFixed(2) || "0.00";

            // --- 1. Major schemes description ---
            descriptions.push(
                `The above table depicts the major schemes (with outstanding amount more than ₹200.00 crore) of MSME Advances other than the specific schemes as mentioned in the preceding paragraphs.`
            );

            // --- 2. Major portion identification ---
            const top3Sectors = latestRows
                .filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => b["Balance"] - a["Balance"])
                .slice(0, 3)
                .map(r => r.Sector);

            const totalTop3 =
                latestRows
                    .filter(r => top3Sectors.includes(r.Sector))
                    .reduce((sum, r) => sum + r["Balance"], 0);

            const sharePct = ((totalTop3 / latestTotal["Balance"]) * 100).toFixed(0);

            descriptions.push(
                `As evident from the table above, major portion of other MSME falls under ${top3Sectors.join(", ")} comprising about ${sharePct}%.`
            );

            // --- 3. Highest yield schemes ---
            const highYieldSchemes = latestRows
                .filter(r => r.Sector !== "Grand Total" && parseFloat(r["Yield on Advances"]) > 9)
                .map(r => r.Sector);

            if (highYieldSchemes.length > 0) {
                descriptions.push(
                    `The schemes with maximum contribution to yield on advances are ${highYieldSchemes.join(", ")} with yield more than 9.00%.`
                );
            }

            // --- 4. Growth description ---
            if (prevTotal["Balance"] && latestTotal["Balance"]) {
                const growth = (
                    ((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) *
                    100
                ).toFixed(2);
                descriptions.push(
                    `The segment has witnessed a remarkable growth of around ₹${(
                        latestTotal["Balance"] - prevTotal["Balance"]
                    ).toFixed(2)} Cr mainly led by ${top3Sectors[0]} portfolio, TL EMI subsidy scheme and MSME Premier TL`
                );
            }
        }

        return { flattenedData, dates, descriptions };
    };

    const processBalancesheet_16 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // 1. Contribution to total MSME portfolio
            descriptions.push(
                `PSB SME Liquid Plus contributes only ${(
                    (latestTotal["Balance"] / latestTotal["Balance"]) * 100
                ).toFixed(2)}% of total MSME portfolio, NPA% and SMA% under this segment stands at ${latestTotal["NPA%"]} and ${latestTotal["SMA1+2%"]} respectively.`
            );

            // 2. Top 3 zones with highest NPA%
            const topNpaZones = latestRows
                .filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => parseFloat(b["NPA%"]) - parseFloat(a["NPA%"]))
                .slice(0, 3)
                .map(r => `${r.Sector} (${r["NPA%"]})`);
            if (topNpaZones.length > 0) {
                descriptions.push(`${topNpaZones.join(", ")} have highest NPA percentages among all Zones.`);
            }

            // 3. NPA increase zones
            const npaIncreaseZones = latestRows.filter(latest => {
                if (latest.Sector === "Grand Total") return false;
                const prev = prevRows.find(p => p.Sector === latest.Sector);
                return prev && latest.NPA > prev.NPA;
            });
            // if (npaIncreaseZones.length > 0) {
            descriptions.push(`NPA has increased in ${npaIncreaseZones.length} zones (${npaIncreaseZones.map(z => z.Sector).join(", ")}).`);
            // }

            // 4. SMA increase zones
            const smaIncreaseZones = latestRows.filter(latest => {
                if (latest.Sector === "Grand Total") return false;
                const prev = prevRows.find(p => p.Sector === latest.Sector);
                return prev && latest["SMA1+2"] > prev["SMA1+2"];
            });
            if (smaIncreaseZones) {
                descriptions.push(`SMA (1+2) has increased in ${smaIncreaseZones.length} zones (${smaIncreaseZones.map(z => z.Sector).join(", ")}) and However Overall, a reduction in SMA (1+2) has been witnessed under the segment.`);
            }

            // 5. Yield reduction
            const prevYield = parseFloat((prevTotal["Yield on Advances"] || "0").replace("%", ""));
            const latestYield = parseFloat((latestTotal["Yield on Advances"] || "0").replace("%", ""));
            // if (latestYield < prevYield) {
            descriptions.push(`Similar to PSB Vyapar segment, reduction in yield has also been witnessed under SMA Liquid Plus Segment`);
            // }
        }

        return { flattenedData, dates, descriptions };
    };

    const processOtherAgricultural = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // --- Dynamic Calculations ---
            const totalZones = latestRows.length - 1; // excluding Grand Total
            const zonesAbove10 = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat(r["NPA%"]) > 10);
            const zonesAbove10Count = zonesAbove10.length;

            // Portfolio yields
            const overallYield = latestTotal["Yield on Advances"] || "0.00%";
            const stdYield = latestTotal["Yield on Std Accounts"] || "0.00%";

            // Zones with major improvement in SMA (fall in SMA1+2%)
            const prevSmaMap = Object.fromEntries(prevRows.map(r => [r.Sector, parseFloat(r["SMA1+2%"]) || 0]));
            const smaImprovedZones = latestRows.filter(r => {
                if (r.Sector === "Grand Total") return false;
                const prevSma = prevSmaMap[r.Sector] || 0;
                const currSma = parseFloat(r["SMA1+2%"]) || 0;
                return currSma < prevSma;
            });

            // Zones with steep fall (more than 2% reduction)
            const steepFallZones = smaImprovedZones
                .filter(r => (prevSmaMap[r.Sector] - parseFloat(r["SMA1+2%"])) > 2)
                .map(r => r.Sector);

            // --- Dynamic Description Text ---
            descriptions.push(`Out of ${totalZones} Zones, ${zonesAbove10Count} zones are having NPA more than 10%.`);

            // if (smaImprovedZones.length > 0) {
            descriptions.push(`There is a prominent improvement in SMA recovery in all the zones.`);
            // }

            if (steepFallZones.length > 0) {
                descriptions.push(`${steepFallZones.join(", ")} Zones have seen a steep fall in SMA.`);
            }
            const smaChange = ((prevTotal["SMA1+2"] || 0) - (latestTotal["SMA1+2"] || 0)).toFixed(2);

            descriptions.push(
                `An increase in NPA amount by around ₹${((latestTotal["NPA"] || 0) - (prevTotal["NPA"] || 0)).toFixed(2)} Cr has led to increase in stress and However, the reduction of SMA under segment by around ₹${smaChange} Cr has contributed towards better asset quality and ultimately reduction of stress.`
            );



        }

        return { flattenedData, dates, descriptions };
    };

    const processOtherAgricultural100 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------

        const nameMapping = {
            "KCCAH": "ANIMAL HUSBANDARY",
            "CCGEN": "HYPOTHECATION (PLEDGE)",
            "CCIAG": "INDIRECT AGRICULTURE",
            "VYPOD": "VYAPAR OVERDRAFT",
            "WCMLI": "AGREE SCALE IN-NON II",
            "AGGDL": "PSB KRISHI SWAN KANTI",
            "RSHCC": "PSB RICE SHELTER SCHEME",
            "DLJEW": "DEMAND LOAN JEWELLERY",
            "AGGWC": "AGRI GOLD LOAN",
            "TLAIF": "PSG AGRI INFRA FUND",
            "AGVEH": "AGRI VEHICLE LOAN",
            "TLSSI": "TLI SMALL SCALE INDUSTRIES",
            "DEPLO": "LOANS AGAINST DEPOSITS",
            "FAGCC": "FOOD AND AGRO PROCESSING",
            "ODABD": "OD AGAINST BANK DEPOSIT",

        };


        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%
                const cleanSector = nameMapping[item.rep_param?.trim()] || item.rep_param;

                result[date].push({
                    Sector: cleanSector,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};
            const totalBalance = latestTotal["Balance"] || 0;

            // Filter valid rows (schemes)
            const schemes = latestRows.filter(r => r.Sector !== "Grand Total");

            // --- Identify major schemes (Balance > 100 Cr) ---
            const majorSchemes = schemes.filter(r => r["Balance"] > 100);

            // --- Sort top 3 schemes by Balance ---
            const topSchemes = [...schemes]
                .sort((a, b) => b["Balance"] - a["Balance"])
                .slice(0, 3);

            // --- Calculate their combined % contribution ---
            const topContribution = topSchemes.reduce((acc, s) => acc + (s["Balance"] || 0), 0);
            const topContributionPct =
                totalBalance > 0 ? ((topContribution / totalBalance) * 100).toFixed(2) : "0.00";

            const latestDateLabel = latestDate.replace("Unknown Date", "").trim();

            // ---------- Dynamic Description Text ----------
            descriptions.push(
                `The above table depicts the major schemes (with outstanding amount more than ₹100.00 crore) of Agricultural Advances other than the specific schemes as mentioned in the paragraphs.`
            );

            descriptions.push(
                `As evident from the tables above, as on ${latestDateLabel}, major portion of Other Agricultural falls under ${topSchemes
                    .map(s => s.Sector)
                    .join(", ")} contributing approximately ${topContributionPct}% of the other agricultural portfolio.`
            );

            // --- Optional additional insight ---
            const avgNPA =
                totalBalance > 0
                    ? ((schemes.reduce((acc, s) => acc + (s["NPA"] || 0), 0) / totalBalance) * 100).toFixed(2)
                    : "0.00";


        }

        return { flattenedData, dates, descriptions };
    };

    const processRenewableEnergy = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 1) {
            const latestDate = dates[dates.length - 1];
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};
            const totalBalance = latestTotal["Balance"] || 0;

            // Filter valid schemes (exclude Grand Total)
            const schemes = latestRows.filter(r => r.Sector !== "Grand Total");

            // Top scheme by balance
            const topScheme = [...schemes].sort((a, b) => b["Balance"] - a["Balance"])[0];
            const topSharePct = totalBalance > 0 ?
                ((topScheme["Balance"] / totalBalance) * 100).toFixed(2) : "0.00";

            // Scheme with highest NPA%
            const highNpaScheme = [...schemes].sort(
                (a, b) => parseFloat(b["NPA%"]) - parseFloat(a["NPA%"])
            )[0];

            // Scheme with highest SMA%
            const highSmaScheme = [...schemes].sort(
                (a, b) => parseFloat(b["SMA1+2%"]) - parseFloat(a["SMA1+2%"])
            )[0];

            // Format date for display
            const displayDate = latestDate === "2024-12-31" ? "31.12.2024" :
                latestDate === "2025-03-31" ? "31.03.2025" :
                    latestDate;

            // ---------- Dynamic Description Text ----------
            descriptions.push(
                `The above table depicts advances portfolio sanctioned under Green-Advances.`
            );

            descriptions.push(
                `Out of total portfolio of ₹${totalBalance.toFixed(2)} Cr as on ${displayDate}, ${topScheme.Sector} constitutes the major share nearly ${topSharePct}% of the total exposure to e-advances.`
            );

            if (highNpaScheme && parseFloat(highNpaScheme["NPA%"]) > 0) {
                descriptions.push(
                    `${highNpaScheme.Sector} has highest NPA% of ${highNpaScheme["NPA%"]} and SMA% at ${highNpaScheme["SMA1+2%"]}.`
                );
            } else if (highSmaScheme && parseFloat(highSmaScheme["SMA1+2%"]) > 0) {
                descriptions.push(
                    `${highSmaScheme.Sector} has highest SMA% of ${highSmaScheme["SMA1+2%"]}.`
                );
            }

            // Additional insights based on your image data
            const ethanolScheme = schemes.find(s => s.Sector.includes("ETHANOL") || s.Sector.includes("TLNET"));
            if (ethanolScheme) {
                const ethanolShare = totalBalance > 0 ?
                    ((ethanolScheme["Balance"] / totalBalance) * 100).toFixed(2) : "0.00";

                // If ethanol is not the top scheme but has significant share, mention it
                if (ethanolScheme.Sector !== topScheme.Sector && parseFloat(ethanolShare) > 20) {
                    descriptions.push(
                        `${ethanolScheme.Sector} also contributes significantly with ${ethanolShare}% share of the total portfolio.`
                    );
                }
            }

            // Portfolio quality insight
            const totalNpaPercent = parseFloat(latestTotal["NPA%"] || "0");
            const totalSmaPercent = parseFloat(latestTotal["SMA1+2%"] || "0");

            // if (totalNpaPercent < 1 && totalSmaPercent < 2) {
            //     descriptions.push(
            //         `Overall portfolio quality remains healthy with NPA% at ${totalNpaPercent}% and SMA% at ${totalSmaPercent}%.`
            //     );
            // }
        }
        return { flattenedData, dates, descriptions };
    };

    const processBalancesheet_18 = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // 1. Overall exposure change
            const exposureChange = (latestTotal["Balance"] - prevTotal["Balance"]).toFixed(2);
            const exposureDirection = exposureChange >= 0 ? "increased" : "decreased";
            descriptions.push(`Overall exposure ${exposureDirection} by ₹${Math.abs(exposureChange)} crore during the quarter.`);

            // 2. Highest balance zones
            const topZones = [...latestRows]
                .filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => b["Balance"] - a["Balance"])
                .slice(0, 3);
            if (topZones.length > 0) {
                descriptions.push(
                    `${topZones[0].Sector} Zone has highest Agriculture business ( ₹${topZones[0]["Balance"]} Crore) followed by ${topZones[1].Sector} ( ₹${topZones[1]["Balance"]} Crore) and ${topZones[2].Sector} ( ₹${topZones[2]["Balance"]} Crore).`
                );
            }

            // 3. Count of zones with NPA > 10%
            // 3. Zones with higher NPA percentages
            const zonesAbove10 = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat(r["NPA%"]) > 10);
            const zonesAbove14 = zonesAbove10.filter(r => parseFloat(r["NPA%"]) > 14);

            if (zonesAbove10.length > 0 && zonesAbove14.length > 0) {
                let desc = `${zonesAbove10.length} Zones out of ${latestRows.length - 1} have NPA more than 10%, Among them, ${zonesAbove14.map(z => z.Sector).join(", ")} have the highest NPA% with more than 14%.`;

                descriptions.push(desc);
            }


            // 5. Portfolio yield
        }

        return { flattenedData, dates, descriptions };
    };

    const processKCC = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;

            // Calculate weighted average yield correctly
            const weightedYield = totalBalance > 0
                ? ((totalInterest / totalBalance) * 100).toFixed(2)
                : 0;

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": weightedYield + "%",
                INTEREST: totalInterest,
                "Interest Income": totalInterest.toFixed(2),
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;

                // roi is the percentage value (like 9.45, 8.57 etc.)
                const roiPercent = parseFloat(item.roi || 0);

                // Calculate Interest Income = (Outstanding Balance × ROI %) / 100
                const interest = (os_balance * roiPercent) / 100;

                // Yield on Advances is the same as roiPercent
                const yieldOnAdvances = roiPercent.toFixed(2) + "%";

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Interest Income": interest.toFixed(2),
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // 1. Overall exposure change
            const exposureChange = (latestTotal["Balance"] - prevTotal["Balance"]).toFixed(2);
            const exposureDirection = exposureChange >= 0 ? "increased" : "decreased";
            descriptions.push(
                `Overall exposure to KCC (CCAGR) has ${exposureDirection} by ₹${Math.abs(exposureChange)} Crore during the current quarter.`
            );

            // 2. Highest balance zones
            const topZones = [...latestRows]
                .filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => b["Balance"] - a["Balance"])
                .slice(0, 3);
            if (topZones.length > 0) {
                descriptions.push(
                    `${topZones[0].Sector} Zone has highest KCC business ( ₹${topZones[0]["Balance"]} Crore) followed by ${topZones[1].Sector} (₹${topZones[1]["Balance"]} Crore) and ${topZones[2].Sector} (₹${topZones[2]["Balance"]} Crore).`
                );
            }

            // 3. Highest NPA zones
            const highestNPA = [...latestRows]
                .filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => parseFloat(b["NPA%"]) - parseFloat(a["NPA%"]))
                .slice(0, 3);
            if (highestNPA.length > 0) {
                descriptions.push(
                    `${highestNPA[0].Sector} Zone has the highest NPA% (${highestNPA[0]["NPA%"]}) followed by ${highestNPA[1].Sector} and ${highestNPA[2].Sector}.`
                );
            }
        }

        return { flattenedData, dates, descriptions };
    };

    const processSnapshot = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;

            // Calculate weighted average yield correctly
            const weightedYield = totalBalance > 0
                ? ((totalInterest / totalBalance) * 100).toFixed(2)
                : 0;

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": weightedYield + "%",
                INTEREST: totalInterest,
                "% to Total": totalInterest.toFixed(2),
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;

                // roi is the percentage value (like 9.45, 8.57 etc.)
                const roiPercent = parseFloat(item.roi || 0);

                // Calculate Interest Income = (Outstanding Balance × ROI %) / 100
                const interest = (os_balance / 100);

                // Yield on Advances is the same as roiPercent
                const yieldOnAdvances = roiPercent.toFixed(2) + "%";

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "% to Total": interest.toFixed(2),
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, currDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const currRows = flattenedData.filter(r => r.Date === currDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const currTotal = currRows.find(r => r.Sector === "Grand Total") || {};

            // Compute % of A and above (AAA, AA, A)
            const topRatings = ["AAA", "AA", "A"];
            const calcTopExposurePct = (rows) => {
                let total = 0;
                let top = 0;
                rows.forEach(r => {
                    if (r.Sector === "Grand Total") total = r["Balance"] || 0;
                });
                rows.forEach(r => {
                    if (topRatings.includes(r.Sector)) top += r["Balance"] || 0;
                });
                return total > 0 ? ((top / total) * 100).toFixed(2) : "0.00";
            };

            const prevTopPct = calcTopExposurePct(prevRows);
            const currTopPct = calcTopExposurePct(currRows);

            // 1️⃣ Summary on portfolio concentration
            descriptions.push(
                `The above table depicts that majority of the NBFC portfolio is mainly concentrated in top rated borrowers since approximately ${currTopPct}% of the total exposure is rated ‘A’ & above as of ${currDate}.`
            );

            // 2️⃣ Risk-weight observation
            descriptions.push(
                `This indicates that the portfolio attracts a lower risk weight and in turn consumes lower amount of capital.`
            );
        }


        return { flattenedData, dates, descriptions };
    };

    const processExternalRatingPosition = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        if (Array.isArray(jsonData)) {
            // Group by reporting_date
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.exposure);
                console.log("os_balance:", os_balance);
                const exposure = toCrores(item.exposure);
                console.log("exposure:", exposure);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const roiPercent = parseFloat(item.roi || 0);

                result[date].push({
                    Sector: item.rating_grade,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "Yield on Advances": roiPercent.toFixed(2) + "%",
                    INTEREST: (os_balance / 100),
                });
            });

            // Calculate % to Total for each reporting date
            Object.keys(result).forEach(date => {
                const rows = result[date];
                const totalBalance = rows.reduce((sum, r) => sum + r.Balance, 0);

                rows.forEach(r => {
                    r["% to Total"] = totalBalance > 0 ? ((r.Balance / totalBalance) * 100).toFixed(2) + "%" : "0.00%";
                });

                // Add Grand Total row
                const grandTotal = {
                    Sector: "Grand Total",
                    Balance: totalBalance,
                    NPA: rows.reduce((s, r) => s + (r.NPA || 0), 0),
                    "NPA%": "100.00%",
                    SMA1: rows.reduce((s, r) => s + (r.SMA1 || 0), 0),
                    SMA2: rows.reduce((s, r) => s + (r.SMA2 || 0), 0),
                    "SMA1+2": rows.reduce((s, r) => s + (r["SMA1+2"] || 0), 0),
                    INTEREST: rows.reduce((s, r) => s + (r.INTEREST || 0), 0),
                    "% to Total": "100.00%",
                    type: "grandtotal"
                };

                result[date] = [...rows, grandTotal];
            });
        }

        // Flatten
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        const dates = Object.keys(result).sort();
        return { flattenedData, dates, descriptions: [] };

    };


    const processSnapshotExternal = (jsonData) => {
        let result = {};

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
            });

            return {
                Sector: label,
                "Balance": totalBalance,
                "NPA": 0,
                "NPA%": "0.00%",
                "SMA1": 0,
                "SMA1%": "0.00%",
                "SMA2": 0,
                "SMA2%": "0.00%",
                "SMA1+2": 0,
                "SMA1+2%": "0.00%",
                "Yield on Advances": "0.00%",
                "INTEREST": 0,
                "% to Total": "0.00",
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (jsonData && typeof jsonData === "object") {
            Object.keys(jsonData).forEach(rating => {
                const entries = jsonData[rating];
                if (!Array.isArray(entries)) return;

                entries.forEach(item => {
                    const date = item.reporting_date || "Unknown Date";
                    if (!result[date]) result[date] = [];

                    const os_balance = toCrores(item.exposure);

                    result[date].push({
                        Sector: rating, // instead of item.rep_param
                        "Balance": os_balance,
                        "NPA": 0,
                        "NPA%": "0.00%",
                        "SMA1": 0,
                        "SMA1%": "0.00%",
                        "SMA2": 0,
                        "SMA2%": "0.00%",
                        "SMA1+2": 0,
                        "SMA1+2%": "0.00%",
                        "Yield on Advances": "0.00%",
                        "INTEREST": 0,
                        "% to Total": "0.00",
                    });
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const exposureChange = (latestTotal["Balance"] - prevTotal["Balance"]).toFixed(2);
            const exposureDirection = exposureChange >= 0 ? "increased" : "decreased";
            descriptions.push(
                `Overall exposure has ${exposureDirection} by ₹${Math.abs(exposureChange)} Crore during the current quarter.`
            );

            // Top exposures
            const topRatings = [...latestRows]
                .filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => b["Balance"] - a["Balance"])
                .slice(0, 3);

            if (topRatings.length > 0) {
                descriptions.push(
                    `${topRatings[0].Sector} rating has highest exposure (₹${topRatings[0]["Balance"]} Crore), followed by ${topRatings[1]?.Sector || "-"} and ${topRatings[2]?.Sector || "-"}.`
                );
            }
        }

        return { flattenedData, dates, descriptions };
    };


    const processPsb_gst_ease = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const overallYield = latestTotal["Yield on Advances"];
            const stdYield = latestTotal["Yield on Std Accounts"] || "0.00%";
            const npaPct = latestTotal["NPA%"];
            const smaPct = latestTotal["SMA1+2%"];

            // ----- 1. Portfolio yield header -----
            // descriptions.push(`Overall Portfolio yield ${overallYield}`);
            // descriptions.push(`Portfolio yield on Standard accounts ${stdYield}`);

            // ----- 2. Growth in Business (dynamic 13%) -----
            const growthPct = prevTotal["Balance"] > 0
                ? (((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            descriptions.push(`The flagship MSME scheme of the Bank has shown a growth of approximately ${growthPct}% in business as compared to previous quarter.`);

            // ----- 3. GST Ease Contribution (dynamic 9.96%) -----
            const gstEase = latestRows.find(r => r.Sector !== "Grand Total"); // assuming all rows are GST Ease zones
            // Find GST Ease totals (sum all zones except "Grand Total")
            const gstEaseBalance = latestRows.filter(r => r.Sector !== "Grand Total")
                .reduce((sum, r) => sum + (r["Balance"] || 0), 0);

            const gstEaseSma = latestRows.filter(r => r.Sector !== "Grand Total")
                .reduce((sum, r) => sum + (r["SMA1+2"] || 0), 0);

            // Dynamic percentages
            const gstEasePct = latestTotal["Balance"] > 0
                ? ((gstEaseBalance / latestTotal["Balance"]) * 100).toFixed(2)
                : "0.00";

            const gstEaseSmaPct = latestTotal["SMA1+2"] > 0
                ? ((gstEaseSma / latestTotal["SMA1+2"]) * 100).toFixed(2)
                : "0.00";

            // Final description
            descriptions.push(`PSB GST Ease contributes ${gstEasePct}% of our total MSME Portfolio, SMA ${gstEaseSmaPct}% of total SMA in MSME portfolio.`);

            // ----- 4. NPA negligible -----
            descriptions.push(`NPA in the portfolio is almost negligible at ${npaPct} of total NPA under MSME portfolio.`);

            // ----- 5. SMA negligible -----
            descriptions.push(`Also, stressed assets in the form of SMA is also negligible under the segment.`);

            // ----- 6. Reduction in NPA & SMA -----
            if (parseFloat(latestTotal["NPA%"]) < parseFloat(prevTotal["NPA%"]) &&
                parseFloat(latestTotal["SMA1+2%"]) < parseFloat(prevTotal["SMA1+2%"])) {
            }
            descriptions.push(`During the quarter stress under the segment has also witnessed a reduction under both NPA & SMA segment signifying improvement in asset quality.`);

            // ----- 7. Yield dip -----
            const prevYield = parseFloat((prevTotal["Yield on Advances"] || "0").replace("%", ""));
            const latestYield = parseFloat((latestTotal["Yield on Advances"] || "0").replace("%", ""));
            if (!isNaN(prevYield) && !isNaN(latestYield)) {
                descriptions.push(`However, yield on advances has also reduced from ${prevYield}% in ${prevDate} to ${latestYield}% in ${latestDate}`);
            }
        }


        return { flattenedData, dates, descriptions };
    };

    const processContractor_plus = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // ---------- Group by date ----------
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            // ----- 1. Contribution (Balance, NPA, SMA) -----
            const schemeBal = latestTotal["Balance"];
            const schemeNpa = latestTotal["NPA"];
            const schemeSma = latestTotal["SMA1+2"];

            const overallBal = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["Balance"] : 0), 0);
            const overallNpa = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["NPA"] : 0), 0);
            const overallSma = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["SMA1+2"] : 0), 0);

            const contribPct = overallBal > 0 ? ((schemeBal / overallBal) * 100).toFixed(2) : "0.00";
            const npaPct = overallNpa > 0 ? ((schemeNpa / overallNpa) * 100).toFixed(2) : "0.00";
            const smaPct = overallSma > 0 ? ((schemeSma / overallSma) * 100).toFixed(2) : "0.00";

            descriptions.push(`Contractor plus Scheme contributes about ${contribPct}% of our total MSME Portfolio, NPA % stands at ${npaPct}% of total MSME NPA and SMA % is ${smaPct}% of total SMA in MSME portfolio.`);

            // ----- 2. Growth or Decline -----
            const growthPct = prevTotal["Balance"] > 0
                ? (((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            descriptions.push(`There is ${growthPct >= 0 ? "increase" : "decrease"} of ${Math.abs(growthPct)}% in the portfolio during the current quarter.`);

            // ----- 3. Highest SMA Zone -----
            const highestSmaZone = latestRows.filter(r => r.Sector !== "Grand Total")
                .sort((a, b) => parseFloat(b["SMA1+2%"]) - parseFloat(a["SMA1+2%"]))[0];
            if (highestSmaZone) {
                descriptions.push(`Although the exposure under the portfolio is negligible of the total MSME portfolio, SMA % in ${highestSmaZone.Sector} is highest at ${highestSmaZone["SMA1+2%"]}.`);
            }

            // ----- 4. Zone with no exposure -----
            const noExposureZones = latestRows.filter(r => r.Sector !== "Grand Total" && r["Balance"] === 0).map(z => z.Sector);
            noExposureZones.forEach(zone => {
                descriptions.push(`${zone} Zone is not having any exposure under the scheme.`);
            });

            // ----- 5. SMA Reduction Zones -----
            latestRows.forEach(latest => {
                const prev = prevRows.find(p => p.Sector === latest.Sector);
                if (prev && parseFloat(prev["SMA1+2%"]) > 0 && parseFloat(latest["SMA1+2%"]) === 0) {
                    descriptions.push(`SMA% of ${latest.Sector} zone has substantially reduced from ${prev["SMA1+2%"]} to ${latest["SMA1+2%"]} during the quarter.`);
                }
            });
        }


        return { flattenedData, dates, descriptions };
    };

    const processApnaGhar = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group data by reporting_date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const schemeBal = latestTotal["Balance"];
            const schemeNpa = latestTotal["NPA"];
            const schemeSma = latestTotal["SMA1+2"];

            const overallBal = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["Balance"] : 0), 0);
            const overallNpa = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["NPA"] : 0), 0);
            const overallSma = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["SMA1+2"] : 0), 0);

            const contribPct = overallBal > 0 ? ((schemeBal / overallBal) * 100).toFixed(2) : "0.00";
            const npaPct = overallNpa > 0 ? ((schemeNpa / overallNpa) * 100).toFixed(2) : "0.00";
            const smaPct = overallSma > 0 ? ((schemeSma / overallSma) * 100).toFixed(2) : "0.00";

            // 1️⃣ Portfolio contribution
            descriptions.push(
                `PSB APNA GHAR contributes ${contribPct}% of our total Retail Portfolio, NPA % stands at ${npaPct}% of total Retail NPA and SMA % is ${smaPct}% of total SMA in Retail portfolio.`
            );

            // 2️⃣ Portfolio growth
            const growthPct = prevTotal["Balance"] > 0
                ? (((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            const trend = growthPct >= 0 ? "increased" : "decreased";
            const fromAmt = prevTotal["Balance"].toLocaleString("en-IN", { minimumFractionDigits: 2 });
            const toAmt = latestTotal["Balance"].toLocaleString("en-IN", { minimumFractionDigits: 2 });
            descriptions.push(
                `PSB Apna Ghar Portfolio of the Bank has ${trend} from ₹${fromAmt} crore to ₹${toAmt} crore during the current quarter.`
            );

            // 3️⃣ SMA double-digit zones
            const doubleDigitSmaZones = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat(r["SMA1+2%"]) >= 10);
            descriptions.push(
                `${doubleDigitSmaZones.length} zones out of total ${latestRows.length - 1} zones are having SMA in double digits indicating the higher side of stress under the portfolio.`
            );

            // 4️⃣ NPA > 4%
            const highNpaZones = latestRows.filter(r => r.Sector !== "Grand Total" && parseFloat(r["NPA%"]) > 4);
            if (highNpaZones.length > 0) {
                const npaPercents = highNpaZones.map(z => parseFloat(z["NPA%"])).sort((a, b) => a - b);
                descriptions.push(
                    `${highNpaZones.length} zones are having NPA% more than 4%, ranges from ${npaPercents[0].toFixed(2)}% to ${npaPercents[npaPercents.length - 1].toFixed(2)}%.`
                );
            }

            // 5️⃣ Yield comparison (bps change)
            const prevYield = parseFloat(prevTotal["Yield on Advances"]) || 0;
            const latestYield = parseFloat(latestTotal["Yield on Advances"]) || 0;
            const yieldDiffBps = ((latestYield - prevYield) * 100).toFixed(0);
            descriptions.push(
                `Taking into consideration the revenue, yield under the portfolio has witnessed a ${yieldDiffBps < 0 ? "reduction" : "rise"} of around ${Math.abs(yieldDiffBps)} bps.`
            );

            // 6️⃣ Stress reduction
            descriptions.push(
                `From stress point of view, both NPA & SMA outstanding under the segment has witnessed a fall during the quarter.`
            );
        }

        return { flattenedData, dates, descriptions };
    };


    const processApnaGharVahan = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group data by reporting_date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const schemeBal = latestTotal["Balance"];
            const schemeNpa = latestTotal["NPA"];
            const schemeSma = latestTotal["SMA1+2"];

            const overallBal = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["Balance"] : 0), 0);
            const overallNpa = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["NPA"] : 0), 0);
            const overallSma = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["SMA1+2"] : 0), 0);

            const contribPct = overallBal > 0 ? ((schemeBal / overallBal) * 100).toFixed(2) : "0.00";
            const npaPct = overallNpa > 0 ? ((schemeNpa / overallNpa) * 100).toFixed(2) : "0.00";
            const smaPct = overallSma > 0 ? ((schemeSma / overallSma) * 100).toFixed(2) : "0.00";

            // 1️⃣ Portfolio contribution
            descriptions.push(
                `PSB APNA VAHAN contributes ${contribPct}% of our total Retail Portfolio, NPA % stands at ${npaPct}% of total Retail NPA and SMA % is ${smaPct}% of total SMA in Retail portfolio.`
            );

            // 2️⃣ Portfolio growth
            const growthAmt = (latestTotal["Balance"] - prevTotal["Balance"]).toFixed(2);
            const growthPct = prevTotal["Balance"] > 0
                ? (((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            const trend = growthPct >= 0 ? "increased" : "decreased";
            descriptions.push(
                `PSB APNA VAHAN Portfolio has ${trend} by ${Math.abs(growthPct)}% ( ₹${Math.abs(growthAmt)} Cr) during the Quarter.`
            );

            // 3️⃣ Identify zone under high stress (both NPA and SMA high)
            // 3️⃣ Identify zone under high stress (both highest NPA% and SMA%)
            const validZones = latestRows.filter(r => r.Sector !== "Grand Total");
            if (validZones.length > 0) {
                // Find the max NPA% and SMA% among all zones
                const maxNPA = Math.max(...validZones.map(r => parseFloat(r["NPA%"]) || 0));
                const maxSMA = Math.max(...validZones.map(r => parseFloat(r["SMA1+2%"]) || 0));

                // Find zone(s) having BOTH highest NPA% and SMA%
                const stressZones = validZones.filter(
                    r =>
                        parseFloat(r["NPA%"]) === maxNPA &&
                        parseFloat(r["SMA1+2%"]) === maxSMA
                );

                // Generate description line only if one or more zones match both
                if (stressZones.length > 0) {
                    stressZones.forEach(z => {
                        descriptions.push(
                            `${z.Sector} Zone is under high stress in terms of NPA (${z["NPA%"]}) and SMA (${z["SMA1+2%"]}) both.`
                        );
                    });
                }
            }

            // 4️⃣ NPA decrease but SMA increase
            const prevNPA = parseFloat(prevTotal["NPA%"]) || 0;
            const latestNPA = parseFloat(latestTotal["NPA%"]) || 0;
            const prevSMA = parseFloat(prevTotal["SMA1+2%"]) || 0;
            const latestSMA = parseFloat(latestTotal["SMA1+2%"]) || 0;

            // if (latestNPA < prevNPA && latestSMA > prevSMA) {
            descriptions.push(
                `Though NPA% has decreased during the quarter, an increase has been witnessed in SMA% leading to increase in stress under the segment`
            );
            // }
        }

        return { flattenedData, dates, descriptions };
    };


    const processPSBEducationLoan = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group data by reporting_date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const schemeBal = latestTotal["Balance"];
            const schemeNpa = latestTotal["NPA"];
            const schemeSma = latestTotal["SMA1+2"];
            const totalAdvances = latestTotal["Balance"];

            const overallBal = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["Balance"] : 0), 0);
            const overallNpa = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["NPA"] : 0), 0);
            const overallSma = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["SMA1+2"] : 0), 0);

            const contribPct = overallBal > 0 ? ((schemeBal / overallBal) * 100).toFixed(2) : "0.00";
            const npaPct = overallNpa > 0 ? ((schemeNpa / overallNpa) * 100).toFixed(2) : "0.00";
            const smaPct = overallSma > 0 ? ((schemeSma / overallSma) * 100).toFixed(2) : "0.00";

            // 1️⃣ Portfolio contribution
            descriptions.push(
                `Education Loan contributes merely ${contribPct}% to our total Retail Portfolio, NPA% stands at ${npaPct}% of total Retail NPA and SMA% is ${smaPct}% of total SMA in Retail portfolio.`
            );

            // 2️⃣ Portfolio growth
            const growthAmt = (latestTotal["Balance"] - prevTotal["Balance"]).toFixed(2);
            const growthPct = prevTotal["Balance"] > 0
                ? (((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            descriptions.push(
                `There is growth of about ${Math.abs(growthPct)}% in the portfolio during the quarter.`
            );

            // 3️⃣ Exposure in SMA category
            const totalSMA = latestTotal["SMA1+2"];
            const smaExposurePct = totalAdvances > 0 ? ((totalSMA / totalAdvances) * 100).toFixed(2) : "0.00";
            descriptions.push(
                `Out of total advance of ₹${totalAdvances.toFixed(2)} crore, Bank is having ₹${totalSMA.toFixed(2)} crore in SMA (1&2) category, which is almost ${smaExposurePct}% of the exposure.`
            );

            // 4️⃣ Highest NPA zone
            const validZones = latestRows.filter(r => r.Sector !== "Grand Total");
            if (validZones.length > 0) {
                const maxNPAZone = validZones.reduce((max, z) => (parseFloat(z["NPA%"]) > parseFloat(max["NPA%"]) ? z : max));
                descriptions.push(
                    `${maxNPAZone.Sector} zone is having highest NPA% of ${maxNPAZone["NPA%"]}.`
                );

                // 5️⃣ Zones with SMA% > 10%
                const zonesAbove10 = validZones.filter(z => parseFloat(z["SMA1+2%"]) > 10);
                descriptions.push(
                    `${zonesAbove10.length} zones out of ${validZones.length} zones are having SMA% more than 10%.`
                );
            }
        }

        return { flattenedData, dates, descriptions };
    };

    const processPSBGoldLoan = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group data by reporting_date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const schemeName = latestRows[0]?.Sector || "Gold Loan";

            const schemeBal = latestTotal["Balance"];
            const schemeNpa = latestTotal["NPA"];
            const schemeSma = latestTotal["SMA1+2"];
            const totalAdvances = latestTotal["Balance"];

            const overallBal = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["Balance"] : 0), 0);
            const overallNpa = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["NPA"] : 0), 0);
            const overallSma = latestRows.reduce((s, r) => s + (r.Sector !== "Grand Total" ? r["SMA1+2"] : 0), 0);

            const contribPct = overallBal > 0 ? ((schemeBal / overallBal) * 100).toFixed(2) : "0.00";
            const npaPct = overallNpa > 0 ? ((schemeNpa / overallNpa) * 100).toFixed(2) : "0.00";
            const smaPct = overallSma > 0 ? ((schemeSma / overallSma) * 100).toFixed(2) : "0.00";

            // 1️⃣ Portfolio contribution
            descriptions.push(
                `Gold Loan contributes only ${contribPct}% to our total Retail Portfolio, NPA% stands at ${npaPct}% of total Retail NPA and SMA% is ${smaPct}% of total SMA in Retail portfolio.`
            );

            // 2️⃣ Portfolio growth
            const growthAmt = (latestTotal["Balance"] - prevTotal["Balance"]).toFixed(2);
            const growthPct = prevTotal["Balance"] > 0
                ? (((latestTotal["Balance"] - prevTotal["Balance"]) / prevTotal["Balance"]) * 100).toFixed(2)
                : "0.00";
            descriptions.push(
                `There is ${Math.abs(growthPct)}% ${growthPct >= 0 ? "increase" : "decrease"} in the ${schemeName} portfolio during the quarter.`
            );

            // 3️⃣ Stress (NPA + SMA) change
            const prevStress = parseFloat(prevTotal["NPA%"]) + parseFloat(prevTotal["SMA1+2%"]);
            const latestStress = parseFloat(latestTotal["NPA%"]) + parseFloat(latestTotal["SMA1+2%"]);
            if (!isNaN(prevStress) && !isNaN(latestStress)) {
                const stressTrend = latestStress < prevStress ? "decreased" : "increased";
                descriptions.push(
                    `Amount of stress under ${schemeName} portfolio (having NPA and SMA) has ${stressTrend} from ${prevStress.toFixed(2)}% to ${latestStress.toFixed(2)}% during the quarter under study.`
                );
            }

            // 4️⃣ Zones with SMA% > 10%
            const validZones = latestRows.filter(r => r.Sector !== "Grand Total");
            if (validZones.length > 0) {
                const zonesAbove10 = validZones.filter(z => parseFloat(z["SMA1+2%"]) > 10);
                const prevZonesAbove10 = prevRows.filter(r => r.Sector !== "Grand Total" && parseFloat(r["SMA1+2%"]) > 10);
                descriptions.push(
                    `${zonesAbove10.length} out of ${validZones.length} zones are having SMA more than 10% depicting high stress as against ${prevZonesAbove10.length} zones in SMA during last quarter.`
                );
            }
        }

        return { flattenedData, dates, descriptions };
    };

    const processPSBPersonalLoan = (jsonData) => {
        let result = {};
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };

        // ---------- Helper for totals ----------
        const calculateTotals = (rows, label = "Grand Total") => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalInterest = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalInterest += Number(r["INTEREST"] || 0); // crores
            });

            const totalSma1plus2 = totalSma1 + totalSma2;
            const yieldOnAdvances =
                totalBalance > 0
                    ? (
                        (rows.reduce((sum, r) =>
                            sum + (Number(r["Balance"] || 0) * parseFloat(r["Yield on Advances"] || 0)), 0
                        ) / totalBalance)
                    ).toFixed(2) + "%"
                    : "0.00%";

            return {
                Sector: label,
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": yieldOnAdvances, // correct weighted yield
                INTEREST: totalInterest,
                type: "grandtotal"
            };
        };

        // Group data by reporting_date
        if (Array.isArray(jsonData)) {
            jsonData.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                if (!result[date]) result[date] = [];

                const os_balance = toCrores(item.os_balance);
                const npa = toCrores(item.npa);
                const sma1 = toCrores(item.sma1);
                const sma2 = toCrores(item.sma2);
                const sma1plus2 = sma1 + sma2;
                const yieldvalue = item.roi; // keep original for logging

                const roiPercent = toCrores(item.roi || 0); // ROI in %
                const interest = (os_balance * (roiPercent / 100)); // Interest income in crores
                const yieldOnAdvances = ((interest / os_balance) * 100).toFixed(2) + "%"; // same as ROI%

                result[date].push({
                    Sector: item.rep_param,
                    "Balance": os_balance,
                    NPA: npa,
                    "NPA%": os_balance > 0 ? ((npa / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": os_balance > 0 ? ((sma1 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": os_balance > 0 ? ((sma2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": os_balance > 0 ? ((sma1plus2 / os_balance) * 100).toFixed(2) + "%" : "0.00%",
                    // "Yield on Advances": yieldOnAdvances,
                    INTEREST: interest,
                    "Yield on Advances": yieldvalue ? `${yieldvalue}%` : "0.00%",
                });
            });
        }

        // ---------- Add Grand Totals ----------
        Object.keys(result).forEach(date => {
            const rows = result[date];
            const filteredRows = rows.filter(r => r.Sector !== "Grand Total");
            const grandTotal = calculateTotals(filteredRows, "Grand Total");
            result[date] = [...filteredRows, grandTotal];
        });

        // ---------- Flatten ----------
        let flattenedData = [];
        Object.entries(result).forEach(([date, rows]) => {
            rows.forEach(r => flattenedData.push({ Date: date, ...r }));
        });

        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        // ---------- Generate Descriptions ----------
        const dates = Object.keys(result).sort();
        let descriptions = [];

        if (dates.length >= 2) {
            const [prevDate, latestDate] = dates.slice(-2);
            const prevRows = flattenedData.filter(r => r.Date === prevDate);
            const latestRows = flattenedData.filter(r => r.Date === latestDate);

            const prevTotal = prevRows.find(r => r.Sector === "Grand Total") || {};
            const latestTotal = latestRows.find(r => r.Sector === "Grand Total") || {};

            const schemeName = latestRows[0]?.Sector || "Personal Loan";

            // --- Portfolio Contribution ---
            const overallBal = latestRows.reduce((sum, r) => sum + (r.Sector !== "Grand Total" ? r["Balance"] : 0), 0);
            const overallNpa = latestRows.reduce((sum, r) => sum + (r.Sector !== "Grand Total" ? r["NPA"] : 0), 0);
            const overallSma = latestRows.reduce((sum, r) => sum + (r.Sector !== "Grand Total" ? r["SMA1+2"] : 0), 0);

            const contribPct = overallBal > 0 ? ((latestTotal["Balance"] / overallBal) * 100).toFixed(2) : "0.00";
            const npaPct = overallNpa > 0 ? ((latestTotal["NPA"] / overallNpa) * 100).toFixed(2) : "0.00";
            const smaPct = overallSma > 0 ? ((latestTotal["SMA1+2"] / overallSma) * 100).toFixed(2) : "0.00";

            descriptions.push(
                `PSB Personal Loan contributes merely ${contribPct}% to our total Retail Portfolio, NPA% stands at ${npaPct}% of total Retail NPA and SMA% is ${smaPct}% of total SMA in Retail portfolio.`
            );

            // --- Portfolio Growth ---
            const prevBal = prevTotal["Balance"] || 0;
            const latestBal = latestTotal["Balance"] || 0;
            const growthPct = prevBal > 0 ? (((latestBal - prevBal) / prevBal) * 100).toFixed(2) : "0.00";
            const trendWord = growthPct >= 0 ? "increased" : "decreased";

            descriptions.push(
                `Personal Loan portfolio of the bank has ${trendWord} during the quarter from ₹${prevBal.toFixed(2)} crore to ₹${latestBal.toFixed(2)} crore as on ${latestDate} equivalent to ${Math.abs(growthPct)}% ${trendWord}.`
            );
        }

        return { flattenedData, dates, descriptions };

    };

    const processRatingComparison = (jsonData) => {
        if (!Array.isArray(jsonData)) {
            return { flattenedData: [], dates: [], descriptions: [] };
        }

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };
        // Extract unique reporting dates
        const dates = [...new Set(jsonData.map(item => item.reporting_date))];

        // Flattened structure for easy table mapping
        const flattenedData = jsonData.map((item) => ({
            Sr_No: item.Sr_No,
            NAME: item.NAME || "",
            Balance_as_on: toCrores(item.Balance_as_on ?? 0),
            Rating_Curr: item.Rating_Curr || "",
            Rating_Prev: item.Rating_Prev || "",
            reporting_date: item.reporting_date || ""
        }));

        return { flattenedData, dates, descriptions: [] };
    };

    const processOffBalancesheet = (jsonData, fromDate, toDate) => {
        if (!Array.isArray(jsonData)) return { flattenedData: [], dates: [], descriptions: [] };

        const normalizeDate = (date) => {
            if (!date) return "";
            if (typeof date === "string") return date.split("T")[0];
            return new Date(date).toISOString().split("T")[0];
        };

        const toCrores = (val) => Number((Number(val || 0) / 10000000).toFixed(2));

        // ---------- Extract Dates ----------
        const dates = [...new Set(jsonData.map(i => i.reporting_date))].sort();
        const startDate = fromDate || dates[0];
        const endDate = toDate || dates[dates.length - 1];

        const flattenedData = [];
        const grouped = jsonData.reduce((acc, item) => {
            if (!acc[item.rep_type]) acc[item.rep_type] = [];
            acc[item.rep_type].push(item);
            return acc;
        }, {});

        let grandPrev = 0, grandCurr = 0;

        // ---------- Build Table ----------
        Object.entries(grouped).forEach(([repType, items]) => {
            flattenedData.push({
                Sr_No: "", Rep_Type: repType === "BG" ? "Bank Guarantees" : "Letter of Credit",
                BG_LC_Type: "", Scheme_Desc: "", type: "header"
            });

            const schemes = [...new Set(items.map(i => i.bg_lc_type))];
            let subPrev = 0, subCurr = 0;

            schemes.forEach((scheme, idx) => {
                const schemeData = items.filter(i => i.bg_lc_type === scheme);
                const desc = schemeData[0]?.scheme_desc || "";

                const prevObj = schemeData.find(i => normalizeDate(i.reporting_date) === normalizeDate(startDate));
                const currObj = schemeData.find(i => normalizeDate(i.reporting_date) === normalizeDate(endDate));

                const prev = toCrores(prevObj?.os_balance || 0);
                const curr = toCrores(currObj?.os_balance || 0);
                const change = Number((curr - prev).toFixed(2));

                subPrev += prev;
                subCurr += curr;

                flattenedData.push({
                    Sr_No: idx + 1,
                    Rep_Type: repType,
                    BG_LC_Type: scheme,
                    Scheme_Desc: desc,
                    Prev_Value: prev,
                    Curr_Value: curr,
                    Change: change,
                    type: "data"
                });
            });

            flattenedData.push({
                Sr_No: "", Scheme_Desc: "Sub Total",
                Prev_Value: subPrev, Curr_Value: subCurr, Change: Number((subCurr - subPrev).toFixed(2)),
                type: "subtotal"
            });

            grandPrev += subPrev;
            grandCurr += subCurr;
        });

        flattenedData.push({
            Sr_No: "", Scheme_Desc: "Grand Total",
            Prev_Value: grandPrev, Curr_Value: grandCurr,
            Change: Number((grandCurr - grandPrev).toFixed(2)),
            type: "grandtotal"
        });

        // ---------- Generate Descriptions ----------
        let descriptions = [];
        const changeCr = Number((grandCurr - grandPrev).toFixed(2));
        const changeWord = changeCr >= 0 ? "increase" : "decrease";

        descriptions.push(
            `During the last quarter of FY${new Date(endDate).getFullYear() - 1}-${String(new Date(endDate).getFullYear()).slice(-2)}, the Bank has witnessed ${changeWord} of around ₹${Math.abs(changeCr)} crore in BG/LC business of the Bank.`
        );

        // Find % of No Cash Margin vs Total Non-Fund (if applicable in data)
        const bgLcTotal = grandCurr;
        if (bgLcTotal > 0) {
            descriptions.push(
                `As on ${endDate}, Bank’s off-balance sheet exposure stood at ₹${grandCurr.toFixed(2)} crore, indicating ${changeWord} of ₹${Math.abs(changeCr).toFixed(2)} crore compared to ₹${grandPrev.toFixed(2)} crore as on ${startDate}.`
            );
        }

        descriptions.push(
            `Bank continues its efforts to improve cash margin and reduce non-fund based exposure under BG/LC facilities.`
        );

        return { flattenedData, dates, descriptions };
    };


    const processRatingDowngraded = (jsonData) => {
        if (!Array.isArray(jsonData)) {
            return { flattenedData: [], dates: [], descriptions: [] };
        }

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };
        // Extract unique reporting dates
        const dates = [...new Set(jsonData.map(item => item.reporting_date))];

        // Flattened structure for easy table mapping
        const flattenedData = jsonData.map((item) => ({
            Sr_No: item.Sr_No,
            NAME: item.NAME || "",
            Balance_as_on: toCrores(item.Balance_as_on ?? 0),
            Rating_Curr: item.Rating_Curr || "",
            Rating_Prev: item.Rating_Prev || "",
            reporting_date: item.reporting_date || ""
        }));

        return { flattenedData, dates, descriptions: [] };
    };

    const processRatingMigration = (jsonData) => {
        if (!Array.isArray(jsonData)) {
            return { flattenedData: [], dates: [], descriptions: [] };
        }

        // Identify all rating columns dynamically
        const allRatings = Array.from(
            new Set(jsonData.flatMap(item => Object.keys(item.current_distribution)))
        );

        const rows = jsonData.map(item => {
            const row = {
                Previous_Rating: item.previous_rating,
                Total_Accounts: item.total_accounts,
            };

            // Fill rating columns
            allRatings.forEach(r => {
                row[r] = item.current_distribution[r] || 0;
            });

            // Calculate derived fields
            const sumRatings = allRatings.reduce((acc, r) => acc + (row[r] || 0), 0);
            const closed = Math.max(item.total_accounts - sumRatings, 0);
            const npa = item.npa || 0; // if NPA count available per rating, else keep as 0
            const balanceAccounts = sumRatings;
            const defaultRate = ((npa / item.total_accounts) * 100).toFixed(1) + "%";
            const stabilityValue = row[item.previous_rating] || 0;
            const stabilityRate =
                item.total_accounts > 0
                    ? ((stabilityValue / item.total_accounts) * 100).toFixed(2) + "%"
                    : "0%";

            row["Closed"] = closed;
            row["NPA"] = npa;
            row["Balance Accounts"] = balanceAccounts;
            row["Default Rate"] = defaultRate;
            row["Stability Rate"] = stabilityRate;

            return row;
        });

        // ---- GRAND TOTAL ROW ----
        const grandTotalRow = {
            Previous_Rating: "Grand Total",
        };

        grandTotalRow.Total_Accounts = rows.reduce((a, r) => a + (r.Total_Accounts || 0), 0);

        allRatings.forEach(r => {
            grandTotalRow[r] = rows.reduce((a, r2) => a + (r2[r] || 0), 0);
        });

        grandTotalRow["Closed"] = rows.reduce((a, r) => a + (r["Closed"] || 0), 0);
        grandTotalRow["NPA"] = rows.reduce((a, r) => a + (r["NPA"] || 0), 0);
        grandTotalRow["Balance Accounts"] = rows.reduce((a, r) => a + (r["Balance Accounts"] || 0), 0);

        grandTotalRow["Default Rate"] = "";
        grandTotalRow["Stability Rate"] = "";

        // ---- Overall Rating Stability ----
        const stableSum = rows.reduce((acc, r) => {
            const matchVal = r[r.Previous_Rating] || 0;
            return acc + matchVal;
        }, 0);

        const totalAccountsSum = rows.reduce((acc, r) => acc + (r.Total_Accounts || 0), 0);

        const overallStability =
            totalAccountsSum > 0
                ? (Math.floor((stableSum / totalAccountsSum) * 10000) / 100).toFixed(2) + "%"
                : "0%";

        setOverallStability(overallStability);

        const flattenedData = [...rows, grandTotalRow];

        // ---- Dynamic Descriptions ----
        const descriptions = [];

        // ✅ 1. Overall stability statement

        // ✅ 2. NPA migration statement
        const totalNPA = grandTotalRow["NPA"] || 0;
        descriptions.push(`${totalNPA} account${totalNPA !== 1 ? "s" : ""} migrated to NPA category.`);

        // ✅ 3. Static explanation (same for all)
        descriptions.push(
            "Calculation of Overall rating stability has been done after excluding closed accounts."
        );

        return { flattenedData, overallStability, dates: [], descriptions };
    };



    const processRatingTurned = (jsonData) => {
        if (!Array.isArray(jsonData)) {
            return { flattenedData: [], dates: [], descriptions: [] };
        }

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000;
            return Number(num.toFixed(2));
        };
        // Extract unique reporting dates
        const dates = [...new Set(jsonData.map(item => item.reporting_date))];

        // Flattened structure for easy table mapping
        const flattenedData = jsonData.map((item) => ({
            Sr_No: item.Sr_No,
            NAME: item.NAME || "",
            Balance_as_on: toCrores(item.Balance_as_on ?? 0),
            Rating_Curr: item.Rating_Curr || "",
            Rating_Prev: item.Rating_Prev || "",
            reporting_date: item.reporting_date || ""
        }));

        return { flattenedData, dates, descriptions: [] };
    };

    const processMajorCreditProposals = (jsonData) => {
        if (!Array.isArray(jsonData)) {
            return { flattenedData: [], dates: [], descriptions: [] };
        }

        const toCrores = (val) => {
            const num = Number(val);
            return isNaN(num) ? 0 : Number((num / 10000000).toFixed(2));
        };


        const flattenedData = jsonData.map(item => ({
            borrower: item.borrower || "",
            totalExposureCr: toCrores(item.total_exposure_crore), // ✅ Converted to crores
            activity: item.activity || "",
            externalRating: item.external_rating || ""
        }));

        return { flattenedData, dates: [], descriptions: [] };
    };

    const processPortfolioQuality = (jsonData) => {
        if (!Array.isArray(jsonData)) {
            return { flattenedData: [], dates: [], descriptions: [] };
        }

        // Flatten and format data
        const flattenedData = jsonData.map((item, index) => ({
            Sr_No: index + 1,
            Period: item.Period || "",
            "Portfolio Quality Index": Number(item.Portfolio_Quality_Index || 0),
        }));

        const dates = flattenedData.map(d => d.Period);

        // Get latest & previous values
        const latestData = flattenedData[flattenedData.length - 1];
        const previousData = flattenedData[flattenedData.length - 2];

        const latestPeriod = latestData?.Period || "";
        const latestPQI = latestData?.["Portfolio Quality Index"]?.toFixed(2) || "0.00";
        const prevPQI = previousData?.["Portfolio Quality Index"]?.toFixed(2) || null;

        // Determine PQI trend
        let trendText = "";
        if (prevPQI) {
            if (latestData["Portfolio Quality Index"] < previousData["Portfolio Quality Index"]) {
                trendText = "has improved compared to the previous quarter";
            } else if (latestData["Portfolio Quality Index"] > previousData["Portfolio Quality Index"]) {
                trendText = "has slightly weakened compared to the previous quarter";
            } else {
                trendText = "has remained stable compared to the previous quarter";
            }
        }

        // Single-line paragraph description
        const descriptionText = `As apparent in the graph above, the PQI has been consistently on the lower side (the lower the better)., In ${latestPeriod}, the PQI is at the level of ${latestPQI} and ${trendText}., A lower PQI can be attributed to a higher concentration of exposure in top-rated categories (AAA, AA, A), as it indicates better credit quality., Undertaking high-rated exposure and/or recovery of NPAs would further help to improve the PQI of the portfolio.`;

        return { flattenedData, dates, descriptions: [descriptionText] };
    };



    const processBanksCreditProposals = (jsonData) => {
        if (!jsonData || !Array.isArray(jsonData)) {
            console.warn("⚠️ Invalid or missing Report16 data");
            return { flattenedData: [], dates: [], descriptions: [] };
        }
        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000; // 1 crore = 10 million
            return Number(num.toFixed(2));
        };
        // --- Flatten the core data ---
        const flattenedData = jsonData.map(item => ({
            rep_param: item.rep_param || "",           // NBFC Sub-sector
            reporting_date: item.reporting_date || "", // Reporting date
            os_balance: toCrores(item.os_balance),     // ✅ Total Exposure in Crores
            roi: Number(item.roi) || 0,                // % to Total Exposure
            npa: toCrores(item.npa),                   // ✅ Total NPA in Crores
            npa_percent: Number(item.npa_percent) || 0 // NPA %
        }));

        // --- Extract unique reporting dates ---
        const dates = [...new Set(flattenedData.map(d => d.reporting_date))].sort();

        // --- Group by date for summary ---
        const grouped = {};
        dates.forEach(date => {
            grouped[date] = flattenedData.filter(d => d.reporting_date === date);
        });

        // --- Generate descriptive insights ---
        const descriptions = [];

        if (dates.length >= 1) {
            const latestDate = dates[dates.length - 1];
            const latestRows = grouped[latestDate];

            // 1️⃣ Total exposure % of NBFC
            const nbfcTotalRow = latestRows.find(r => r.rep_param.toLowerCase().includes("nbfc total"));
            const totalExposurePct = nbfcTotalRow ? nbfcTotalRow.roi : 0;

            descriptions.push(
                `The total exposure to NBFC sector stands at ${totalExposurePct.toFixed(2)}% of the Bank’s total exposure which is well within the prescribed internal limit of 18%.`
            );

            // 2️⃣ Compare total exposure change (if at least 2 dates)
            if (dates.length >= 2) {
                const prevDate = dates[dates.length - 2];
                const prevRows = grouped[prevDate];
                const prevTotal = prevRows.find(r => r.rep_param.toLowerCase().includes("nbfc total"));
                const latestTotal = nbfcTotalRow;

                if (prevTotal && latestTotal) {
                    const diff = latestTotal.os_balance - prevTotal.os_balance;
                    const changePct = prevTotal.os_balance > 0 ? ((diff / prevTotal.os_balance) * 100).toFixed(2) : 0;
                    const trend = diff < 0 ? "fall" : "rise";
                    const absChange = Math.abs(changePct);

                    // Try to identify IFC or SREI dynamic note if exists
                    const ifcRow = latestRows.find(r => r.rep_param.toLowerCase().includes("ifc"));
                    const ifcNpaPct = ifcRow ? ifcRow.npa_percent : null;

                    descriptions.push(
                        `Exposure under NBFC sector has witnessed a ${trend} of ${absChange}% between ${prevDate} and ${latestDate}` +
                        (ifcRow
                            ? `, majorly led by IFC borrower(s) showing NPA level of ${ifcNpaPct.toFixed(2)}%.`
                            : ".")
                    );
                }
            }
        }

        return { flattenedData, dates, descriptions };
    };

    const processSnapshotExternalProposals = (jsonData) => {
        if (!jsonData || !Array.isArray(jsonData)) {
            console.warn("⚠️ Invalid or missing Report17 data");
            return { flattenedData: [], dates: [], descriptions: [] };
        }

        const toCrores = (val) => {
            const num = Number(val || 0) / 10000000; // 1 crore = 10 million
            return Number(num.toFixed(2));
        };

        // --- Flatten the core data ---
        const flattenedData = jsonData.map(item => ({
            rep_param: item.rep_param || "",
            reporting_date: item.reporting_date || "",
            os_balance: toCrores(item.os_balance),
            npa_percent: Number(item.percentage) || 0,
            rating: item.rating || item.credit_rating || "" // Include rating if available
        }));

        // --- Extract unique reporting dates ---
        const dates = [...new Set(flattenedData.map(d => d.reporting_date))].sort();

        // --- Group by date for summary ---
        const grouped = {};
        dates.forEach(date => {
            grouped[date] = flattenedData.filter(d => d.reporting_date === date);
        });

        // --- Generate descriptive insights ---
        const descriptions = [];

        if (dates.length >= 1) {
            const latestDate = dates[dates.length - 1];
            const latestRows = grouped[latestDate];

            // 1️⃣ Total exposure % of NBFC
            const nbfcTotalRow = latestRows.find(r => r.rep_param.toLowerCase().includes("nbfc total"));
            const totalExposurePct = nbfcTotalRow ? nbfcTotalRow.roi || 0 : 0;

            // 3️⃣ Calculate % of exposure rated "A" & above
            const ratedRows = latestRows.filter(r => r.rating);
            // if (ratedRows.length > 0) {
            const totalExposure = ratedRows.reduce((sum, r) => sum + r.os_balance, 0);

            // Define acceptable high-grade ratings
            const highGrades = ["AAA", "AA+", "AA", "AA-", "A+", "A"];
            const highRatedExposure = ratedRows
                .filter(r => highGrades.some(g => r.rating.toUpperCase().startsWith(g)))
                .reduce((sum, r) => sum + r.os_balance, 0);

            const highRatedPct = totalExposure > 0 ? ((highRatedExposure / totalExposure) * 100).toFixed(2) : 0;

            descriptions.push(
                `The above table depicts that majority of the NBFC Portfolio is mainly concentrated in top rated borrowers since approximately ${highRatedPct}% of the total exposure is 'A' & above rated borrowers.`
            );

            descriptions.push(
                `This indicates that the portfolio attracts a lower risk weight and in turn consumes lower amount of capital.`
            );
            // }
        }

        return { flattenedData, dates, descriptions };
    };


    const tableDisplayMap = {
        "Sector Wise Advances Portfolio": "accounting_code",
        "Geographical Concentration": "accounting_data",
        "Zone wise Concentration": "actcust",
        "Analysis of Co-Lending Segment": "additional_gl_balance",
        "Analysis of Co-Lending, Retail Segment": "distribution_exposure",
        "Analysis of Co-Lending, MSME Segment": "exchange_rates",
        "Analysis of Direct Assignment Pool": "fully_unavailed_tl",
        "Analysis of RAM Segment": "report9",
        "MSME Seg, Zone-wise Bifurcation": "report13",
        "MSME Seg, Product Wise Bifurcation, PSB VYAPAR LOAN": "investment_depreciationamount",
        "MSME Seg, Product Wise Bifurcation, PSB SME LTQUTD PLUS": "rating_override",
        "MSME Seg, Product Wise Bifurcation, PSB MORTGAGE LOAN": "pf_superannuation",
        "MSME Seg, Product Wise Bifurcation, PSB GST EASE": "balance_sheet",
        "MSME Seg, Product Wise Bifurcation, MUDRA Loan": "profit_flag",
        "MSME Seg, Product Wise Bifurcation, CONTRACTOR PLUS": "bulkdatarecords4",
        "MSME Seg, Product Wise Bifurcation, GECL": "bulkdatarecords5",
        "MSME Seg, Product Wise Bifurcation, Other MSME": "bulkdatarecords6",
        "MSME Seg, Product Wise Bifurcation, Other MSME (Product Wise above 200 crore)": "bulkrecordsupload",
        "Retail Seg, Zone-wise Bifurcation": "bulkuploads56",
        "Retail Advances, Product Wise Bifurcation, PSB APNA GHAR": "report",
        "Retail Advances, Product Wise Bifurcation, PSB APNA VAHAN": "report3",
        "Retail Advances, Product Wise Bifurcation, PSB EDUCATION LOAN": "report4",
        "Retail Advances, Product Wise Bifurcation, PSB GOLD LOAN": "report5",
        "Retail Advances, Product Wise Bifurcation, PSB PERSONAL LOAN": "report6",
        "Retail Advances, Product Wise Bifurcation, Other Retail": "report7",
        "Retail Advances, Product Wise Bifurcation, Other Retail (Product Wise above 200 crore)": "report8",
        "Agriculture Seg, Zone-wise Bifurcation": "restructured_data",
        "Agriculture Advances, Product Wise Bifurcation, KCC": "unavailed_data",
        "Agriculture Advances, Product Wise Bifurcation, Other Agricultural": "report10",
        "Agriculture Advances, Product Wise Bifurcation, Other Agricultural (Product Wise above 100 crore)": "report11",
        "Renewable Energy Advances": "report14",
        "Off Balance Sheet Exposure, Bank Guarantee & Letter of Credit": "unavailed_data8",
        "Off Balance Sheet Exposure, Restructured advances": "unavailed_data8", // You might need separate handling for this
        "Trend of Bank's Credit Exposure (Funded) to NBFCs": "interactive1",
        // "Major credit proposals to NBFCs sanctioned": "report15",
        // "Bank's Exposure to NBFCs based on composition": "report16",
        "Snapshot of External rating distribution of NBFC Portfolio": "npa_test1",
        "Portfolio Quality Index (PQI)": "report23",
        "External Rating Position": "reportmart",
        "Rating Migration and Distribution": "unavailed_data1",
        "Rating Migration of Government Guaranteed Borrowers": "unavailed_data1", // You might need separate handling
        "Major Changes, List of Major Borrowers where External rating were downgraded": "report21",
        "Major Changes, List of Major Borrowers where External rating were upgraded": "report20",
        "Major Changes, List of Major Borrowers turned to NPA": "report22"
    };

    // const tableDisplayMap = {
    //     "accounting_code": "Sector Wise Advances Portfolio",
    //     "accounting_data": "Geographical Concentration",
    //     "actcust": "Zone wise Concentration",
    //     "additional_gl_balance": "Analysis of Co-Lending Segment",
    //     "distribution_exposure": "Analysis of Co-Lending, Retail Segment",
    //     "exchange_rates": "Analysis of Co-Lending, MSME Segment",
    //     "fully_unavailed_tl": "Analysis of Direct Assignment Pool",
    //     "investment_depreciationamount": "MSME Seg, Product Wise Bifurcation, PSB VYAPAR LOAN",
    //     "pf_superannuation": "MSME Seg, Product Wise Bifurcation, PSB MORTGAGE LOAN",
    //     "profit_flag": "MSME Seg, Product Wise Bifurcation, MUDRA Loan",
    //     "rating_override": "MSME Seg, Product Wise Bifurcation, PSB SME LTQUTD PLUS",
    //     "restructured_data": "Agriculture Seg, Zone-wise Bifurcation",
    //     "unavailed_data": "Agriculture Advances, Product Wise Bifurcation, KCC",
    //     "report10": "Agriculture Advances, Product Wise Bifurcation, Other Agricultural",
    //     "report11": "Agriculture Advances, Product Wise Bifurcation, Other Agricultural (Product Wise above 100 crore)",
    //     "report14": "Renewable Energy Advances",
    //     "balance_sheet": "MSME Seg, Product Wise Bifurcation, PSB GST EASE",
    //     "bulkdatarecords4": "MSME Seg, Product Wise Bifurcation, CONTRACTOR PLUS",
    //     "report": "Retail Advances, Product Wise Bifurcation, PSB APNA GHAR",
    //     "report3": "Retail Advances, Product Wise Bifurcation, PSB APNA VAHAN",
    //     "report4": "Retail Advances, Product Wise Bifurcation, PSB EDUCATION LOAN",
    //     "report5": "Retail Advances, Product Wise Bifurcation, PSB GOLD LOAN",
    //     "report6": "Retail Advances, Product Wise Bifurcation, PSB PERSONAL LOAN",
    //     "report7": "Retail Advances, Product Wise Bifurcation, Other Retail",
    //     "report9": "Analysis of RAM Segment",
    //     "bulkdatarecords5": "MSME Seg, Product Wise Bifurcation, GECL",
    //     "bulkdatarecords6": "MSME Seg, Product Wise Bifurcation, Other MSME",
    //     "bulkrecordsupload": "MSME Seg, Product Wise Bifurcation, Other MSME (Product Wise above 200 crore)",
    //     "report8": "Retail Advances, Product Wise Bifurcation, Other Retail (Product Wise above 200 crore)",
    //     "bulkuploads56": "Retail Seg, Zone-wise Bifurcation",
    //     "report13": "MSME Segment (Zone-wise Bifurcation)",
    //     "report15": "Major credit proposals to NBFCs sanctioned",
    //     "report16": "Bank's Exposure to NBFCs based on composition",
    //     "report20": "List of Major Borrowers",
    //     "report21": "Major Changes, List of Major Borrowers where External rating were downgraded",
    //     "report22": "Major Changes, List of Major Borrowers turned to NPA",
    //     "report23": "Portfolio Quality Index (PQI)",
    //     "unavailed_data1": "Rating Migration and Distribution",
    //     "interactive1": "Trend of Bank's Credit Exposure (Funded) to NBFCs",
    //     "unavailed_data8": "Off Balance Sheet Exposure, Bank Guarantee & Letter of Credit",
    //     "npa_test1": "Snapshot of External rating distribution of NBFC Portfolio",
    //     "reportmart": "External Rating Position"
    // };

    // useEffect(() => {
    //     const fetchReportData = async () => {
    //         if (!fromDate || !toDate || !department) return; // wait until dates & department exist

    //         // setIsReportLoading(true);

    //         try {

    //             const apiConfig = {
    //                 params: {
    //                     p_prev_date: fromDate,
    //                     p_curr_date: toDate,
    //                     dept: department
    //                 },
    //                 headers: {
    //                     userId,
    //                     "x-csrf-token": csrfToken
    //                 },
    //                 withCredentials: true
    //             };

    //             const apiResponse = await axios.post(portfolioReport, {}, apiConfig);
    //             if (apiResponse.status === 200) {
    //             const response = await fetch(`/jsonfiles/Gapsphere_Portfolio_Report.json`);
    //             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    //             const jsonData = await response.json();
    //             console.log("Fetched report data:", jsonData);
    //             setReportData(jsonData);
    //             } else {
    //                 console.error("API call failed with status:", apiResponse.status);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching report data:", error);
    //         } finally {
    //             // setIsReportLoading(false);
    //         }
    //     };

    //     fetchReportData();
    // }, [fromDate, toDate, department]);


    const hasFetchedData = useRef(false);

    useEffect(() => {
        const fetchReportData = async () => {
            if (!fromDate || !toDate || !department || hasFetchedData.current) return;

            setIsLoading(true);

            try {
                const apiConfig = {
                    params: {
                        p_prev_date: fromDate,
                        p_curr_date: toDate,
                        dept: department
                    },
                    headers: {
                        userId,
                        "x-csrf-token": csrfToken
                    },
                    withCredentials: true
                };

                // const apiResponse = await axios.post(portfolioReport, {}, apiConfig);
                // if (apiResponse.status === 200) {
                const response = await fetch(`/jsonfiles/Gapsphere_Portfolio_Report.json`);
                if (!response.ok) throw new Error(`Report is not available`);
                const jsonData = await response.json();
                console.log("Fetched report data:", jsonData);
                setReportData(jsonData);
                hasFetchedData.current = true; // Mark as fetched
                // } else {
                //     console.error("API call failed with status:", apiResponse.status);
                // }
            } catch (error) {
                console.error("Error fetching report data:", error);
            }
            setIsLoading(false);
        };

        fetchReportData();
    }, [fromDate, toDate, department]);

    useEffect(() => {
        // When WebSocket descriptions update and we have a selected report
        if (selectedName && Object.keys(wsAIDescriptions).length > 0) {
            const suffixToKeyMap = {
                // ... your mapping object
            };

            const repType = suffixToKeyMap[selectedName];
            if (repType && wsAIDescriptions[repType]) {
                setNpaDescription(wsAIDescriptions[repType]);
                console.log(`Updated description from WebSocket for ${repType}`);
            }
        }
    }, [wsAIDescriptions, selectedName]);

    const suffixToKeyMap = {
        "accounting_code": "sector",
        "accounting_data": "region",
        "actcust": "zonewise",
        "report9": "ramseg",
        "additional_gl_balance": "colendseg",
        "distribution_exposure": "colendretseg",
        "exchange_rates": "colendmsmeseg",
        "investment_depreciationamount": "prodwiseBifVyaparLoan",
        "pf_superannuation": "prodwiseBifMortgageLoan",
        "profit_flag": "prodwiseBifMudraLoan",
        "fully_unavailed_tl": "directAsgnmtPool",
        "rating_override": "prodwiseBifSmeLiqPlus",
        "restructured_data": "agriSegiZonewiseBifurcation",
        "unavailed_data": "agriProdwiseKcc",
        "report10": "agriProdwiseOther",
        "report11": "agriProdwiseOtherAbovr100cr",
        "report14": "renewable_energy_adv",
        "balance_sheet": "prodwiseBifGstEase",
        "bulkdatarecords4": "prodwiseBifContractorPlus",
        "report3": "retSegProdwiseBifvehicleLoan",
        "report4": "retSegProdwiseBifEducationLoan",
        "report5": "retSegProdwiseBifGoldLoan",
        "report6": "retSegProdwiseBifPersonalLoan",
        "report": "retSegProdwiseBifHousingLoan",
        "bulkdatarecords5": "prodwiseBifGecl",
        "report7": "retSegProdwiseBifOtherRet",
        "bulkdatarecords6": "prodwiseBifOtherMsme",
        "bulkrecordsupload": "prodwiseBifOtherMsmeAbove200cr",
        "report8": "retSegProdwiseBifOthRetAbove200cr",
        "bulkuploads56": "retSegZonewiseBifurcation",
        "report13": "zonewiseBifurcation",
        "report15": "nbfc_credit_proposals",
        "report16": "nbfc_report",
        "report17": "ext_rating_dist_nbfc",
        "npa_test": "ext_rating_dist_nbfc",
        "report18": "ramseg",
        "report20": "rating_upgrade",
        "report21": "rating_downgrade",
        "report22": "borrower_turned_npa",
        "report23": "portfolio_quality_index",
        "unavailed_data1": "rating_migration_distribution",
        "unavailed_data8": "off_balance_sheet",
        "interactive1": "npa_non_npa_summary",
        "npa_test1": "ext_rating_dist_nbfc",
        "reportmart": "rating_position"
    };

    const handleTableChange = async (e) => {
        const selectedFullName = e.target.value;
        setTempSelectedTable(selectedFullName);

        if (!selectedFullName) return;

        if (!reportData) {
            console.error("Report data not loaded yet");
            return;
        }

        // Extract prefix and suffix
        const prefix = selectedFullName.split('_')[0];
        const suffix = selectedFullName.split('_').slice(1).join('_');

        // setSelectedPrefix(prefix);
        // setSelectedName(suffix);

        setSelectedPrefix(department);
        // setSelectedName(selectedFullName);
        setSelectedName(tableDisplayMap[selectedFullName]);


        // Reset dependent states
        setColumns([]);
        setSelectedColumns([]);
        setTableColumns([]);
        setTableData([]);
        setOriginalResponseData([]);
        // setAvailableDates([]);
        setAvailableSectors([]);
        // setFromDate("");
        // setToDate("");
        setNpaDescription("");
        setSelectedSector('');

        try {
            setLoading(true);

            // Fetch JSON
            // const response = await fetch(`/documents/Risk.json`);
            // const response = await fetch(`/jsonfiles/Gapsphere_Portfolio_Report.json`);
            // if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            // const jsonData = await response.json();
            // setReportData(jsonData);

            const repType = suffixToKeyMap[suffix];

            // Check if we have WebSocket AI description for this rep_type
            if (repType && wsAIDescriptions[repType]) {
                // Set the AI description from WebSocket
                setNpaDescription(wsAIDescriptions[repType]);
                console.log(`Using WebSocket AI description for ${repType}`);
            }
            // Process ALL available report types at once
            const processedReports = {};
            const allDates = new Set();
            let allSectors = new Set();

            for (let [keySuffix, jsonKey] of Object.entries(suffixToKeyMap)) {
                // if (!jsonData[jsonKey]) continue;

                // let flattenedData = [], dates = [], descriptions = [], differenceTable = [], differenceTable1 = [];
                // const targetData = jsonData[jsonKey];

                let flattenedData = [], dates = [], descriptions = [], differenceTable = [], differenceTable1 = [];
                let targetData = reportData[jsonKey];

                // ⭐ New handling for ramseg & sector (now inside portfolio_reports array)
                if (jsonKey === "ramseg" || jsonKey === "sector" || jsonKey === "directAsgnmtPool" || jsonKey === "agriProdwiseOtherAbovr100cr" || jsonKey === "agriProdwiseKcc" || jsonKey === "agriProdwiseOther"
                    || jsonKey === "agriSegiZonewiseBifurcation" || jsonKey === "prodwiseBifContractorPlus" || jsonKey === "prodwiseBifGecl" || jsonKey === "prodwiseBifGstEase" || jsonKey === "prodwiseBifMortgageLoan" || jsonKey === "prodwiseBifMudraLoan" || jsonKey === "prodwiseBifOtherMsme" || jsonKey === "prodwiseBifSmeLiqPlus" || jsonKey === "prodwiseBifVyaparLoan"
                    || jsonKey === "retSegProdwiseBifEducationLoan" || jsonKey === "retSegProdwiseBifGoldLoan" || jsonKey === "retSegProdwiseBifHousingLoan" || jsonKey === "retSegProdwiseBifOtherRet" || jsonKey === "retSegProdwiseBifPersonalLoan" || jsonKey === "retSegProdwiseBifvehicleLoan"
                    || jsonKey === "retSegZonewiseBifurcation" || jsonKey === "zonewise" || jsonKey === "zonewiseBifurcation" || jsonKey === "colendretseg" || jsonKey === "colendmsmeseg" || jsonKey === "prodwiseBifOtherMsmeAbove200cr" || jsonKey === "region" || jsonKey === "retSegProdwiseBifOthRetAbove200cr" || jsonKey === "colendseg"
                    || jsonKey === "renewable_energy_adv"
                ) {
                    const portfolioItem = reportData.portfolio_reports?.find(
                        item => item.rep_type === jsonKey
                    );

                    if (!portfolioItem) continue;

                    targetData = portfolioItem;
                }

                // Skip if still empty
                if (!targetData) continue;

                // Call the corresponding process function
                switch (keySuffix) {
                    case "accounting_code":
                        ({ flattenedData, dates, descriptions } = processAccountingOverride(targetData.data));
                        break;
                    case "accounting_data":
                        ({ flattenedData, dates, descriptions } = processAdditionalCollateral(targetData.data));
                        break;
                    case "actcust":
                        ({ flattenedData, dates, descriptions } = processAdditionalGlBalance(targetData.data));
                        break;
                    case "report9":
                        ({ flattenedData, dates, descriptions, differenceTable } = processAdditionalGuarantee(targetData.data));
                        console.log("differenceTable function", differenceTable);
                        setDifferenceTable(differenceTable);
                        break;
                    case "additional_gl_balance":
                        ({ flattenedData, dates, descriptions } = processBalancesheet(targetData.data));
                        break;
                    case "distribution_exposure":
                        ({ flattenedData, dates, descriptions } = processBalancesheet_10(targetData.data));
                        break;
                    case "exchange_rates":
                        ({ flattenedData, dates, descriptions } = processBalancesheet_11(targetData.data));
                        break;
                    case "investment_depreciationamount":
                        ({ flattenedData, dates, descriptions } = processBalancesheet_12(targetData.data));
                        break;
                    case "pf_superannuation":
                        ({ flattenedData, dates, descriptions } = processBalancesheet_13(targetData.data, wsAIDescriptions[jsonKey]));
                        break;
                    case "profit_flag":
                        ({ flattenedData, dates, descriptions } = processBalancesheet_14(targetData.data));
                        break;
                    case "fully_unavailed_tl":
                        ({ flattenedData, dates, descriptions } = processBalancesheet_15(targetData.data));
                        break;
                    case "rating_override":
                        ({ flattenedData, dates, descriptions } = processBalancesheet_16(targetData.data));
                        break;
                    case "restructured_data":
                        ({ flattenedData, dates, descriptions } = processBalancesheet_18(targetData.data));
                        break;
                    case "unavailed_data":
                        ({ flattenedData, dates, descriptions } = processKCC(targetData.data));
                        break;
                    case "npa_test1":
                        ({ flattenedData, dates, descriptions } = processSnapshot(targetData));
                        break;
                    case "reportmart":
                        ({ flattenedData, dates, descriptions } = processExternalRatingPosition(targetData));
                        break;
                    case "balance_sheet":
                        ({ flattenedData, dates, descriptions } = processPsb_gst_ease(targetData.data));
                        break;
                    case "bulkdatarecords4":
                        ({ flattenedData, dates, descriptions } = processContractor_plus(targetData.data));
                        break;
                    case "bulkdatarecords5":
                        ({ flattenedData, dates, descriptions } = processGecl(targetData.data));
                        break;
                    case "bulkdatarecords6":
                        ({ flattenedData, dates, descriptions } = processOtherMSME(targetData.data));
                        break;
                    case "bulkrecordsupload":
                        ({ flattenedData, dates, descriptions } = processOtherMSME200(targetData.data));
                        break;
                    case "bulkuploads56":
                        ({ flattenedData, dates, descriptions } = processRetailZonewise(targetData.data));
                        break;
                    case "report":
                        ({ flattenedData, dates, descriptions } = processApnaGhar(targetData.data));
                        break;
                    case "report3":
                        ({ flattenedData, dates, descriptions } = processApnaGharVahan(targetData.data));
                        break;
                    case "report4":
                        ({ flattenedData, dates, descriptions } = processPSBEducationLoan(targetData.data));
                        break;
                    case "report5":
                        ({ flattenedData, dates, descriptions } = processPSBGoldLoan(targetData.data));
                        break;
                    case "report6":
                        ({ flattenedData, dates, descriptions } = processPSBPersonalLoan(targetData.data));
                        break;
                    case "report7":
                        ({ flattenedData, dates, descriptions } = processOtherRetail(targetData.data));
                        break;
                    case "report8":
                        ({ flattenedData, dates, descriptions } = processOtherRetail200(targetData.data));
                        break;
                    case "report10":
                        ({ flattenedData, dates, descriptions } = processOtherAgricultural(targetData.data));
                        break;
                    case "report11":
                        ({ flattenedData, dates, descriptions } = processOtherAgricultural100(targetData.data));
                        break;
                    case "report13":
                        ({ flattenedData, dates, descriptions } = processMSMEZonewise(targetData.data));
                        break;
                    case "report14":
                        ({ flattenedData, dates, descriptions } = processRenewableEnergy(targetData.data));
                        break;
                    case "report15":
                        ({ flattenedData, dates, descriptions } = processMajorCreditProposals(targetData));
                        break;
                    // case "unavailed_data1":
                    //     ({ flattenedData, dates, descriptions } = processRatingMigration(targetData.data));
                    //     break;
                    case "unavailed_data1": {
                        // Extract previous_date and current_date from JSON
                        const currDate = targetData.current_date;
                        const prevDate = targetData.previous_date;

                        // Process the data normally
                        ({ flattenedData, dates, descriptions } = processRatingMigration(targetData.data));

                        // If processRatingComparison doesn't return dates, override them manually
                        dates = [prevDate, currDate].filter(Boolean); // remove undefined/null
                        // descriptions = [""];

                        // ✅ Set fromDate and toDate directly
                        if (prevDate) setFromDate(prevDate);
                        if (currDate) setToDate(currDate);

                        break;
                    }
                    case "report16":
                        ({ flattenedData, dates, descriptions } = processBanksCreditProposals(targetData));
                        break;
                    case "report17":
                        ({ flattenedData, dates, descriptions } = processSnapshotExternalProposals(targetData));
                        break;
                    case "report18":
                        ({ flattenedData, dates, descriptions, differenceTable1 } = processExternalRating(targetData.data));
                        console.log("differenceTable1 function", differenceTable1);
                        setDifferenceTable1(differenceTable1);
                        break;
                    case "report20": {
                        // Extract previous_date and current_date from JSON
                        const currDate = targetData.current_date;
                        const prevDate = targetData.previous_date;

                        // Process the data normally
                        ({ flattenedData, dates, descriptions } = processRatingComparison(targetData.data));

                        // If processRatingComparison doesn’t return dates, override them manually
                        dates = [prevDate, currDate].filter(Boolean); // remove undefined/null
                        descriptions = [""];

                        // ✅ Set fromDate and toDate directly
                        if (prevDate) setFromDate(prevDate);
                        if (currDate) setToDate(currDate);

                        break;
                    }

                    case "unavailed_data8":
                        ({ flattenedData, dates, descriptions } = processOffBalancesheet(targetData));
                        break;
                    // case "report21":
                    //     ({ flattenedData, dates, descriptions } = processRatingDowngraded(targetData));
                    //     break;

                    case "report21": {
                        // Extract previous_date and current_date from JSON
                        const currDate = targetData.current_date;
                        const prevDate = targetData.previous_date;

                        // Process the data normally
                        ({ flattenedData, dates, descriptions } = processRatingDowngraded(targetData.data));

                        // If processRatingComparison doesn’t return dates, override them manually
                        dates = [prevDate, currDate].filter(Boolean); // remove undefined/null
                        descriptions = [""];

                        // ✅ Set fromDate and toDate directly
                        if (prevDate) setFromDate(prevDate);
                        if (currDate) setToDate(currDate);

                        break;
                    }
                    // case "report22":
                    //     ({ flattenedData, dates, descriptions } = processRatingTurned(targetData));
                    //     break;
                    case "report22": {
                        // Extract previous_date and current_date from JSON
                        const currDate = targetData.current_date;
                        const prevDate = targetData.previous_date;

                        // Process the data normally
                        ({ flattenedData, dates, descriptions } = processRatingTurned(targetData.data));

                        // If processRatingComparison doesn’t return dates, override them manually
                        dates = [prevDate, currDate].filter(Boolean); // remove undefined/null
                        descriptions = [""];

                        // ✅ Set fromDate and toDate directly
                        if (prevDate) setFromDate(prevDate);
                        if (currDate) setToDate(currDate);

                        break;
                    }
                    case "report23":
                        ({ flattenedData, dates, descriptions } = processPortfolioQuality(targetData));
                        break;
                    case "interactive1":
                        ({ flattenedData, dates, descriptions } = processBankCreditReport(targetData));
                        break;
                    case "npa_test":
                        ({ flattenedData, dates, descriptions } = processSnapshotExternal(targetData));
                        break;

                }


                // Normalize column names
                flattenedData = flattenedData.map(row => {
                    const normalized = {};
                    Object.keys(row).forEach(key => {
                        normalized[key.trim()] = row[key];
                    });
                    return normalized;
                });


                // processedReports[keySuffix] = {
                //     flattenedData,
                //     dates,
                //     descriptions,
                //     // overallPortfolioYield: jsonData[jsonKey]?.overall_portfolio_yield ?? null,
                //     // stdActsPortfolioYield: jsonData[jsonKey]?.std_acts_portfolio_yield ?? null,
                //     overallPortfolioYield: targetData?.overall_portfolio_yield ?? null,
                //     stdActsPortfolioYield: targetData?.std_acts_portfolio_yield ?? null,
                //     differenceTable,
                //     differenceTable1
                // };

                processedReports[keySuffix] = {
                    flattenedData,
                    dates,
                    descriptions,
                    repType: jsonKey, // Store the rep_type
                    wsAIDescription: wsAIDescriptions[jsonKey] || null, // Store WebSocket AI description
                    overallPortfolioYield: targetData?.overall_portfolio_yield ?? null,
                    stdActsPortfolioYield: targetData?.std_acts_portfolio_yield ?? null,
                    differenceTable,
                    differenceTable1
                };

                // Collect global dates and sectors
                dates.forEach(d => allDates.add(d));
                flattenedData.forEach(r => allSectors.add(r.Sector));
            }

            // Save processed reports
            setProcessedReports(processedReports);

            const selectedReport = processedReports[suffix];
            const reportDates = selectedReport?.dates?.sort() || [];


            // Only set reportGenerated true if there’s data for this report
            setReportGenerated(reportDates.length > 0 || (selectedReport?.flattenedData?.length > 0));


            console.log("Processed Reports:", processedReports);
            console.log("Available Dates:", reportDates);
            console.log("Available Sectors:", [...allSectors].sort());




        } catch (error) {
            console.error("Error fetching table data:", error);
        } finally {
            setLoading(false);
        }
    };


    const transformReportData = (data) => {
        if (!data) {
            console.warn("transformReportData received invalid data:", data);
            return {};
        }

        let result = {};

        const calculateTotals = (rows) => {
            let totalBalance = 0,
                totalNpa = 0,
                totalSma1 = 0,
                totalSma2 = 0,
                totalYield = 0;

            rows.forEach(r => {
                totalBalance += Number(r["Balance"] || 0);
                totalNpa += Number(r["NPA"] || 0);
                totalSma1 += Number(r["SMA1"] || 0);
                totalSma2 += Number(r["SMA2"] || 0);
                totalYield += Number(r["Yield on Advances"] || 0);
            });

            const totalSma1plus2 = totalSma1 + totalSma2;

            return {
                Sector: "Grand Total",
                "Balance": totalBalance,
                NPA: totalNpa,
                "NPA%": totalBalance > 0 ? ((totalNpa / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA1: totalSma1,
                "SMA1%": totalBalance > 0 ? ((totalSma1 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                SMA2: totalSma2,
                "SMA2%": totalBalance > 0 ? ((totalSma2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "SMA1+2": totalSma1plus2,
                "SMA1+2%": totalBalance > 0 ? ((totalSma1plus2 / totalBalance) * 100).toFixed(2) + "%" : "0.00%",
                "Yield on Advances": totalYield, // Include sum for totals
            };
        };


        // Case 1: New format (Array of objects)
        if (Array.isArray(data)) {
            data.forEach(item => {
                const date = item.reporting_date || "Unknown Date";
                const sector = item.rep_param || "Unknown Sector";

                const balance = item.os_balance || 0;
                const npa = item.npa || 0;
                const sma1 = item.sma1 || 0;
                const sma2 = item.sma2 || 0;
                const yieldAdv = item.yield_on_advances || 0; // <-- Add this line

                const sma1plus2 = sma1 + sma2;

                const row = {
                    Sector: sector,
                    "Balance": balance,
                    NPA: npa,
                    "NPA%": balance > 0 ? ((npa / balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA1: sma1,
                    "SMA1%": balance > 0 ? ((sma1 / balance) * 100).toFixed(2) + "%" : "0.00%",
                    SMA2: sma2,
                    "SMA2%": balance > 0 ? ((sma2 / balance) * 100).toFixed(2) + "%" : "0.00%",
                    "SMA1+2": sma1plus2,
                    "SMA1+2%": balance > 0 ? ((sma1plus2 / balance) * 100).toFixed(2) + "%" : "0.00%",
                    "Yield on Advances": yieldAdv, // <-- Include value here
                };

                if (!result[date]) result[date] = [];
                result[date].push(row);
            });

            Object.keys(result).forEach(date => {
                result[date].push(calculateTotals(result[date]));
            });

            return result;
        }


        // Case 2: Old format (nested object by date)
        if (typeof data === "object") {
            for (const [date, sectors] of Object.entries(data)) {
                if (!sectors || typeof sectors !== "object") continue;

                const rows = [];
                for (const [sector, metrics] of Object.entries(sectors)) {
                    if (!metrics || typeof metrics !== "object") continue;

                    const balance = metrics["Balance"] || 0;
                    const npa = metrics["NPA"] || 0;
                    const sma1 = metrics["SMA1"] || 0;
                    const sma2 = metrics["SMA2"] || 0;
                    const yieldAdv = metrics["Yield on Advances"] || 0;

                    const sma1plus2 = sma1 + sma2;

                    const row = {
                        Sector: sector,
                        "Balance": balance,
                        NPA: npa,
                        "NPA%": balance > 0 ? ((npa / balance) * 100).toFixed(2) + "%" : "0.00%",
                        SMA1: sma1,
                        "SMA1%": balance > 0 ? ((sma1 / balance) * 100).toFixed(2) + "%" : "0.00%",
                        SMA2: sma2,
                        "SMA2%": balance > 0 ? ((sma2 / balance) * 100).toFixed(2) + "%" : "0.00%",
                        "SMA1+2": sma1plus2,
                        "SMA1+2%": balance > 0 ? ((sma1plus2 / balance) * 100).toFixed(2) + "%" : "0.00%",
                        "Yield on Advances": yieldAdv
                    };

                    rows.push(row);
                }

                // ✅ Add Grand Total row at the bottom
                rows.push(calculateTotals(rows));

                result[date] = rows;
            }
            return result;
        }

        return {};
    };

    const dateWiseData = transformReportData(reportData);

    const generateReport = async () => {

        // wsRef.current = new WebSocket(ReportWebsocket);

        // wsRef.current.onopen = () => {
        //     console.log("WebSocket connected");
        //     wsRef.current.send(JSON.stringify({ tableName: tempSelectedTable }));
        // };

        // // Update your WebSocket onmessage handler
        // wsRef.current.onmessage = (event) => {
        //     console.log("WebSocket Response:", event.data);

        //     try {
        //         const wsObj = JSON.parse(event.data);
        //         const innerData = JSON.parse(wsObj.data);

        //         if (Array.isArray(innerData.table_data)) {
        //             const allDescriptions = {};

        //             // 🔥 NEW LOGIC GOES HERE
        //             innerData.table_data.forEach((report) => {
        //                 const repType = report.rep_type;
        //                 const fullText = report.ai_description || "";

        //                 console.log("Extracting after keyword for:", repType);

        //                 const KEYWORD = "Key Takeaways";
        //                 const index = fullText.toLowerCase().indexOf(KEYWORD.toLowerCase());

        //                 if (index === -1) {
        //                     allDescriptions[repType] = "";
        //                     return;
        //                 }

        //                 let afterKeyword = fullText.substring(index + KEYWORD.length).trim();

        //                 afterKeyword = afterKeyword
        //                     .replace(/^[:\-\s]*/i, "")
        //                     .replace(/\*\*/g, "")
        //                     .trim();

        //                 const bulletRegex =
        //                     /(?:\d+\.\s.*?(?=\n\d+\.|$))|(?:[-*]\s.*?(?=\n[-*]|\n?$))/gs;

        //                 const bullets = afterKeyword.match(bulletRegex);

        //                 let finalList = [];

        //                 if (bullets) {
        //                     bullets.forEach(b => {
        //                         finalList.push(
        //                             b.replace(/^(\d+\.\s|[-*]\s)/, "").trim()
        //                         );
        //                     });
        //                 } else {
        //                     if (afterKeyword) finalList.push(afterKeyword);
        //                 }

        //                 allDescriptions[repType] = finalList.join("||");
        //             });

        //             // Store description map in state
        //             setWsAIDescriptions(allDescriptions);

        //             // Update UI for currently selected report
        //             if (selectedName && suffixToKeyMap[selectedName]) {
        //                 const repType = suffixToKeyMap[selectedName];
        //                 if (allDescriptions[repType]) {
        //                     setNpaDescription(allDescriptions[repType]);
        //                 }
        //             }

        //             console.log("WebSocket AI Descriptions stored:", allDescriptions);
        //             Object.entries(allDescriptions).forEach(([repType, desc]) => {
        //                 console.log("-----");
        //                 console.log("REP TYPE:", repType);
        //                 console.log("DESCRIPTION:", desc);
        //             });


        //         }
        //     } catch (err) {
        //         console.error("Error parsing WebSocket:", err);
        //         setNpaDescription("");
        //     }
        // };


        // try {
        //     const config = {
        //         params: { tableName: "Gapsphere_Portfolio_Report.json", role: userRole, dept: department },
        //         headers: { userId: userId, "x-csrf-token": csrfToken },
        //         withCredentials: true
        //     };
        //     await axios.post(demoAireportTexts, {}, config);
        // } catch (apiErr) {
        //     console.error("API error:", apiErr);
        // }
        if (!processedReports) {
            setTableData([]);
            setNpaDescription("");
            setReportGenerated(false);
            return;
        }

        // const selectedDates = [fromDate, toDate];
        // const report = processedReports[selectedName];

        const internalName = tableDisplayMap[selectedName] || selectedName;
        // const report = processedReports[internalName];
        const report = processedReports[selectedName];


        if (!report) {
            console.warn("No report data found for selected type:", selectedName);
            setTableData([]);
            setNpaDescription("No data available for this report.");
            return;
        }

        let { flattenedData, descriptions } = report;
        let filtered = [];

        // 🧩 Skip date filter for report15 and report16
        if (selectedName === "report15" || selectedName === "report16" || selectedName === "report17"
            || selectedName === "report20" || selectedName === "report21" || selectedName === "report22" || selectedName === "report23" || selectedName === "report24" || selectedName === "unavailed_data8" || selectedName === "unavailed_data1") {
            filtered = flattenedData;
        }
        // else {
        //     // Filter only for reports expecting 2 dates
        //     filtered = flattenedData
        //         .filter(row => selectedDates.includes(row.Date))
        //         .sort((a, b) => new Date(a.Date) - new Date(b.Date));
        // }
        else {
            // Filter by fromDate/toDate
            filtered = flattenedData
                .filter(row => {
                    if (!row.Date) return false;
                    return row.Date >= fromDate && row.Date <= toDate;
                })
                .sort((a, b) => new Date(a.Date) - new Date(b.Date));
        }

        if (selectedSector) {
            filtered = filtered.filter(row => row.Sector === selectedSector);
        }

        setTableData(filtered);

        const descText = descriptions.length
            ? descriptions.join(" ")
            : `No significant changes observed for ${selectedName.replace("_", " ")} during the selected period.`;

        setNpaDescription(descText);

        console.log("Filtered Table Data:", filtered);
        console.log("NPA Description:", descText);

        setReportGenerated(true);
    };



    useEffect(() => {
        if (!reportGenerated) return;

        const selectedDates = [fromDate, toDate];

        let filtered = originalResponseData
            .filter(row => selectedDates.includes(row.Date))
            .sort((a, b) => new Date(a.Date) - new Date(b.Date));

        if (selectedSector) {
            filtered = filtered.filter(row => row.Sector === selectedSector);
        }

        setTableData(filtered);
    }, [selectedSector]);


    useEffect(() => {
        // keep this only for resetting when dates change, don't generate report here
        if (!fromDate || !toDate) {
            setTableData([]);
            setNpaDescription("");
        }
    }, [fromDate, toDate]);



    const calculateSums = () => {
        const sums = {};

        // Convert fromDate and toDate strings to Date objects and only keep the date part
        const fromDateObj = fromDate ? new Date(fromDate) : null;
        const toDateObj = toDate ? new Date(toDate) : null;

        if (fromDateObj) {
            fromDateObj.setHours(0, 0, 0, 0); // Start of the day
        }
        if (toDateObj) {
            toDateObj.setHours(23, 59, 59, 999); // End of the day
        }

        // Filter the table data based on the search query and date range
        const filteredData = tableData.filter(row => {
            // Filter by search query
            const matchesSearchQuery = !searchQuery || Object.values(row).some(value =>
                // value.toString().toLowerCase().includes(searchQuery.toLowerCase())
                value != null && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
            );

            // Function to convert a string to Proper Case (PropCase)
            function toProperCase(str) {
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            }
            // Normalize all keys to Proper Case
            const normalizedRow = Object.keys(row).reduce((acc, key) => {
                const properCaseKey = toProperCase(key);
                acc[properCaseKey] = row[key];
                return acc;
            }, {});

            // Try both possible keys for reporting date
            const reportingDateValue = row['reporting_date'] || row['Reporting Date'];
            const reportingDate = reportingDateValue ? new Date(reportingDateValue) : null;

            // Check for invalid date
            if (reportingDate && isNaN(reportingDate.getTime())) {
                console.error(`Invalid date: ${reportingDateValue}`);
                return false;
            }
            // Strip time from reportingDate for comparison
            if (reportingDate) {
                reportingDate.setHours(0, 0, 0, 0);
            }


            // Filter by date range
            const isWithinDateRange = (() => {
                if (fromDateObj && !toDateObj) {
                    // Only fromDate is specified
                    return reportingDate && reportingDate.getTime() === fromDateObj.getTime();
                }
                if (!fromDateObj && toDateObj) {
                    // Only toDate is specified
                    return reportingDate && reportingDate.getTime() === toDateObj.getTime();
                }
                if (fromDateObj && toDateObj) {
                    // Both fromDate and toDate are specified
                    return reportingDate && reportingDate >= fromDateObj && reportingDate <= toDateObj;
                }
                // No date filters are specified
                return true;
            })();

            return matchesSearchQuery && isWithinDateRange;
        });

        // Calculate sums for the selected numeric columns
        sumColumns.forEach((col) => {
            if (availableSumColumns.includes(col)) { // Ensure column is numeric
                const sum = filteredData.reduce((acc, row) => {
                    const value = parseFloat(row[col]);
                    return !isNaN(value) ? acc + value : acc;
                }, 0);
                sums[col] = sum;
            }
        });

        setFilteredData(filteredData); // Store the filtered data for display
        return sums;
    };

    const downloadSingleReport = ({
        isOver = false,
        isGeoReport = false,
        isGlReport = false,
        isGuaranteeReport = false,
        isBalanceReport = false,
        isBalanceReport10 = false,
        isBalanceReport11 = false,
        isBalanceReport12 = false,
        isBalanceReport13 = false,
        isBalanceReport14 = false,
        isBalanceReport15 = false,
        isBalanceReport16 = false,
        isBalanceReport17 = false,
        isPsbgstease = false,
        isMSMEZonewise = false,
        isContractorplus = false,
        isGecl = false,
        isOtherMSME = false,
        isOtherMSME200 = false,
        isRetailZonewise = false,
        isApnaGhar = false,
        isApnaGharVahan = false,
        isPSBEducationLoan = false,
        isPSBGoldLoan = false,
        isPSBPersonalLoan = false,
        isOtherRetail = false,
        isOtherRetail200 = false,
        isOtherAgriculture = false,
        isOtherAgriculture100 = false,
        isRenewableEnergy = false,
        isMajorCreditProposals = false,
        isMajorBanks = false,
        isSnapshot = false,
        isSnapshotExternal = false,
        isExternalRating = false,
        isRatingComparison = false,
        isOffBalancesheet = false,
        isRatingMigration = false,
        isRatingUpgraded = false,
        isRatingTurned = false,
        isPortfolioQuality = false,
        isKCC = false,
        isSnapKCC = false,
        isBankscredit = false,
        isExternalRatingPosition = false,
        reportName,
        reportObj,
        fromDate,
        toDate,
        midDate,
        pdfInstance = null
    }) => {
        const pdf = pdfInstance || new jsPDF("p", "pt", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        let startY = 50;

        if (!reportObj || !reportObj.flattenedData || !reportObj.flattenedData.length) {
            console.warn(`No data for report: ${reportName}`);
            return pdf;
        }

        const tableData = reportObj.flattenedData;
        const npaDescription = reportObj.descriptions?.join(" ") || "";

        // --- Hindi Header (same as downloadPDF)
        const headerY = startY;

        pdf.setFont("NotoSansDevanagari-Regular", "normal");
        pdf.setFontSize(12);
        pdf.text("पंजाब एंड सिंध बैंक", 40, headerY);

        pdf.setFontSize(9);
        pdf.text("(भारत सरकार का उपक्रम)", 40, headerY + 12);
        pdf.text("प्र.का. जोखिम प्रबंधन विभाग", 40, headerY + 24);
        pdf.text("दूसरी मंजिल, एनबीसीसी कॉम्प्लेक्स, ब्लॉक III, प्लेट बी,", 40, headerY + 36);
        pdf.text("ईस्ट किदवई नगर, नई दिल्ली 110023", 40, headerY + 48);

        // English Header (optional, can copy same as downloadPDF)
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(12);
        pdf.text("PUNJAB & SIND BANK", pageWidth - 220, headerY);

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(9);
        pdf.text("(A Government Of India Undertaking)", pageWidth - 220, headerY + 12);
        pdf.text("H.O. Risk Management Department", pageWidth - 220, headerY + 24);
        pdf.text("2nd Floor, NBCC Complex, Block III, Plate B", pageWidth - 220, headerY + 36);
        pdf.text("East Kidwai Nagar, New Delhi - 110023", pageWidth - 220, headerY + 48);

        startY = headerY + 80; // move below header
        let reduced, transformed, dates;
        let head = [];
        let body = [];
        if (reportName === "report15") {
            const tableData = processedReports.report15?.flattenedData || [];

            // Keep all rows, do NOT deduplicate
            transformed = {
                "All Data": tableData.map(row => ({
                    Sector: row.borrower || "",
                    "Total Exposure (Cr)": row.totalExposureCr || "",
                    Activity: row.activity || "",
                    "External Rating": row.externalRating || ""
                }))
            };

            dates = ["All Data"];
        }
        else if (reportName === "report20") {
            const tableData = processedReports.report20?.flattenedData || [];

            // create transformed rows with consistent keys
            transformed = {
                "All Data": tableData.map(row => ({
                    Sr_NO: row.Sr_No ?? row.SrNO ?? "",            // accept existing variants
                    Sector: row.NAME ?? row.NAME_SHORT ?? row.Sector ?? "",
                    Balance_as_on: row.Balance_as_on ?? row.Balance ?? "",
                    Rating_Curr: row.Rating_Curr ?? "",
                    Rating_Prev: row.Rating_Prev ?? ""
                }))
            };

            dates = ["All Data"];
        }

        else if (reportName === "unavailed_data8") {
            const tableData = processedReports.unavailed_data8?.flattenedData || [];

            transformed = {
                "All Data": tableData.map((row, index) => ({
                    Sr_No: row.Sr_No || index + 1,
                    Scheme_Desc: row.Scheme_Desc || "",   // 👈 keep same as UI
                    BG_LC_Type: row.BG_LC_Type || "",     // 👈 keep same as UI
                    Prev_Value: row.Prev_Value ?? 0,
                    Curr_Value: row.Curr_Value ?? 0,
                    Change: row.Change ?? 0,
                    type: row.type || ""
                }))
            };

            dates = ["All Data"];
        }


        else if (reportName === "report21") {
            const tableData = processedReports.report21?.flattenedData || [];

            // create transformed rows with consistent keys
            transformed = {
                "All Data": tableData.map(row => ({
                    Sr_NO: row.Sr_No ?? row.SrNO ?? "",            // accept existing variants
                    Sector: row.NAME ?? row.NAME_SHORT ?? row.Sector ?? "",
                    Balance_as_on: row.Balance_as_on ?? row.Balance ?? "",
                    Rating_Curr: row.Rating_Curr ?? "",
                    Rating_Prev: row.Rating_Prev ?? ""
                }))
            };

            dates = ["All Data"];
        }

        else if (reportName === "unavailed_data1") {
            const tableData = processedReports.unavailed_data1?.flattenedData || [];

            // Get all rating columns dynamically (excluding metadata columns)
            const ratingColumns = tableData.length > 0
                ? Object.keys(tableData[0]).filter(k =>
                    ![
                        "Previous_Rating", "Total_Accounts", "Closed", "NPA",
                        "Balance Accounts", "Default Rate", "Stability Rate"
                    ].includes(k)
                )
                : [];

            // Create transformed rows with proper structure
            transformed = {
                "All Data": tableData.map(row => ({
                    Previous_Rating: row.Previous_Rating || "",
                    Total_Accounts: row.Total_Accounts || "",
                    // Dynamic rating columns
                    ...ratingColumns.reduce((acc, rating) => {
                        acc[rating] = row[rating] || "";
                        return acc;
                    }, {}),
                    Closed: row.Closed || "",
                    NPA: row.NPA || "",
                    Balance_Accounts: row["Balance Accounts"] || "",
                    Default_Rate: row["Default Rate"] || "",
                    Stability_Rate: row["Stability Rate"] || ""
                }))
            };

            dates = ["All Data"];
        }

        else if (reportName === "report22") {
            const tableData = processedReports.report22?.flattenedData || [];

            // create transformed rows with consistent keys
            transformed = {
                "All Data": tableData.map(row => ({
                    Sr_NO: row.Sr_No ?? row.SrNO ?? "",            // accept existing variants
                    Sector: row.NAME ?? row.NAME_SHORT ?? row.Sector ?? "",
                    Balance_as_on: row.Balance_as_on ?? row.Balance ?? "",
                    Rating_Curr: row.Rating_Curr ?? "",
                    Rating_Prev: row.Rating_Prev ?? ""
                }))
            };

            dates = ["All Data"];
        }
        else if (reportName === "report23") {
            const tableData = processedReports.report23?.flattenedData || [];

            // create transformed rows with consistent keys
            transformed = {
                "All Data": tableData.map(row => ({
                    Period: row.Period ?? "",            // accept existing variants
                    Portfolio_Quality_Index: row["Portfolio Quality Index"] ?? row.Portfolio_Quality_Index ?? ""
                }))
            };

            dates = ["All Data"];
        }

        else {
            reduced = tableData.reduce((acc, row) => {
                if (!acc[row.Date]) acc[row.Date] = {};
                if (!acc[row.Date][row.Sector]) acc[row.Date][row.Sector] = row;
                return acc;
            }, {});

            transformed = transformReportData(reduced);
            dates = [fromDate, toDate].filter(d => d && transformed[d] && transformed[d].length);
        }

        // --- Build rowOrder and columns as before
        const rowsPerDate = dates.map(d => transformed[d] || []);

        let rowOrder;
        if (reportName === "report15") {
            // Keep all rows in order, including duplicates
            rowOrder = (rowsPerDate[0] || []).map((r, idx) => ({ Sector: r.Sector, _idx: idx }));
        } else {
            let firstOrder = (rowsPerDate[0] || []).map(r => r.Sector);
            let otherOrder = rowsPerDate.slice(1).flatMap(rows => rows.map(r => r.Sector));
            rowOrder = Array.from(new Set([...firstOrder, ...otherOrder]));
        }


        if (["additional_gl_balance", "actcust", "distribution_exposure", "exchange_rates", "investment_depreciationamount", "pf_superannuation", "profit_flag", "fully_unavailed_tl", "rating_override", "restructured_data",
            "balance_sheet", "bulkdatarecords4", "bulkdatarecords5", "bulkdatarecords6", "bulkrecordsupload", "bulkuploads56", "report", "report3",
            "report4", "report5", "report6", "report7", "report8", "report9", "report10", "report11", "unavailed_data", "report13", "report14", "report18", "interactive1", "npa_test", "npa_test1", "reportmart"].includes(reportName)) {
            rowOrder = rowOrder.filter(s => s !== "Grand Total");
            rowOrder.push("Grand Total");
        }

        const colsPerDate = rowsPerDate.map((rows, idx) => {
            const cols = Object.keys(rows[0] || {}).filter(k => k !== "Date");
            return idx > 0 ? cols.filter(k => k !== "Sector") : cols;
        });



        const adjustedColsPerDate = colsPerDate.map((cols, idx) => {

            if (reportName === "unavailed_data") {
                // Include "Sector" only for the first date
                return idx === 0
                    ? ["Sector", "Balance", "NPA", "NPA%", "Interest Income", "Yield on Advances"]
                    : ["Balance", "NPA", "NPA%", "Interest Income", "Yield on Advances"];
            }

            if (reportName === "npa_test1") {
                // Include "Sector" only for the first date
                return idx === 0
                    ? ["Sector", "Balance", "% to Total"]
                    : ["Balance", "% to Total"];
            }

            if (reportName === "reportmart") {
                // First date columns (e.g. Dec’24)
                if (idx === 0) return ["Sector", "Balance", "% to Total"];

                // Second date (e.g. Mar’25) — no Difference column
                if (idx === dates.length - 1)
                    return ["Balance", "% to Total"];

                return ["Balance", "% to Total"];
            }



            if (!["actcust", "additional_gl_balance", "distribution_exposure", "exchange_rates", "investment_depreciationamount", "pf_superannuation", "profit_flag", "fully_unavailed_tl", "rating_override", "restructured_data",
                "balance_sheet", "bulkdatarecords4", "bulkdatarecords5", "bulkdatarecords6", "bulkrecordsupload", "bulkuploads56", "report", "report3",
                "report4", "report5", "report6", "report7", "report8", "report10", "report11", "report13", "report14", "npa_test"].includes(reportName)) {
                return cols.filter(c => c !== "Yield on Advances");
            }

            return cols;
        });

        const allCols = adjustedColsPerDate.flat();

        // --- Build table head & body as before
        if (reportName === "report20") {
            const ratingUpgrade = processedReports.report20?.rating_upgrade || {};
            const tableData = processedReports.report20?.flattenedData || [];

            // ✅ Priority 1: use the same UI props (toDate/fromDate) if available
            const currentDateRaw = toDate || ratingUpgrade.current_date || "";
            const previousDateRaw = fromDate || ratingUpgrade.previous_date || "";

            // ✅ Fallback: extract from data if missing
            const reportingDates = tableData
                .map(row => row.reporting_date)
                .filter(Boolean)
                .sort((a, b) => new Date(a) - new Date(b));

            const fallbackCurrDateRaw = reportingDates[reportingDates.length - 1] || "";
            const fallbackPrevDateRaw =
                reportingDates.length > 1
                    ? reportingDates[reportingDates.length - 2]
                    : reportingDates[0] || "";

            // ✅ Choose final dates (UI → JSON → fallback)
            const ratingCurrDateRaw = currentDateRaw || fallbackCurrDateRaw;
            const ratingPrevDateRaw = previousDateRaw || fallbackPrevDateRaw;
            const balanceDateRaw = previousDateRaw || fallbackPrevDateRaw;

            // ✅ Helper: format YYYY-MM-DD → DD-MM-YYYY
            const formatDate = (dateString) => {
                if (!dateString) return "";
                const d = new Date(dateString);
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();
                return `${day}-${month}-${year}`;
            };

            const balanceDate = formatDate(balanceDateRaw);
            const ratingCurrDate = formatDate(ratingCurrDateRaw);
            const ratingPrevDate = formatDate(ratingPrevDateRaw);


            // ✅ Header with dynamic dates
            head = [
                [
                    {
                        content: "Sr No",
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: "Name",
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Balance as on ${balanceDate}`, // ✅ will now correctly show "31-12-2024"
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Rating ${ratingCurrDate}`,
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Rating ${ratingPrevDate}`,
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                ],
            ];
        }

        else if (reportName === "unavailed_data8") {
            const rawData = processedReports.unavailed_data8?.off_balance_sheet || [];
            // Use the dates that are already processed and available in processedReports
            const dates = processedReports.unavailed_data8?.dates || [];

            const formatDate = (date) => {
                if (!date) return "";
                const d = new Date(date);
                if (isNaN(d)) return "";
                return `${String(d.getDate()).padStart(2, "0")}.${String(
                    d.getMonth() + 1
                ).padStart(2, "0")}.${d.getFullYear()}`;
            };

            console.log("📅 Available dates from processedReports:", dates);

            const startLabel = dates.length > 0 ? formatDate(dates[0]) : "Previous Period";
            const endLabel = dates.length > 1 ? formatDate(dates[dates.length - 1]) :
                dates.length === 1 ? formatDate(dates[0]) : "Current Period";

            console.log("📅 Final startLabel:", startLabel);
            console.log("📅 Final endLabel:", endLabel);

            head = [
                [
                    { content: "Description", styles: { fontStyle: "bold", halign: "center" } },
                    { content: "Scheme Code", styles: { fontStyle: "bold", halign: "center" } },
                    { content: startLabel, styles: { fontStyle: "bold", halign: "center" } },
                    { content: endLabel, styles: { fontStyle: "bold", halign: "center" } },
                    { content: "Change", styles: { fontStyle: "bold", halign: "center" } },
                ],
            ];
        }

        else if (reportName === "report21") {
            const ratingUpgrade = processedReports.report21?.rating_downgrade || {};
            const tableData = processedReports.report21?.flattenedData || [];

            // ✅ Priority 1: use the same UI props (toDate/fromDate) if available
            const currentDateRaw = toDate || ratingUpgrade.current_date || "";
            const previousDateRaw = fromDate || ratingUpgrade.previous_date || "";

            // Extract all reporting dates and sort ascending
            const reportingDates = tableData
                .map(row => row.reporting_date)
                .filter(Boolean)
                .sort((a, b) => new Date(a) - new Date(b));

            const fallbackCurrDateRaw = reportingDates[reportingDates.length - 1] || "";
            const fallbackPrevDateRaw =
                reportingDates.length > 1
                    ? reportingDates[reportingDates.length - 2]
                    : reportingDates[0] || "";

            // ✅ Choose final dates (UI → JSON → fallback)
            const ratingCurrDateRaw = currentDateRaw || fallbackCurrDateRaw;
            const ratingPrevDateRaw = previousDateRaw || fallbackPrevDateRaw;
            const balanceDateRaw = previousDateRaw || fallbackPrevDateRaw;

            // ✅ Helper: format YYYY-MM-DD → DD-MM-YYYY
            const formatDate = (dateString) => {
                if (!dateString) return "";
                const d = new Date(dateString);
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();
                return `${day}-${month}-${year}`;
            };

            const balanceDate = formatDate(balanceDateRaw);
            const ratingCurrDate = formatDate(ratingCurrDateRaw);
            const ratingPrevDate = formatDate(ratingPrevDateRaw);

            // Transform table rows
            transformed = {
                "All Data": tableData.map(row => ({
                    Sr_NO: row.Sr_No ?? row.SrNO ?? "",
                    Sector: row.NAME ?? row.NAME_SHORT ?? row.Sector ?? "",
                    Balance_as_on: row.Balance_as_on ?? row.Balance ?? "",
                    Rating_Curr: row.Rating_Curr ?? "",
                    Rating_Prev: row.Rating_Prev ?? ""
                }))
            };

            dates = ["All Data"];

            // Header with formatted dynamic dates
            head = [
                [
                    {
                        content: "Sr No",
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: "Name",
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Balance as on ${balanceDate}`, // ✅ will now correctly show "31-12-2024"
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Rating ${ratingCurrDate}`,
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Rating ${ratingPrevDate}`,
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                ],
            ];
        }
        else if (reportName === "unavailed_data1") {
            const tableData = processedReports.unavailed_data1?.flattenedData || [];

            const firstRecord = tableData[0] || {};
            const previousDate = firstRecord.previous_date || fromDate;
            const currentDate = firstRecord.current_date || toDate;

            const formatDate = (dateString) => {
                if (!dateString) return "";
                const d = new Date(dateString);
                if (isNaN(d)) return dateString;
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();
                return `${day}-${month}-${year}`;
            };

            const formattedPreviousDate = formatDate(previousDate);
            const formattedCurrentDate = formatDate(currentDate);

            const ratingColumns = tableData.length > 0
                ? Object.keys(tableData[0]).filter(k =>
                    ![
                        "Previous_Rating", "Total_Accounts", "Closed", "NPA",
                        "Balance Accounts", "Default Rate", "Stability Rate",
                        "previous_date", "current_date"
                    ].includes(k)
                )
                : [];

            const otherColumns = ["Closed", "NPA", "Balance Accounts", "Default Rate", "Stability Rate"];

            // --- Header Row 1 (Main Grouping) ---
            const headerColumns = [
                {
                    content: `Rating as on ${formattedPreviousDate}`,
                    rowSpan: 2, // 🔹 Span vertically for both header rows
                    styles: {
                        fontStyle: "bold",
                        halign: "center",
                        valign: "middle",
                        fillColor: [173, 216, 230],
                        textColor: [0, 0, 0],
                        lineWidth: 0.7,
                        lineColor: [0, 0, 0],
                    },
                },
                {
                    content: `Rating as on ${formattedCurrentDate}`,
                    colSpan: 1 + ratingColumns.length + otherColumns.length, // Total + ratings + others
                    styles: {
                        fontStyle: "bold",
                        halign: "center",
                        valign: "middle",
                        fillColor: [173, 216, 230],
                        textColor: [0, 0, 0],
                        lineWidth: 0.7,
                        lineColor: [0, 0, 0],
                    },
                },
            ];

            // --- Header Row 2 (Column Labels) ---
            const secondRowHeaders = [
                { content: "Total" },
                ...ratingColumns.map(r => ({ content: r })),
                ...otherColumns.map(r => ({ content: r })),
            ].map(h => ({
                ...h,
                styles: {
                    fontStyle: "bold",
                    halign: "center",
                    valign: "middle",
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    lineWidth: 0.7,
                    lineColor: [0, 0, 0],
                },
            }));

            head = [headerColumns, secondRowHeaders];
        }
        else if (reportName === "report22") {
            const ratingUpgrade = processedReports.report22?.borrower_turned_npa || {};
            const tableData = processedReports.report22?.flattenedData || [];

            // ✅ Priority 1: use the same UI props (toDate/fromDate) if available
            const currentDateRaw = toDate || ratingUpgrade.current_date || "";
            const previousDateRaw = fromDate || ratingUpgrade.previous_date || "";

            // Extract all reporting dates and sort ascending
            const reportingDates = tableData
                .map(row => row.reporting_date)
                .filter(Boolean)
                .sort((a, b) => new Date(a) - new Date(b));

            const fallbackCurrDateRaw = reportingDates[reportingDates.length - 1] || "";
            const fallbackPrevDateRaw =
                reportingDates.length > 1
                    ? reportingDates[reportingDates.length - 2]
                    : reportingDates[0] || "";

            // ✅ Choose final dates (UI → JSON → fallback)
            const ratingCurrDateRaw = currentDateRaw || fallbackCurrDateRaw;
            const ratingPrevDateRaw = previousDateRaw || fallbackPrevDateRaw;
            const balanceDateRaw = previousDateRaw || fallbackPrevDateRaw;

            // ✅ Helper: format YYYY-MM-DD → DD-MM-YYYY
            const formatDate = (dateString) => {
                if (!dateString) return "";
                const d = new Date(dateString);
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();
                return `${day}-${month}-${year}`;
            };

            const balanceDate = formatDate(balanceDateRaw);
            const ratingCurrDate = formatDate(ratingCurrDateRaw);
            const ratingPrevDate = formatDate(ratingPrevDateRaw);

            // Header with dynamic date labels
            head = [
                [
                    {
                        content: "Sr No",
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: "Name",
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Balance as on ${balanceDate}`, // ✅ will now correctly show "31-12-2024"
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Rating ${ratingCurrDate}`,
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: `Rating ${ratingPrevDate}`,
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                ],
            ];
        }

        else if (reportName === "report23") {
            // Updated header for report23 with NBFC title
            head = [
                [
                    {
                        content: "NBFC",
                        colSpan: 2,
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                            fontSize: 14
                        },
                    }
                ],
                [
                    {
                        content: "Period",
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },
                    {
                        content: "Portfolio Quality Index",
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    }
                ]
            ];
        } else {
            head = [
                [
                    {
                        content:
                            reportName === "report15"
                                ? "Borrower"
                                : (reportName === "distribution_exposure" ||
                                    reportName === "exchange_rates" ||
                                    reportName === "report7")
                                    ? "Row Labels"
                                    : (reportName === "investment_depreciationamount" ||
                                        reportName === "pf_superannuation" ||
                                        reportName === "profit_flag" ||
                                        reportName === "rating_override" ||
                                        reportName === "restructured_data" ||
                                        reportName === "balance_sheet" ||
                                        reportName === "bulkdatarecords4" ||
                                        reportName === "report" ||
                                        reportName === "bulkdatarecords6" ||
                                        reportName === "actcust" ||
                                        reportName === "report3" ||
                                        reportName === "report4" ||
                                        reportName === "report5" ||
                                        reportName === "report6" ||
                                        reportName === "bulkuploads56" ||
                                        reportName === "report10" ||
                                        reportName === "unavailed_data" ||
                                        reportName === "npa_test" ||
                                        // reportName === "npa_test1" ||
                                        reportName === "report13" ||
                                        reportName === "bulkdatarecords5")
                                        ? "Zone"
                                        : (reportName === "bulkrecordsupload" ||
                                            reportName === "report8" ||
                                            reportName === "report11" ||
                                            reportName === "report14")
                                            ? "Scheme Code"
                                            : (reportName === "report20" ||
                                                reportName === "fully_unavailed_tl" || reportName === "report21" || reportName === "report22")
                                                ? "NAME"
                                                : (reportName === "report18")
                                                    ? "Rating Grades"
                                                    : (reportName === "accounting_data")
                                                        ? "Region"
                                                        : (reportName === "additional_gl_balance")
                                                            ? "Segment"
                                                            : (reportName === "npa_test1")
                                                                ? "Rating Category"
                                                                : (reportName === "reportmart")
                                                                    ? "Rating Grades"
                                                                    : "Sector",
                        rowSpan: 2,
                        styles: {
                            fontStyle: "bold",
                            halign: "center",
                            valign: "middle",
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                        },
                    },

                    ...dates.map((date, idx) => {
                        const d = new Date(date);
                        const day = String(d.getDate()).padStart(2, "0");
                        const month = String(d.getMonth() + 1).padStart(2, "0");
                        const year = d.getFullYear();
                        const formattedDate = `${day}-${month}-${year}`;

                        let title = formattedDate;

                        if (reportName === "additional_gl_balance")
                            title = `Co-Lending Portfolio as on – ${formattedDate}`;
                        else if (reportName === "distribution_exposure")
                            title = `Co-Lending Portfolio (Retail) as on – ${formattedDate}`;
                        else if (reportName === "exchange_rates")
                            title = `Co-Lending MSME as on – ${formattedDate}`;
                        else if (reportName === "investment_depreciationamount")
                            title = `VYAPAR LOAN – ${formattedDate}`;
                        else if (reportName === "pf_superannuation")
                            title = `MORTGAGE LOAN – ${formattedDate}`;
                        else if (reportName === "profit_flag")
                            title = `MUDRA – ${formattedDate}`;
                        else if (reportName === "fully_unavailed_tl")
                            title = `POOL ACCOUNTS as on – ${formattedDate}`;
                        else if (reportName === "rating_override")
                            title = `SME LIQUID PLUS – ${formattedDate}`;
                        else if (reportName === "restructured_data")
                            title = `Zonewise Agriculture – as on ${formattedDate}`;
                        else if (reportName === "balance_sheet")
                            title = `GST EASE - ${formattedDate}`;
                        else if (reportName === "bulkdatarecords4")
                            title = `CONTRACTOR PLUS - ${formattedDate}`;
                        else if (reportName === "bulkdatarecords5")
                            title = `GECL - ${formattedDate}`;
                        else if (reportName === "bulkdatarecords6")
                            title = `Other MSME - ${formattedDate}`;
                        else if (reportName === "bulkrecordsupload")
                            title = `Other MSME above RS. 200Cr – ${formattedDate}`;
                        else if (reportName === "bulkuploads56")
                            title = `ZONEWISE RETAIL - ${formattedDate}`;
                        else if (reportName === "report")
                            title = `PSB APNA GHAR - ${formattedDate}`;
                        else if (reportName === "report3")
                            title = `PSB APNA VAHAN - ${formattedDate}`;
                        else if (reportName === "report4")
                            title = `PSB EDUCATION LOAN - ${formattedDate}`;
                        else if (reportName === "report5")
                            title = `PSB GOLD LOAN - ${formattedDate}`;
                        else if (reportName === "report6")
                            title = `PSB PERSONAL LOAN - ${formattedDate}`;
                        else if (reportName === "report7")
                            title = `OTHER RETAIL - ${formattedDate}`;
                        else if (reportName === "report8")
                            title = `Other RETAIL above RS. 200Cr – ${formattedDate}`;
                        else if (reportName === "report10")
                            title = `Other Agriculture – as on ${formattedDate}`;
                        else if (reportName === "report11")
                            title = `Other Agricultural (Product Wise above RS. 100Cr) – as on ${formattedDate}`;
                        else if (reportName === "unavailed_data")
                            title = `KCC – as on ${formattedDate}`;
                        else if (reportName === "report14")
                            title = `RENEWABLE ENERGY AS ON ${formattedDate}`;

                        return {
                            content: title,
                            colSpan: adjustedColsPerDate[idx].filter(
                                c =>
                                    ![
                                        "Sector",
                                        "Scheme Code",
                                        "Row Labels",
                                        "Borrower",
                                        "Zone",
                                        "NAME",
                                        "Region",
                                        "Segment",
                                        "Rating Grades",
                                    ].includes(c)
                            ).length,
                            styles: {
                                halign: "center",
                                fontStyle: "bold",
                                fillColor: [173, 216, 230],
                                textColor: [0, 0, 0],
                                lineWidth: 0.7,
                                lineColor: [0, 0, 0],
                            },
                        };
                    }),
                    ...(reportName === "reportmart" && dates.length >= 2
                        ? [
                            {
                                content: `Increase / Decrease in ${new Date(
                                    dates[1]
                                ).toLocaleString("en-US", {
                                    month: "short",
                                    year: "2-digit",
                                })} viz-à-viz ${new Date(dates[0]).toLocaleString("en-US", {
                                    month: "short",
                                    year: "2-digit",
                                })}`,
                                rowSpan: 2,
                                styles: {
                                    halign: "center",
                                    fontStyle: "bold",
                                    fillColor: [173, 216, 230],
                                    textColor: [0, 0, 0],
                                    lineWidth: 0.7,
                                    lineColor: [0, 0, 0],
                                },
                            },
                        ]
                        : []),

                ],

                [
                    ...dates.flatMap((_, idx) =>
                        adjustedColsPerDate[idx]
                            .filter(
                                c =>
                                    ![
                                        "Sector",
                                        "Scheme Code",
                                        "Row Labels",
                                        "Borrower",
                                        "Zone",
                                        "NAME",
                                        "Region",
                                        "Segment",
                                        "Rating Grades",
                                    ].includes(c)
                            )
                            .map(c => ({
                                content:
                                    reportName === "npa_test1" && c === "Balance"
                                        ? "Exposure"
                                        : reportName === "reportmart" && c === "Balance"
                                            ? "Exposure (Amt. in Cr)"
                                            : c,
                                styles: {
                                    fontStyle: "bold",
                                    fillColor: [173, 216, 230],
                                    textColor: [0, 0, 0],
                                    halign: "center",
                                },
                            }))


                    ),
                ],

            ];
        }


        // let body;

        if (reportName === "report15") {
            const rows = transformed["All Data"] || [];
            body = rows.map(row => {
                return allCols.map(col => {
                    let v;

                    if (col === "Sector") v = row.Sector;
                    else if (col === "Total Exposure (Cr)") v = row["Total Exposure (Cr)"];
                    else if (col === "Activity") v = row.Activity;
                    else if (col === "External Rating") v = row["External Rating"];

                    if (typeof v === "number") v = v.toLocaleString("en-IN");
                    return v ?? "";
                });

            });

        }


        else if (reportName === "report20") {
            const rows = transformed["All Data"] || [];
            body = rows.map(row => {
                return allCols.map(col => {
                    let v = "";

                    if (col === "Sr_NO") v = row.Sr_NO;
                    else if (col === "Sector") v = row.Sector;
                    else if (col === "Balance_as_on") v = row.Balance_as_on;
                    else if (col === "Rating_Curr") v = row.Rating_Curr;
                    else if (col === "Rating_Prev") v = row.Rating_Prev;

                    // Try to format numeric balances; accept numbers or numeric strings
                    if (v !== null && v !== undefined && v !== "") {
                        // remove commas then try to parse
                        const numCandidate = typeof v === "string" ? v.replace(/,/g, "") : v;
                        const n = Number(numCandidate);
                        if (!Number.isNaN(n)) {
                            // format for en-IN
                            v = n.toLocaleString("en-IN");
                        }
                    }

                    return v ?? "";
                });
            });
        } else if (reportName === "unavailed_data8") {
            const structuredData = transformed["All Data"] || [];

            let headerCount = 0;

            body = structuredData.map(item => {
                if (item.type === "header") {
                    headerCount++;
                    let headerText = headerCount === 1 ? "Bank Guarantees" : "Letter of Credit";

                    return [
                        {
                            content: headerText,
                            colSpan: 5,
                            styles: { halign: "center", fillColor: [234, 243, 255], fontStyle: "bold" },
                        },
                    ];
                }

                if (item.type === "subtotal") {
                    return [
                        { content: "", styles: { fillColor: [241, 241, 241] } },
                        {
                            content: String(item.Scheme_Desc || ""),
                            styles: { halign: "right", fontStyle: "bold", fillColor: [241, 241, 241] }
                        },
                        {
                            content: item.Prev_Value?.toLocaleString("en-IN") || "0",
                            styles: { halign: "right", fillColor: [241, 241, 241] }
                        },
                        {
                            content: item.Curr_Value?.toLocaleString("en-IN") || "0",
                            styles: { halign: "right", fillColor: [241, 241, 241] }
                        },
                        {
                            content: item.Change?.toLocaleString("en-IN") || "0",
                            styles: { halign: "right", fillColor: [241, 241, 241] }
                        },
                    ];
                }

                if (item.type === "grandtotal") {
                    return [
                        { content: "", styles: { fillColor: [217, 237, 247] } },
                        {
                            content: String(item.Scheme_Desc || ""),
                            styles: { halign: "right", fontStyle: "bold", fillColor: [217, 237, 247] }
                        },
                        {
                            content: item.Prev_Value?.toLocaleString("en-IN") || "0",
                            styles: { halign: "right", fillColor: [217, 237, 247] }
                        },
                        {
                            content: item.Curr_Value?.toLocaleString("en-IN") || "0",
                            styles: { halign: "right", fillColor: [217, 237, 247] }
                        },
                        {
                            content: item.Change?.toLocaleString("en-IN") || "0",
                            styles: { halign: "right", fillColor: [217, 237, 247] }
                        },
                    ];
                }

                // Normal data rows
                return [
                    {
                        content: String(item.Scheme_Desc || ""),
                        styles: { halign: "left" }
                    },
                    {
                        content: String(item.BG_LC_Type || ""),
                        styles: { halign: "center" }
                    },
                    {
                        content: item.Prev_Value?.toLocaleString("en-IN") || "0",
                        styles: { halign: "right" }
                    },
                    {
                        content: item.Curr_Value?.toLocaleString("en-IN") || "0",
                        styles: { halign: "right" }
                    },
                    {
                        content: item.Change?.toLocaleString("en-IN") || "0",
                        styles: {
                            halign: "right",
                            textColor: item.Change > 0 ? [0, 0, 0] : item.Change < 0 ? [0, 0, 0] : [0, 0, 0],
                            fontStyle: item.Change !== 0 ? "bold" : "normal",
                        },
                    },
                ];
            });
        } else if (reportName === "report21") {
            const rows = transformed["All Data"] || [];
            body = rows.map(row => {
                return allCols.map(col => {
                    let v = "";

                    if (col === "Sr_NO") v = row.Sr_NO;
                    else if (col === "Sector") v = row.Sector;
                    else if (col === "Balance_as_on") v = row.Balance_as_on;
                    else if (col === "Rating_Curr") v = row.Rating_Curr;
                    else if (col === "Rating_Prev") v = row.Rating_Prev;

                    // Try to format numeric balances; accept numbers or numeric strings
                    if (v !== null && v !== undefined && v !== "") {
                        // remove commas then try to parse
                        const numCandidate = typeof v === "string" ? v.replace(/,/g, "") : v;
                        const n = Number(numCandidate);
                        if (!Number.isNaN(n)) {
                            // format for en-IN
                            v = n.toLocaleString("en-IN");
                        }
                    }

                    return v ?? "";
                });
            });
        } else if (reportName === "unavailed_data1") {
            const rows = transformed["All Data"] || [];
            body = rows.map(row => {
                return allCols.map(col => {
                    let v = "";

                    // Map all possible columns
                    if (col === "Previous_Rating") v = row.Previous_Rating;
                    else if (col === "Total_Accounts") v = row.Total_Accounts;
                    else if (col === "Closed") v = row.Closed;
                    else if (col === "NPA") v = row.NPA;
                    else if (col === "Balance_Accounts") v = row.Balance_Accounts;
                    else if (col === "Default_Rate") v = row.Default_Rate;
                    else if (col === "Stability_Rate") v = row.Stability_Rate;
                    else {
                        // Handle dynamic rating columns
                        v = row[col] || "";
                    }

                    // Format numeric values
                    if (v !== null && v !== undefined && v !== "") {
                        const numCandidate = typeof v === "string" ? v.replace(/,/g, "") : v;
                        const n = Number(numCandidate);
                        if (!Number.isNaN(n)) {
                            v = n.toLocaleString("en-IN");
                        }
                    }

                    return v ?? "";
                });
            });

            // Add overall rating stability at the end
            const overallStability = processedReports.unavailed_data1?.overallStability || "0%";

            // You can add this as a footer after the table
            // We'll handle this in the final section after table rendering
        } else if (reportName === "report22") {
            const rows = transformed["All Data"] || [];
            body = rows.map(row => {
                return allCols.map(col => {
                    let v = "";

                    if (col === "Sr_NO") v = row.Sr_NO;
                    else if (col === "Sector") v = row.Sector;
                    else if (col === "Balance_as_on") v = row.Balance_as_on;
                    else if (col === "Rating_Curr") v = row.Rating_Curr;
                    else if (col === "Rating_Prev") v = row.Rating_Prev;

                    // Try to format numeric balances; accept numbers or numeric strings
                    if (v !== null && v !== undefined && v !== "") {
                        // remove commas then try to parse
                        const numCandidate = typeof v === "string" ? v.replace(/,/g, "") : v;
                        const n = Number(numCandidate);
                        if (!Number.isNaN(n)) {
                            // format for en-IN
                            v = n.toLocaleString("en-IN");
                        }
                    }

                    return v ?? "";
                });
            });
        } else if (reportName === "report23") {
            const rows = transformed["All Data"] || [];
            body = rows.map(row => {
                return allCols.map(col => {
                    let v = "";

                    if (col === "Period") v = row.Period;
                    else if (col === "Portfolio_Quality_Index") v = row.Portfolio_Quality_Index;

                    if (v !== null && v !== undefined && v !== "") {
                        const numCandidate = typeof v === "string" ? v.replace(/,/g, "") : v;
                        const n = Number(numCandidate);
                        if (!Number.isNaN(n)) {
                            v = n.toLocaleString("en-IN");
                        }
                    }

                    return v ?? "";
                });
            });
        }
        else {
            // Existing logic for other reports
            body = rowOrder.map(sectorName => {
                const cells = [];

                dates.forEach((date, idx) => {
                    const rows = transformed[date] || [];

                    // 1) Compute totalBalance once, excluding any aggregate rows
                    const totalBalance = rows
                        .filter(r => (r.Sector || "").toString().toLowerCase() !== "grand total")
                        .reduce((sum, r) => {
                            // Normalize to number: handle numbers or formatted strings with commas
                            const raw = r["Balance"];
                            const num = typeof raw === "number"
                                ? raw
                                : parseFloat(String(raw).replace(/,/g, "").replace(/%/g, "")) || 0;
                            return sum + num;
                        }, 0);

                    // Debug: show the value used for totalBalance
                    console.log(`Date: ${date} -> totalBalance (excl Grand Total) =`, totalBalance);

                    const row = rows.find(r => r.Sector === sectorName);

                    adjustedColsPerDate[idx].forEach(col => {
                        let v;

                        if (col === "Sector") {
                            v = sectorName === "Grand Total" && reportName === "additional_gl_balance"
                                ? "CO-LENDING Total"
                                : sectorName;
                        }
                        else if (["npa_test", "npa_test1", "reportmart"].includes(reportName) &&
                            col === "% to Total" && row) {

                            // Normalize osBalance as number too
                            const osBalance = typeof row["Balance"] === "number"
                                ? row["Balance"]
                                : parseFloat(String(row["Balance"]).replace(/,/g, "").replace(/%/g, "")) || 0;

                            console.log(`📊 ${reportName} | Sector: ${row.Sector} | Date: ${date} | osBalance: ${osBalance} | totalBalance: ${totalBalance}`);

                            v = totalBalance > 0
                                ? ((osBalance / totalBalance) * 100).toFixed(2) + "%"
                                : "0.00%";
                        }
                        else if (["unavailed_data"].includes(reportName) && col === "Interest Income" && row) {
                            // Normalize Balance
                            const osBalance = typeof row["Balance"] === "number"
                                ? row["Balance"]
                                : parseFloat(String(row["Balance"]).replace(/,/g, "").replace(/%/g, "")) || 0;

                            // Use the same formula as processKCC
                            const roiPercent = typeof row["Yield on Advances"] === "string"
                                ? parseFloat(row["Yield on Advances"].replace("%", "")) || 0
                                : Number(row["Yield on Advances"]) || 0;

                            const interest = (osBalance * roiPercent) / 100;

                            v = interest.toFixed(2);
                        }

                        // ... other columns ...
                        else {
                            v = row ? row[col] : "";
                        }

                        if (typeof v === "number") v = v.toLocaleString("en-IN");
                        cells.push(v ?? "");
                    });
                });


                // 🔥 DIFFERENCE CALCULATION FOR reportmart
                if (reportName === "reportmart" && dates.length >= 2) {
                    const rowsDate1 = transformed[dates[0]] || [];
                    const rowsDate2 = transformed[dates[1]] || [];
                    const row1 = rowsDate1.find(r => r.Sector === sectorName);
                    const row2 = rowsDate2.find(r => r.Sector === sectorName);

                    if (row1 && row2) {
                        const balance1 = parseFloat(String(row1["Balance"] || "0").replace(/,/g, "")) || 0;
                        const balance2 = parseFloat(String(row2["Balance"] || "0").replace(/,/g, "")) || 0;
                        const difference = balance2 - balance1;

                        let formattedDifference = difference !== 0
                            ? difference.toLocaleString("en-IN")
                            : "0";

                        cells.push(formattedDifference);
                    } else {
                        cells.push("");
                    }
                }

                return cells;
            });
        }


        const sectorIndex = allCols.indexOf("Sector");
        if (sectorIndex !== -1) {
            body.forEach((cells, ri) => {
                const label = String(cells[sectorIndex] ?? "").trim();
                if (/^(sub\s*total|grand\s*total|subtotal|co-?lending\s*total)$/i.test(label)) {
                    for (let i = 0; i < cells.length; i++) {
                        cells[i] = {
                            content: cells[i],
                            styles: {
                                fillColor: [173, 216, 230],
                                fontStyle: "bold",
                                textColor: [0, 0, 0]
                            }
                        };
                    }
                }
            });
        }
        if (reportName === "unavailed_data1") {
            const previousRatingIndex = allCols.indexOf("Previous_Rating");
            if (previousRatingIndex !== -1) {
                body.forEach((cells, ri) => {
                    const label = String(cells[previousRatingIndex] ?? "").trim();
                    if (/^(grand\s*total)$/i.test(label)) {
                        for (let i = 0; i < cells.length; i++) {
                            cells[i] = {
                                content: cells[i],
                                styles: {
                                    fillColor: [173, 216, 230],
                                    fontStyle: "bold",
                                    textColor: [0, 0, 0]
                                }
                            };
                        }
                    }
                });
            }
        }

        // const headerY = 50;

        // Hindi (Left)
        pdf.setFont("NotoSansDevanagari-Regular", "normal");
        pdf.setFontSize(12);
        pdf.text("पंजाब एंड सिंध बैंक", 40, headerY);

        pdf.setFontSize(9);
        pdf.text("(भारत सरकार का उपक्रम)", 40, headerY + 12);
        pdf.text("प्र.का. जोखिम प्रबंधन विभाग", 40, headerY + 24);
        pdf.text("दूसरी मंजिल, एनबीसीसी कॉम्प्लेक्स, ब्लॉक III, प्लेट बी,", 40, headerY + 36);
        pdf.text("ईस्ट किदवई नगर, नई दिल्ली 110023", 40, headerY + 48);

        // Center logo (place your base64 / PNG here)
        let headerX = 20;
        const logoWidth = 50;
        const logoWidth1 = 65;
        const logoHeight = 60;
        const logoHeight1 = 15;
        const logoX = pageWidth / 2 - logoWidth / 2; // center
        const logoY = headerY - 5;
        const logoY1 = headerX + 10;
        const sloganOffsetY = 8;
        const logoffsetX1 = 10; // move 20px to the right
        // pdf.addImage(SloganBase64, "PNG", logoX, logoY1, logoWidth1, logoHeight1);
        const sloganOffsetX = 2; // move 20px to the right
        pdf.addImage(SloganBase64, "PNG", logoX - sloganOffsetX, logoY1 + sloganOffsetY, logoWidth1, logoHeight1);
        pdf.addImage(logoBase64, "PNG", logoX, logoY + logoffsetX1, logoWidth, logoHeight);

        // Optional text above logo (like in screenshot)
        pdf.setFont("NotoSansDevanagari-Regular", "normal");
        pdf.setFontSize(9);
        pdf.text("੧੬ ਸ੍ਰੀ ਹਰਿਗੁਰੂ ਤੇਗ ਬਹਾਦਰ", logoX - 10, logoY - 5); // adjust X,Y to fit

        // English (Right)
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(12);
        pdf.text("PUNJAB & SIND BANK", pageWidth - 220, headerY);

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(9);
        pdf.text("(A Government Of India Undertaking)", pageWidth - 220, headerY + 12);
        pdf.text("H.O. Risk Management Department", pageWidth - 220, headerY + 24);
        pdf.text("2nd Floor, NBCC Complex, Block III, Plate B", pageWidth - 220, headerY + 36);
        pdf.text("East Kidwai Nagar, New Delhi - 110023", pageWidth - 220, headerY + 48);

        startY = headerY + 80;

        const marginX = 40;
        const boxWidth = pageWidth - 80;

        if (reportName === "report9") {
            const lineY = startY - 5;
            startY = lineY + 15;

            // Use the same font & size convention
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(11);

            const englishText = [
                "One Account under HDFC DA Pool amount has turned NPA during the current quarter.",
                "SMA under the segment is almost NIL, as the Bank's exposure under the category is still in its nascent stage.",
                "During the quarter a huge drop in yield has been observed under HDFC Pool and IDFC Bank pool, bringing down the overall yield of the segment."
            ];

            let currentY = startY;
            englishText.forEach(line => {
                // Wrap text same as heading section
                const wrapped = pdf.splitTextToSize(line, pageWidth - 80);
                pdf.text(wrapped, 40, currentY);

                // Same line spacing factor
                currentY += wrapped.length * 14 + 5;
            });

            startY = currentY + 10;
        }


        let startYY = 123;

        pdf.setLineWidth(1); // thickness of the line
        pdf.setDrawColor(0, 0, 0); // black line
        pdf.line(40, startYY - 5, pageWidth - 40, startYY - 5); // from left margin to right margin


        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(11);
        const isGeo = isGeoReport; // flag to indicate if processAdditionalCollateral is used

        const td = new Date(toDate);
        const toDay = String(td.getDate()).padStart(2, "0");
        const toMonth = String(td.getMonth() + 1).padStart(2, "0");
        const toYear = td.getFullYear();
        const formattedToDate = `${toDay}-${toMonth}-${toYear}`;

        const fd = new Date(fromDate);
        const fromDay = String(fd.getDate()).padStart(2, "0");
        const fromMonth = String(fd.getMonth() + 1).padStart(2, "0");
        const fromYear = fd.getFullYear();
        const formattedFromDate = `${fromDay}-${fromMonth}-${fromYear}`;

        // const title = isGeo
        const title = isOver
            ? `1. Sector Wise Advances Portfolio as on ${formattedToDate}`
            : isGeo
                ? `2. Geographical Concentration`
                : isGlReport
                    ? `3. Zone wise Concentration`
                    : isGuaranteeReport
                        ? `5. Analysis of RAM Segment`
                        : isBalanceReport
                            ? `4. Analysis of Co-Lending Segment`
                            : isBalanceReport10
                                ? `4.1 Analysis of Co-Lending - Retail Segment`
                                : isBalanceReport11
                                    ? `4.2 Analysis of Co-Lending - MSME Segment`
                                    : isBalanceReport12
                                        ? `ii)   Product Wise Bifurcation - a) PSB VYAPAR LOAN`
                                        : isBalanceReport13
                                            ? `c). PSB MORTGAGE LOAN`
                                            : isBalanceReport14
                                                ? `e).MUDRA LOAN`
                                                : isBalanceReport15
                                                    ? `4.3 Analysis of Direct Assignment Pool`
                                                    : isBalanceReport16
                                                        ? `b). PSB SME LIQUID PLUS`
                                                        : isPsbgstease
                                                            ? `d). PSB GST EASE`
                                                            : isContractorplus
                                                                ? `f). CONTRACTOR PLUS`
                                                                : isApnaGhar
                                                                    ? `ii) Product Wise Bifurcation: - a) PSB APNA GHAR `
                                                                    : isApnaGharVahan
                                                                        ? `b). PSB APNA VAHAN`
                                                                        : isPSBEducationLoan
                                                                            ? `c). PSB EDUCATION LOAN`
                                                                            : isPSBGoldLoan
                                                                                ? `d). PSB GOLD LOAN`
                                                                                : isPSBPersonalLoan
                                                                                    ? `e). PSB PERSONAL LOAN`
                                                                                    : isGecl
                                                                                        ? `g). GECL`
                                                                                        : isOtherRetail
                                                                                            ? `f). Other Retail`
                                                                                            : isOtherMSME
                                                                                                ? `h).Other MSME`
                                                                                                : isOtherMSME200
                                                                                                    ? `i).Other MSME (Product Wise above 200 Crore)`
                                                                                                    : isOtherRetail200
                                                                                                        ? `g).Other Retail (Product Wise above 200 Crore)`
                                                                                                        : isRetailZonewise
                                                                                                            ? `5.2 Retail Segment: i) Zone-wise Bifurcation`
                                                                                                            : isMSMEZonewise
                                                                                                                ? `5.1 MSME Segment: i). Zone-wise Bifurcation`
                                                                                                                : isBalanceReport17
                                                                                                                    ? `5.3). Agriculture Segment - Zone-wise Bifurcation`
                                                                                                                    : isKCC
                                                                                                                        ? `i) Product Wise Bifurcation: a) KCC:`
                                                                                                                        : isOtherAgriculture
                                                                                                                            ? `b). Other Agricultural`
                                                                                                                            : isOtherAgriculture100
                                                                                                                                ? `c). Other Agricultural (Product Wise above 100 Crore)`
                                                                                                                                : isRenewableEnergy
                                                                                                                                    ? `5.3). Renewable Energy Advances`
                                                                                                                                    : isMajorCreditProposals
                                                                                                                                        ? `7.2 Major credit proposals to NBFCs sanctioned ${formattedToDate}`
                                                                                                                                        : isMajorBanks
                                                                                                                                            ? `7.3 Bank's Exposure to NBFCs based on composition`
                                                                                                                                            : isSnapKCC
                                                                                                                                                ? `7.4 Snapshot of External rating distribution of NBFC Portfolio`
                                                                                                                                                : isExternalRating
                                                                                                                                                    ? `8.1 External Rating Position as on ${formattedFromDate} viz-a-viz ${formattedToDate}`
                                                                                                                                                    : isExternalRatingPosition
                                                                                                                                                        ? `8 External Rating Wise position of Bank's Advances Portfolio`
                                                                                                                                                        : isRatingComparison
                                                                                                                                                            ? `8.5 ii List of Major Borrowers where External rating were upgraded in ${formattedFromDate} viz-a-viz ${formattedToDate}`
                                                                                                                                                            : isOffBalancesheet
                                                                                                                                                                ? `6 Off Balance Sheet Exposure`
                                                                                                                                                                : isRatingUpgraded
                                                                                                                                                                    ? `8.5 Major Changes between ${formattedFromDate} and ${formattedToDate}`
                                                                                                                                                                    : isRatingTurned
                                                                                                                                                                        ? `8.5 iii List of Major Borrowers turned to NPA in ${formattedFromDate} viz-a-viz ${formattedToDate}`
                                                                                                                                                                        : isPortfolioQuality
                                                                                                                                                                            ? `7.5 Portfolio Quality Index (PQI)`
                                                                                                                                                                            : isBankscredit
                                                                                                                                                                                ? `7.1 Trend of Bank's Credit Exposure (Funded) to NBFCs`
                                                                                                                                                                                : isRatingMigration
                                                                                                                                                                                    ? `8.3 Rating Migration and Distribution`
                                                                                                                                                                                    : `1. Sector Wise Advances Portfolio as on ${formattedToDate}`;

        const x = 40;
        pdf.text(title, x, startY + 5);


        const textWidth = pdf.getTextWidth(title);
        pdf.setLineWidth(0.8);
        pdf.line(x, startY + 8, x + textWidth, startY + 8);
        // pdf.text("(₹ in Crores)", pageWidth - 40, startYY, { align: "right" });
        // Register font

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(11);

        startY += 25;

        // startY += wrappedMain.length * 14 + 5;
        // pdf.text("can be segmented as below:", 40, startY);
        if (!isBalanceReport && !isBalanceReport10 && !isGuaranteeReport && !isBalanceReport11 && !isBalanceReport12 && !isBalanceReport13 && !isBalanceReport14
            && !isBalanceReport15 && !isBalanceReport16 && !isBalanceReport17 && !isPsbgstease && !isContractorplus && !isGecl && !isOtherMSME && !isOtherMSME200 && !isApnaGhar && !isApnaGharVahan
            && !isPSBEducationLoan && !isPSBGoldLoan && !isPSBPersonalLoan && !isOtherRetail && !isOtherRetail200 && !isOtherAgriculture && !isOtherAgriculture100 &&
            !isKCC && !isRenewableEnergy && !isMajorCreditProposals && !isMajorBanks && !isExternalRating && !isRatingComparison && !isBankscredit && !isRatingTurned) {
            // 🔹 Format fromDate
            const fd = new Date(fromDate);
            const fromDay = String(fd.getDate()).padStart(2, "0");
            const fromMonth = String(fd.getMonth() + 1).padStart(2, "0");
            const fromYear = fd.getFullYear();
            const formattedFromDate = `${fromDay}-${fromMonth}-${fromYear}`;

            // 🔹 Format toDate
            const td = new Date(toDate);
            const toDay = String(td.getDate()).padStart(2, "0");
            const toMonth = String(td.getMonth() + 1).padStart(2, "0");
            const toYear = td.getFullYear();
            const formattedToDate = `${toDay}-${toMonth}-${toYear}`;

            const md = new Date(midDate);
            const mdDay = String(md.getDate()).padStart(2, "0");
            const mdMonth = String(md.getMonth() + 1).padStart(2, "0");
            const mdYear = md.getFullYear();
            // const formattedmdDate = `${mdDay}-${mdMonth}-${mdYear}`;

            let tempMidDate = midDate;
            if ((selectedName === "report17") && !tempMidDate && availableDates.length >= 3) {
                const midIndex = Math.floor(availableDates.length / 2);
                tempMidDate = availableDates[midIndex];
            }

            let formattedmdDate = "";
            if (tempMidDate) {
                const md = new Date(tempMidDate);
                formattedmdDate = `${String(md.getDate()).padStart(2, "0")}-${String(md.getMonth() + 1).padStart(2, "0")}-${md.getFullYear()}`;
            }

            // const headingMain = isGeo
            const headingMain = isOver
                ? `Bank's credit portfolio (outstanding amount), NPA & SMA position as on ${formattedToDate} vis - a - vis ${formattedFromDate}`
                : isGeo
                    ? `Region wise concentration of Bank's advances as on ${formattedFromDate} and ${formattedToDate} is given in below table:`
                    : isGlReport
                        ? `Zone wise concentration of Bank's total advances as on ${formattedFromDate} and ${formattedToDate} is given in below table:`
                        : isRetailZonewise
                            ? `Following table depicts the Zone-wise bifurcation of Retail advances:`
                            : isMSMEZonewise
                                ? `Following table depicts the Zone-wise bifurcation of MSME advances:`
                                : isSnapKCC
                                    ? ` External rating-wise distribution of NBFC's Exposure of ${formattedFromDate}, ${formattedmdDate} and ${formattedToDate} is given
   below:`
                                    : isExternalRatingPosition
                                        ? `8.1 External Rating Position as on ${formattedFromDate} viz-a viz ${formattedToDate}`
                                        : isRatingUpgraded
                                            ? `8.5 i List of Major Borrowers where External rating were downgraded in ${formattedFromDate} viz-a-viz ${formattedToDate}`
                                            : isPortfolioQuality
                                                ? `PQI is the weighted average rating of the underlying portfolio. It attempts to gauge the overall health of a portfolio. The PQI may be interpreted as the weighted average rating of the portfolio with the following attributes:`
                                                : isRatingMigration
                                                    ? `Rating wise migration of Bank's corporate advances is given in below table:-`
                                                    : isOffBalancesheet
                                                        ? `6.1 Bank Guarantee & Letter of Credit:-`
                                                        : `Bank's credit portfolio (outstanding amount), NPA & SMA position as on ${formattedToDate} vis - a - vis ${formattedFromDate}`;

            const wrappedMain = pdf.splitTextToSize(headingMain, pageWidth - 80);
            pdf.text(wrappedMain, 40, startY);


            // Add bullet points for Portfolio Quality section with same arrow symbol formatting
            if (isPortfolioQuality) {
                startY += wrappedMain.length * 14 + 5;

                const bulletPoints = [
                    "Higher the PQI value of a portfolio, the riskier the portfolio or the poorer the quality of borrowers in the portfolio",
                    "Lesser the value of PQI, the better the quality of borrowers in the portfolio."
                ];

                // Use the same font and formatting as npaDescription
                pdf.setFont("helvetica", "normal");
                pdf.setFontSize(9);
                pdf.setTextColor(34, 34, 34);

                bulletPoints.forEach((point) => {
                    const wrappedText = pdf.splitTextToSize(point, pageWidth - 100);

                    wrappedText.forEach((line, i) => {
                        if (i === 0) {
                            // Bullet - same symbol as npaDescription
                            pdf.setFont("DejaVuSans", "normal");
                            pdf.text("➢", 60, startY);
                        }

                        let cursorX = 75;
                        const parts = line.split(/(₹)/); // Keep ₹ intact

                        parts.forEach((part) => {
                            if (!part) return;

                            if (part === "₹") {
                                pdf.setFont("NotoSansDevanagari-Regular", "normal");
                            } else {
                                pdf.setFont("helvetica", "normal");
                            }

                            pdf.text(part, cursorX, startY);
                            cursorX += pdf.getTextWidth(part);
                        });

                        startY += 12;
                    });

                    startY += 5;
                });
            }

            startY += wrappedMain.length * 14 + 5;
            // pdf.text("can be segmented as below:", 40, startY);
            if (isOver) {
                pdf.text("can be segmented as below:", 40, startY);
                startY += 20;
            }

            startY += 20;
        }
        // Draw "(₹ in Crores)" always at table top-right
        if (reportName != "interactive1" && reportName != "unavailed_data1" && reportName != "report23") {
            const label = "in Crores";
            pdf.setFontSize(9);


            // Measure label width
            pdf.setFont("helvetica", "normal");
            const labelWidth = pdf.getTextWidth(label);

            // X coordinate: right margin minus some padding
            const paddingRight = 20;
            const rupeeX = pageWidth - 40 - labelWidth - 15; // 10px gap for ₹
            const textY = startY - 5; // slightly above table start

            // 1. Draw Rupee symbol with Devanagari font
            if (reportName === "reportmart") {
                pdf.setFont("NotoSansDevanagari-Regular", "normal");
                pdf.text("(Amt.", rupeeX, textY);

                // 2. Draw "in Crores" with helvetica, right-aligned to margin
                pdf.setFont("helvetica", "normal");
                pdf.text("in Lakh )", pageWidth - 30, textY, { align: "right" });
            } else {
                pdf.setFont("NotoSansDevanagari-Regular", "normal");
                pdf.text("(₹", rupeeX, textY);

                // 2. Draw "in Crores" with helvetica, right-aligned to margin
                pdf.setFont("helvetica", "normal");
                pdf.text("in Crores )", pageWidth - 40, textY, { align: "right" });
            }
        }


        let fontSize = reportName === "actcust" ? 4 : reportName === "report9" ? 3 : reportName === "additional_gl_balance" ? 3.5 : reportName === "distribution_exposure" ? 4 : reportName === "accounting_code" ? 5 : reportName === "exchange_rates" ? 4 : reportName === "investment_depreciationamount" ? 4.5 : reportName === "pf_superannuation" ? 4 : reportName === "profit_flag" ? 4.5 : reportName === "fully_unavailed_tl" ? 4.5 : reportName === "rating_override"
            ? 4.5 : reportName === "restructured_data" ? 4 : reportName === "balance_sheet" ? 4 : reportName === "bulkdatarecords4" ? 4 : reportName === "bulkdatarecords5" ? 4 : reportName === "bulkdatarecords6" ? 4 : reportName === "bulkrecordsupload" ? 3.5 : reportName === "bulkuploads56" ? 4 : reportName === "report" ?
                4 : reportName === "report3" ? 4 : reportName === "report4" ? 4 : reportName === "report5" ? 4 : reportName === "report6" ? 4 : reportName === "report7" ? 4 : reportName === "report8" ? 3.5 :
                    reportName === "report10" ? 4 : reportName === "report11" ? 4 : reportName === "unavailed_data" ? 4.5 : reportName === "report13" ? 4 : reportName === "report14" ? 4 : reportName === "report15" ? 4.5 : reportName === "report18" ? 3 : reportName === "report20" ? 4.5 : reportName === "npa_test1" ? 4.5 : reportName === "reportmart"
                        ? 4.5 : reportName === "report21" ? 4.5 : reportName === "report22" ? 4.5 : reportName === "report23" ? 4.5 : reportName === "unavailed_data1" ? 4 : reportName === "unavailed_data8" ? 4.5 : 4.5;
        // --- Draw table
        // let fontSize = 5;


        if (reportName !== "report9" && reportName !== "report18" && reportName !== "interactive1" && reportName !== "report23") {
            let tableFits = false;
            const pageHeight = pdf.internal.pageSize.getHeight();

            while (!tableFits && fontSize <= 10) {
                autoTable(pdf, {
                    head,
                    body,
                    startY,
                    margin: { left: 30, right: 30 },
                    theme: "grid",
                    styles: {
                        fontSize,
                        cellPadding: 2,
                        overflow: "ellipsize",
                        lineWidth: 0.5,
                        lineColor: [0, 0, 0],
                        halign: "center",
                        fontStyle: "bold",
                        valign: "middle",
                    },
                    headStyles: {
                        fillColor: [173, 216, 230],
                        textColor: [0, 0, 0],
                        fontSize,
                        lineWidth: 0.7,
                        lineColor: [0, 0, 0],
                        fontStyle: "bold",
                    },
                    bodyStyles: {
                        // fontStyle: "bold",   // 🔹 makes all tbody content bold
                        textColor: [34, 34, 34]
                    },
                    tableWidth: "auto",
                    didDrawPage: data => {
                        tableFits = data.cursor.y <= pageHeight - 40;
                    }
                });

                if (!tableFits) {
                    pdf.deletePage(pdf.getNumberOfPages());
                    fontSize -= 0.5;
                }
            }
        }

        // Add Overall Rating Stability for unavailed_data1
        if (reportName === "unavailed_data1") {
            const finalY = pdf.lastAutoTable?.finalY ? pdf.lastAutoTable.finalY + 20 : startY + 20;

            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(11);
            pdf.text(`Overall Rating Stability = ${overallStability}`, pageWidth / 2, finalY, { align: "center" });
        }
        // 🔹 After the table rendering finishes

        else if (reportName === "report23") {
            const rows = transformed["All Data"] || [];
            if (rows.length > 0) {
                const pageHeight = pdf.internal.pageSize.getHeight();
                const pageWidth = pdf.internal.pageSize.getWidth();
                let tableFits = false;
                let fontSize = 10;

                // Format the table data with the same date formatting
                const formattedBody = body.map(row => {
                    // Format the period date in the first column
                    const formattedRow = [...row];
                    if (formattedRow[0]) {
                        formattedRow[0] = formatPeriodDate(formattedRow[0]);
                    }
                    return formattedRow;
                });

                // --- Step 1: Draw the table ---
                while (!tableFits && fontSize >= 6) {
                    autoTable(pdf, {
                        head,
                        body: formattedBody, // Use the formatted body
                        startY,
                        margin: { left: 30, right: 30 },
                        theme: "grid",
                        styles: {
                            fontSize,
                            cellPadding: 2,
                            overflow: "ellipsize",
                            lineWidth: 0.5,
                            lineColor: [0, 0, 0],
                            halign: "center",
                            fontStyle: "bold",
                            valign: "middle",
                        },
                        headStyles: {
                            fillColor: [173, 216, 230],
                            textColor: [0, 0, 0],
                            fontSize,
                            lineWidth: 0.7,
                            lineColor: [0, 0, 0],
                            fontStyle: "bold",
                        },
                        bodyStyles: {
                            textColor: [34, 34, 34],
                        },
                        tableWidth: "auto",
                        didDrawPage: (data) => {
                            tableFits = data.cursor.y <= pageHeight - 40;
                        },
                    });

                    if (!tableFits) {
                        pdf.deletePage(pdf.getNumberOfPages());
                        fontSize -= 0.5;
                    }
                }

                // --- Step 2: Draw the PQI Curve Graph below the table ---
                const yStart = pdf.lastAutoTable?.finalY ? pdf.lastAutoTable.finalY + 25 : 100;

                const boxWidth = pageWidth - 100;
                const boxX = 50;
                const boxY = yStart;
                const boxHeight = 110;

                // Box border
                pdf.setDrawColor(180);
                pdf.roundedRect(boxX, boxY, boxWidth, boxHeight, 5, 5);

                // --- Heading INSIDE the box ---
                pdf.setFont("helvetica", "bold");
                pdf.setFontSize(13);
                pdf.setTextColor(0);
                pdf.text("PQI Curve: NBFC", pageWidth / 2, boxY + 15, { align: "center" });

                // --- Graph points ---
                const graphMarginX = 80;
                const usableWidth = boxWidth - graphMarginX * 2;
                const stepX = rows.length > 1 ? usableWidth / (rows.length - 1) : 0;
                // Compute PQI range
                const pqiValues = rows.map(r => Number(r.Portfolio_Quality_Index) || 0);
                const minPQI = Math.min(...pqiValues);
                const maxPQI = Math.max(...pqiValues);

                // Define Y range inside the box (top-down, inverted)
                const chartTop = boxY + 30;
                const chartBottom = boxY + boxHeight - 30;

                // Helper to scale PQI -> Y position
                const scaleY = (value) => {
                    if (maxPQI === minPQI) return (chartTop + chartBottom) / 2; // Avoid division by zero
                    const normalized = (value - minPQI) / (maxPQI - minPQI);
                    return chartBottom - normalized * (chartBottom - chartTop); // invert Y
                };

                const points = rows.map((r, i) => ({
                    label: formatPeriodDate(r.Period), // Format the period date for graph labels
                    value: Number(r.Portfolio_Quality_Index) || 0,
                    x: boxX + graphMarginX + i * stepX,
                    y: scaleY(Number(r.Portfolio_Quality_Index) || 0),
                }));

                // Connecting line
                if (points.length >= 2) {
                    pdf.setLineWidth(1.5);
                    pdf.setDrawColor(214, 39, 40);
                    for (let i = 0; i < points.length - 1; i++) {
                        pdf.line(points[i].x, points[i].y, points[i + 1].x, points[i + 1].y);
                    }
                }

                // Circles + labels
                points.forEach((p) => {
                    pdf.setFillColor(214, 39, 40);
                    pdf.circle(p.x, p.y, 10, "F");

                    pdf.setTextColor(255, 255, 255);
                    pdf.setFont("helvetica", "bold");
                    pdf.setFontSize(10);
                    pdf.text(String(p.value.toFixed(2)), p.x, p.y + 3, { align: "center" });

                    pdf.setTextColor(80);
                    pdf.setFont("helvetica", "bold");
                    pdf.setFontSize(9);
                    pdf.text(p.label, p.x, p.y + 25, { align: "center" });
                });

                // --- Step 3: Add short bold description below the box ---
            }
        }


        // Add this helper function at the top level of your file
        function formatPeriodDate(period) {
            if (!period || typeof period !== 'string') return period;

            // Handle YYYY-MM-DD format (like "2024-12-31")
            const yyyymmddMatch = period.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (yyyymmddMatch) {
                const [, year, month, day] = yyyymmddMatch;
                const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                const monthName = monthNames[parseInt(month) - 1];
                const shortYear = year.slice(-2);
                return `${monthName}-${shortYear}`;
            }

            // Handle original format (like "MAR'25")
            return period.replace(/([A-Z]+)'(\d{2})/, (match, month, year) => {
                const monthNames = {
                    'JAN': 'Jan', 'FEB': 'Feb', 'MAR': 'Mar', 'APR': 'Apr',
                    'MAY': 'May', 'JUNE': 'Jun', 'JULY': 'Jul', 'AUG': 'Aug',
                    'SEP': 'Sep', 'OCT': 'Oct', 'NOV': 'Nov', 'DEC': 'Dec'
                };
                return `${monthNames[month] || month}-${year}`;
            });
        }

        if (reportName === "report16") {
            const tableData = processedReports.report16?.flattenedData || [];
            console.log("tableData for report16", tableData);
            // Group data by reporting date
            const reduced = tableData.reduce((acc, item) => {
                if (!acc[item.reporting_date]) acc[item.reporting_date] = [];
                acc[item.reporting_date].push(item);
                return acc;
            }, {});

            const dates = Object.keys(reduced);
            let fontSize = 4.5;

            // Columns under each reporting date
            const subCols = ["Total Exposure", "% to Total Exposure", "Total NPA", "NPA %"];

            // Build table head with 2 rows (no NBFC Sub-sector)
            const head = [
                // First row: reporting dates spanning 4 columns each
                [
                    {
                        content: "NBFC Sub-sector",
                        rowSpan: 2,
                        styles: { fontStyle: "bold", halign: "center", fillColor: [173, 216, 230], fontSize }
                    },
                    ...dates.map(date => ({
                        content: date,
                        colSpan: subCols.length,
                        styles: { fontStyle: "bold", halign: "center", fillColor: [173, 216, 230], fontSize }
                    }))
                ],
                // Second row: sub-columns for each reporting date
                [
                    // {}, // Placeholder for first column
                    ...dates.flatMap(() => subCols.map(col => ({
                        content: col,
                        styles: { fontStyle: "bold", halign: "center", fillColor: [173, 216, 230], fontSize }
                    })))
                ]
            ];

            // Build table body
            const subSectors = Array.from(new Set(tableData.map(d => d.rep_param)));
            const body = subSectors.map(subSector => {
                const row = [
                    { content: subSector, styles: { fontStyle: "bold", halign: "center" } }
                ];
                dates.forEach(date => {
                    const items = reduced[date];
                    const rowData = items.find(d => d.rep_param === subSector);
                    if (rowData) {
                        row.push(
                            { content: rowData.os_balance != null ? rowData.os_balance.toLocaleString() : "0", styles: { halign: "center" } },
                            { content: rowData.roi != null ? rowData.roi.toLocaleString() : "0", styles: { halign: "center" } },
                            { content: rowData.npa != null ? rowData.npa.toLocaleString() : "0", styles: { halign: "center" } },
                            { content: rowData.npa_percent != null ? rowData.npa_percent.toLocaleString() : "0", styles: { halign: "center" } }
                        );

                    } else {
                        row.push(
                            { content: "0", styles: { halign: "center" } },
                            { content: "0", styles: { halign: "center" } },
                            { content: "0", styles: { halign: "center" } },
                            { content: "0", styles: { halign: "center" } }
                        );

                    }
                });
                return row;
            });

            // Generate PDF table with fixed font size 4
            autoTable(pdf, {
                head,
                body,
                startY,
                margin: { left: 30, right: 30 },
                theme: "grid",
                styles: {
                    fontSize,
                    cellPadding: 2,
                    overflow: "ellipsize",
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    halign: "center",
                    fontStyle: "bold",
                    valign: "middle",
                },
                headStyles: {
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    fontSize,
                    fontStyle: "bold",
                    lineWidth: 0.7,
                    lineColor: [0, 0, 0],
                },
                bodyStyles: { textColor: [34, 34, 34] },
                tableWidth: "auto",
            });
        }

        if (reportName === "report17") {
            const tableData = processedReports.report17?.flattenedData || [];
            console.log("tableData for report17", tableData);
            // Group data by reporting date
            const reduced = tableData.reduce((acc, item) => {
                if (!acc[item.reporting_date]) acc[item.reporting_date] = [];
                acc[item.reporting_date].push(item);
                return acc;
            }, {});

            let fontSize = 5;
            const dates = Object.keys(reduced);

            // Columns under each reporting date
            const subCols = ["Exposure", "% to Total"];

            // Build table head with 2 rows (no NBFC Sub-sector)
            const head = [
                // First row: reporting dates spanning 4 columns each
                [
                    {
                        content: "Rating Category",
                        rowSpan: 2,
                        styles: { fontStyle: "bold", halign: "center", fillColor: [173, 216, 230], fontSize }
                    },
                    ...dates.map(date => ({
                        content: date,
                        colSpan: subCols.length,
                        styles: { fontStyle: "bold", halign: "center", fillColor: [173, 216, 230], fontSize }
                    }))
                ],
                // Second row: sub-columns for each reporting date
                [
                    // {}, // Placeholder for first column
                    ...dates.flatMap(() => subCols.map(col => ({
                        content: col,
                        styles: { fontStyle: "bold", halign: "center", fillColor: [173, 216, 230], fontSize }
                    })))
                ]
            ];

            // Build table body
            const subSectors = Array.from(new Set(tableData.map(d => d.rep_param)));
            const body = subSectors.map(subSector => {
                const row = [
                    { content: subSector, styles: { fontStyle: "bold", halign: "center" } }
                ];
                dates.forEach(date => {
                    const items = reduced[date];
                    const rowData = items.find(d => d.rep_param === subSector);
                    if (rowData) {
                        row.push(
                            { content: rowData.os_balance != null ? rowData.os_balance.toLocaleString() : "0", styles: { halign: "center" } },
                            { content: rowData.percentage != null ? rowData.percentage.toLocaleString() : "0", styles: { halign: "center" } }
                        );

                    } else {
                        row.push(
                            { content: "0", styles: { halign: "center" } },
                            { content: "0", styles: { halign: "center" } }
                        );

                    }
                });
                return row;
            });

            // Generate PDF table with fixed font size 4
            autoTable(pdf, {
                head,
                body,
                startY,
                margin: { left: 30, right: 30 },
                theme: "grid",
                styles: {
                    fontSize,
                    cellPadding: 2,
                    overflow: "ellipsize",
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    halign: "center",
                    fontStyle: "bold",
                    valign: "middle",
                },
                headStyles: {
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    fontSize,
                    fontStyle: "bold",
                    lineWidth: 0.7,
                    lineColor: [0, 0, 0],
                },
                bodyStyles: { textColor: [34, 34, 34] },
                tableWidth: "auto",
            });
        }


        if (reportName === "report9" && isGuaranteeReport && differenceTable.length > 0) {
            const baseY = pdf.lastAutoTable ? pdf.lastAutoTable.finalY : startY;
            const tableTop = 260;

            const totalWidth = pageWidth - 80; // total usable width with some margin
            const toDateTableWidth = totalWidth * 0.80; // left table 55%
            const diffTableWidth = totalWidth * 0.25;   // right table 45%
            const leftMargin = 30;
            const gapBetween = 0;

            // --- Draw the To-Date Table (left) ---
            autoTable(pdf, {
                head,
                body,
                startY: tableTop,
                margin: { left: leftMargin },
                tableWidth: toDateTableWidth,
                theme: "grid",
                styles: {
                    fontSize,
                    cellPadding: 2, // reduce padding
                    overflow: "ellipsize",
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    halign: "center",
                    fontStyle: "bold",
                    valign: "middle",
                },
                headStyles: {
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    fontSize,
                    lineWidth: 0.7,
                    lineColor: [0, 0, 0],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    textColor: [34, 34, 34],
                },
            });

            // --- Draw the Difference Heading ---
            const rightMarginLeft = leftMargin + toDateTableWidth + gapBetween;
            const headingText = "Difference";
            const headingHeight = 7.5;

            pdf.setFillColor(173, 216, 230);
            pdf.rect(rightMarginLeft, tableTop, diffTableWidth, headingHeight, "F"); // background
            pdf.setDrawColor(0, 0, 0);
            pdf.setLineWidth(0.5);
            pdf.rect(rightMarginLeft, tableTop, diffTableWidth, headingHeight); // border

            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(fontSize + 1);
            pdf.setTextColor(0, 0, 0);
            pdf.setLineWidth(0.5);
            pdf.text(
                headingText,
                rightMarginLeft + diffTableWidth / 2,
                tableTop + headingHeight / 2 + 1,
                { align: "center" }
            );

            // --- Draw the Difference Table below the heading ---
            const extraHeaderCols = ["Balance ", "NPA ", "SMA "];
            const extraBody = differenceTable.map(row =>
                extraHeaderCols.map(col => row[col] ?? "")
            );
            const extraHead = extraHeaderCols.map(col => ({
                content: col,
                styles: {
                    fontStyle: "bold",
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    halign: "center",
                    lineColor: [0, 0, 0],
                },
            }));

            autoTable(pdf, {
                startY: tableTop + headingHeight,
                head: [extraHead],
                body: extraBody,
                margin: { left: rightMarginLeft }, // start at right table position
                tableWidth: diffTableWidth,
                theme: "grid",
                styles: {
                    fontSize,
                    cellPadding: 2, // reduce padding
                    overflow: "ellipsize",
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    halign: "center",
                    fontStyle: "bold",
                    valign: "middle",
                },
                headStyles: {
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    cellPadding: 2.1,
                    fontSize,
                    lineWidth: 0.7,
                    lineColor: [0, 0, 0],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    textColor: [34, 34, 34],
                },
                didParseCell: data => {
                    if (data.row.index === extraBody.length - 1) {
                        data.cell.styles.fillColor = [173, 216, 230];
                        data.cell.styles.fontStyle = "bold";
                    }
                },
            });
        }

        let finalY = (pdf.lastAutoTable && pdf.lastAutoTable.finalY) ? pdf.lastAutoTable.finalY + 20 : startY + 20;

        if (reportName === "interactive1" && isBankscredit) {
            if (tableData && tableData.length > 0) {
                const chartWidth = pageWidth - 120;
                const chartHeight = 280;
                const chartX = 60;
                const chartY = startY;

                // ✅ Chart border in red
                pdf.setDrawColor(220, 53, 69);
                pdf.setLineWidth(1.2);
                pdf.rect(chartX, chartY, chartWidth, chartHeight);

                // ✅ Title inside chart box (top center)
                pdf.setFont("helvetica", "bold");
                pdf.setFontSize(11);
                pdf.setTextColor(220, 53, 69); // Red title color to match border
                pdf.text("NBFC's Exposure and NPA", chartX + chartWidth / 2, chartY + 12, { align: "center" });

                const plotTop = chartY + 25;
                const plotHeight = chartHeight - 50;

                const maxExposure = Math.max(...tableData.map(d => d["Bank's Exposure in NBFC"] || 0));
                const maxNPA = Math.max(...tableData.map(d => d["Bank's NPA in NBFC"] || 0));
                const maxValueRaw = Math.max(maxExposure, maxNPA);
                const maxValue = Math.ceil(maxValueRaw / 1000) * 1000;
                const minValue = 0;
                const scaleFactor = plotHeight / (maxValue * 1.1);

                const dateCount = tableData.length;
                const columnWidth = chartWidth / (dateCount + 1);

                // Y-axis gridlines and labels
                pdf.setFontSize(9);
                pdf.setTextColor(0, 0, 0);
                const desiredTicks = 5;
                const step = maxValue / desiredTicks;
                const roundedTicks = [];

                for (let i = 0; i <= desiredTicks; i++) {
                    const rawValue = i * step;
                    const roundedValue = Math.round(rawValue / 1000) * 1000;
                    if (!roundedTicks.includes(roundedValue) && roundedValue <= maxValue) {
                        roundedTicks.push(roundedValue);
                    }
                }

                roundedTicks.forEach(value => {
                    const y = plotTop + plotHeight - (value * scaleFactor);
                    pdf.setDrawColor(220, 220, 220);
                    pdf.line(chartX, y, chartX + chartWidth, y);
                    pdf.setTextColor(0, 0, 0);
                    pdf.text(`${value.toLocaleString('en-IN')}`, chartX + 8, y + 2, { align: "left" });
                });

                let prevExposureX = null, prevExposureY = null;
                let prevNPAX = null, prevNPAY = null;

                // Plot data
                tableData.forEach((item, index) => {
                    const x = chartX + (index + 1) * columnWidth;
                    const exposureValue = item["Bank's Exposure in NBFC"] || 0;
                    const npaValue = item["Bank's NPA in NBFC"] || 0;
                    const exposureY = plotTop + plotHeight - (exposureValue * scaleFactor);
                    const npaY = plotTop + plotHeight - (npaValue * scaleFactor);

                    // Exposure (blue)
                    pdf.setDrawColor(0, 123, 255);
                    pdf.setLineWidth(1.2);
                    if (prevExposureX !== null) pdf.line(prevExposureX, prevExposureY, x, exposureY);
                    pdf.setFillColor(0, 123, 255);
                    pdf.circle(x, exposureY, 2.5, "F");
                    prevExposureX = x;
                    prevExposureY = exposureY;

                    // NPA (red)
                    pdf.setDrawColor(220, 53, 69);
                    pdf.setLineWidth(1.2);
                    if (prevNPAX !== null) pdf.line(prevNPAX, prevNPAY, x, npaY);
                    pdf.setFillColor(220, 53, 69);
                    pdf.circle(x, npaY, 2.5, "F");
                    prevNPAX = x;
                    prevNPAY = npaY;

                    // Value labels
                    pdf.setFontSize(9);
                    if (Math.abs(exposureY - npaY) < 15) {
                        pdf.setTextColor(0, 123, 255);
                        pdf.text(exposureValue.toLocaleString('en-IN'), x, exposureY - 15, { align: "center" });

                        pdf.setTextColor(220, 53, 69);
                        pdf.text(npaValue.toLocaleString('en-IN'), x, npaY + 15, { align: "center" });
                    } else {
                        pdf.setTextColor(0, 123, 255);
                        pdf.text(exposureValue.toLocaleString('en-IN'), x, exposureY - 8, { align: "center" });

                        pdf.setTextColor(220, 53, 69);
                        pdf.text(npaValue.toLocaleString('en-IN'), x, npaY - 8, { align: "center" });
                    }

                    // ✅ X-axis labels in "Mon-YY" format
                    const dateStr = item.Date;
                    const formattedDate = (() => {
                        const d = new Date(dateStr);
                        if (isNaN(d)) return dateStr;
                        return d.toLocaleString('en-GB', { month: 'short', year: '2-digit' }).replace(' ', '-');
                    })();
                    pdf.setFontSize(9);
                    pdf.setTextColor(0, 0, 0);
                    pdf.text(formattedDate, x, plotTop + plotHeight + 6, { align: "center" });
                });

                // ✅ Legends inside chart (bottom center)
                const legendY = chartY + chartHeight - 10;
                const legendCenterX = chartX + chartWidth / 2 - 40;
                pdf.setFontSize(9);
                pdf.setTextColor(0, 0, 0);

                // Exposure legend (Blue)
                pdf.setFillColor(0, 123, 255);
                pdf.rect(legendCenterX - 80, legendY, 8, 8, "F");
                pdf.text("Bank's exposure in NBFC", legendCenterX - 70, legendY + 6);

                // NPA legend (Red)
                pdf.setFillColor(220, 53, 69);
                pdf.rect(legendCenterX + 50, legendY, 8, 8, "F");
                pdf.text("Bank's exposure of NPAs in NBFCs", legendCenterX + 62, legendY + 6);

                finalY = chartY + chartHeight + 20;
            }
        }





        if (reportName === "report18" && isExternalRating && differenceTable1.length > 0) {
            const baseY = pdf.lastAutoTable ? pdf.lastAutoTable.finalY : startY;
            const tableTop = 160;

            const totalWidth = pageWidth - 80; // total usable width with some margin
            const toDateTableWidth = totalWidth * 0.80; // left table 55%
            const diffTableWidth = totalWidth * 0.25;   // right table 45%
            const leftMargin = 30;
            const gapBetween = 0;

            // --- Draw the To-Date Table (left) ---
            autoTable(pdf, {
                head,
                body,
                startY: tableTop,
                margin: { left: leftMargin },
                tableWidth: toDateTableWidth,
                theme: "grid",
                styles: {
                    fontSize,
                    cellPadding: 2,
                    overflow: "ellipsize",
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    halign: "center",
                    fontStyle: "bold",
                    valign: "middle",
                },
                headStyles: {
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    fontSize,
                    lineWidth: 0.7,
                    lineColor: [0, 0, 0],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    textColor: [34, 34, 34],
                },
            });


            // --- Draw the Difference Heading ---
            const rightMarginLeft = leftMargin + toDateTableWidth + gapBetween;
            const headingText = "Difference";
            const headingHeight = 7.5;

            pdf.setFillColor(173, 216, 230);
            pdf.rect(rightMarginLeft, tableTop, diffTableWidth, headingHeight, "F"); // background
            pdf.setDrawColor(0, 0, 0);
            pdf.setLineWidth(0.5);
            pdf.rect(rightMarginLeft, tableTop, diffTableWidth, headingHeight); // border

            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(fontSize + 1);
            pdf.setTextColor(0, 0, 0);
            pdf.setLineWidth(0.5);
            pdf.text(
                headingText,
                rightMarginLeft + diffTableWidth / 2,
                tableTop + headingHeight / 2 + 1,
                { align: "center" }
            );

            // --- Draw the Difference Table below the heading ---
            const extraHeaderCols = [{ key: "Balance ", display: `Increase / Decrease in ${formattedFromDate} viz-a-viz ${formattedToDate}` }];

            // Prepare body using the key
            const extraBody = differenceTable1.map(row =>
                extraHeaderCols.map(col => row[col.key] ?? "")
            );

            // Prepare head using display name
            const extraHead = extraHeaderCols.map(col => ({
                content: col.display,  // <-- This is what will be shown as heading
                styles: {
                    fontStyle: "bold",
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    halign: "center",
                    lineColor: [0, 0, 0],
                },
            }));

            autoTable(pdf, {
                startY: tableTop + headingHeight,
                head: [extraHead],
                body: extraBody,
                margin: { left: rightMarginLeft }, // start at right table position
                tableWidth: diffTableWidth,
                theme: "grid",
                styles: {
                    fontSize,
                    cellPadding: 2, // reduce padding
                    overflow: "ellipsize",
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    halign: "center",
                    fontStyle: "bold",
                    valign: "middle",
                },
                headStyles: {
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    cellPadding: 2.1,
                    fontSize,
                    lineWidth: 0.7,
                    lineColor: [0, 0, 0],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    textColor: [34, 34, 34],
                },
                didParseCell: data => {
                    if (data.row.index === extraBody.length - 1) {
                        data.cell.styles.fillColor = [173, 216, 230];
                        data.cell.styles.fontStyle = "bold";
                    }
                },
            });
        }


        if (
            reportName === "actcust" ||
            reportName === "additional_gl_balance" ||
            reportName === "distribution_exposure" ||
            reportName === "exchange_rates" ||
            reportName === "investment_depreciationamount" ||
            reportName === "pf_superannuation" ||
            reportName === "profit_flag" ||
            // reportName === "fully_unavailed_tl" ||
            reportName === "rating_override" ||
            reportName === "restructured_data" ||
            reportName === "balance_sheet" ||
            reportName === "bulkdatarecords4" ||
            reportName === "bulkdatarecords5" ||
            reportName === "bulkdatarecords6" ||
            // reportName === "bulkrecordsupload" ||
            reportName === "bulkuploads56" ||
            reportName === "report" ||
            reportName === "report3" ||
            reportName === "report4" ||
            reportName === "report5" ||
            reportName === "report6" ||
            reportName === "report7" ||
            // reportName === "report8" ||
            reportName === "report10" ||
            // reportName === "report11" ||
            reportName === "report12" ||
            reportName === "report13"
            // reportName === "npa_test1"
            // reportName === "report14"
        ) {
            // Default placeholders

            // ✅ Use the same processedReports values
            const overallValue = processedReports?.[reportName]?.overallPortfolioYield ?? 0;
            const standardValue = processedReports?.[reportName]?.stdActsPortfolioYield ?? 0;

            // ✅ Format both values correctly with rounding
            const formattedOverall = `${Number(overallValue).toFixed(2).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}%`;

            const formattedStandard = `${Number(standardValue).toFixed(2).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}%`;


            console.log(`📊 PDF Yield Values for ${reportName}:`, {
                overallValue,
                standardValue,
                formattedOverall,
                formattedStandard,
            });


            // Small spacing before the yield table
            finalY += 5;

            // ✅ Add the yield summary table aligned to the right
            autoTable(pdf, {
                startY: finalY,
                body: [
                    ["Overall Portfolio Yield", overallValue],
                    ["Portfolio Yield on Standard Accounts", standardValue],
                ],
                theme: "grid",
                styles: {
                    fontSize: 9,
                    cellPadding: 5,
                    fontStyle: "bold",
                    halign: "left",
                    valign: "middle",
                },
                margin: {
                    left: pdf.internal.pageSize.getWidth() - 420,
                    right: 20,
                },
                tableWidth: 250,
                headStyles: {
                    fillColor: [173, 216, 230],
                    textColor: [0, 0, 0],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    lineColor: [0, 0, 0],
                    lineWidth: 0.5,
                    fontStyle: "bold",
                },
            });

            // Update Y position for next section
            finalY = pdf.lastAutoTable.finalY + 20;
        }


        // ✅ Ensure this is right before your description section
        // ✅ Maintain spacing after PQI curve box for report23
        if (reportName === "report23") {
            // Place description after the graph box
            if (pdf.lastAutoTable?.finalY) {
                finalY = pdf.lastAutoTable.finalY + 160;
            } else {
                finalY += 160;
            }
        }

        if (reportName === "unavailed_data1") {
            // Place description after the graph box
            if (pdf.lastAutoTable?.finalY) {
                finalY = pdf.lastAutoTable.finalY + 60;
            } else {
                finalY += 160;
            }
        }


        // ✅ Unified description section
        if (npaDescription) {
            // Bold title only for accounting_data
            if (reportName === "accounting_data") {
                pdf.setFont("helvetica", "bold");
                pdf.setFontSize(10);
                pdf.text("Following are the major observations of the segment:", 40, finalY);
                finalY += 15;
            }

            // 🔹 Match font style with other reports
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(9);
            pdf.setTextColor(34, 34, 34);

            const rawSentences = npaDescription.split(". ");
            const bulletPoints = [];
            let currentSentence = "";

            rawSentences.forEach((part, idx) => {
                const trimmed = part.trim();
                if (!trimmed) return;

                if (/^(and|or)\b/i.test(trimmed)) {
                    currentSentence += ". " + trimmed;
                } else {
                    if (currentSentence) bulletPoints.push(currentSentence + ".");
                    currentSentence = trimmed;
                }

                if (idx === rawSentences.length - 1) {
                    bulletPoints.push(currentSentence + ".");
                }
            });

            bulletPoints.forEach((point) => {
                const wrappedText = pdf.splitTextToSize(point, pageWidth - 100);

                wrappedText.forEach((line, i) => {
                    if (i === 0) {
                        // Bullet
                        pdf.setFont("DejaVuSans", "normal");
                        pdf.text("➢", 60, finalY);
                    }

                    let cursorX = 75;
                    const parts = line.split(/(₹)/); // Keep ₹ intact

                    parts.forEach((part) => {
                        if (!part) return;

                        if (part === "₹") {
                            pdf.setFont("NotoSansDevanagari-Regular", "normal");
                        } else {
                            pdf.setFont("helvetica", "normal");
                        }

                        pdf.text(part, cursorX, finalY);
                        cursorX += pdf.getTextWidth(part);
                    });

                    finalY += 12;
                });

                finalY += 5;
            });
        } else {
            // Default "No data" message for missing descriptions
            if (
                reportName !== "report20" &&
                reportName !== "reportmart" &&
                reportName !== "report21" &&
                reportName !== "report22"
            ) {
                pdf.setFont("helvetica", "normal");
                pdf.setFontSize(9);
                pdf.setTextColor(80);
                pdf.text("No data available for selected period.", 60, finalY);
            }
        }


        return pdf;
    };


    const downloadAllReports = () => {
        let pdf = new jsPDF("p", "pt", "a4");

        // Define the reports in the order you want them
        // const reportOrder = [
        //     // "accounting_code",
        //     // "accounting_data",
        //     // "actcust",
        //     "additional_gl_balance",
        //     // "distribution_exposure",
        //     // "exchange_rates",
        //     // "fully_unavailed_tl",
        //     // "report9",
        //     // "report13",
        //     // "investment_depreciationamount",
        //     // "rating_override",
        //     // "pf_superannuation",
        //     // "balance_sheet",
        //     // "profit_flag",
        //     // "bulkdatarecords4",
        //     // "bulkdatarecords5",
        //     // "bulkdatarecords6",
        //     // "bulkrecordsupload",
        //     // "bulkuploads56",
        //     // "report",
        //     // "report3",
        //     // "report4",
        //     // "report5",
        //     // "report6",
        //     // // "bulkdatarecords5",
        //     // "report7",
        //     // // "bulkdatarecords6",
        //     // // "bulkrecordsupload",
        //     // "report8",
        //     // // "bulkuploads56",
        //     // "restructured_data",
        //     // "report12",
        //     // "report10",
        //     // "report11",
        //     // "report14",
        //     // "report25",
        //     // // "report12",
        //     // "interactive1",
        //     // // "report15",
        //     // // "report16",
        //     // // "report17",
        //     // "npa_test1",
        //     // "report23",
        //     // "npa_account",
        //     // "report24",
        //     // // "report18",
        //     // "report21",
        //     // "report20",
        //     // "report22"

        // ];

        const reportOrder = [
            "accounting_code",
            "accounting_data",
            "actcust",
            "additional_gl_balance",
            "distribution_exposure",
            "exchange_rates",
            "fully_unavailed_tl",
            "report9",
            "report13",
            "investment_depreciationamount",
            "rating_override",
            "pf_superannuation",
            "balance_sheet",
            "profit_flag",
            "bulkdatarecords4",
            "bulkdatarecords5",
            "bulkdatarecords6",
            "bulkrecordsupload",
            "bulkuploads56",
            "report",
            "report3",
            "report4",
            "report5",
            "report6",
            "report7",
            "report8",
            "restructured_data",
            "unavailed_data",
            "report10",
            "report11",
            "report14",
            "unavailed_data8",
            "interactive1",
            "npa_test1",
            "report23",
            "reportmart",
            "unavailed_data1",
            "report21",
            "report20",
            "report22"
        ];

        reportOrder.forEach((rName, idx) => {
            const rObj = processedReports[rName];
            if (!rObj) {
                console.warn("Report missing:", rName);
                return;
            }

            pdf = downloadSingleReport({
                reportName: rName,
                reportObj: rObj,
                fromDate,
                toDate,
                midDate,
                pdfInstance: pdf,
                isOver: rName === "accounting_code",
                isGeoReport: rName === "accounting_data",
                isGlReport: rName === "actcust",
                isGuaranteeReport: rName === "report9",
                isMSMEZonewise: rName === "report13",
                isBalanceReport: rName === "additional_gl_balance",
                isBalanceReport10: rName === "distribution_exposure",
                isBalanceReport11: rName === "exchange_rates",
                isBalanceReport12: rName === "investment_depreciationamount",
                isBalanceReport13: rName === "pf_superannuation",
                isPsbgstease: rName === "balance_sheet",
                isBalanceReport14: rName === "profit_flag",
                isContractorplus: rName === "bulkdatarecords4",
                isApnaGhar: rName === "report",
                isApnaGharVahan: rName === "report3",
                isPSBEducationLoan: rName === "report4",
                isPSBGoldLoan: rName === "report5",
                isPSBPersonalLoan: rName === "report6",
                isGecl: rName === "bulkdatarecords5",
                isOtherRetail: rName === "report7",
                isOtherRetail200: rName === "report8",
                isOtherMSME: rName === "bulkdatarecords6",
                isOtherMSME200: rName === "bulkrecordsupload",
                isRetailZonewise: rName === "bulkuploads56",
                isBalanceReport15: rName === "fully_unavailed_tl",
                isBalanceReport16: rName === "rating_override",
                isBalanceReport17: rName === "restructured_data",
                isOtherAgriculture: rName === "report10",
                isKCC: rName === "unavailed_data",
                isSnapKCC: rName === "npa_test1",
                isExternalRatingPosition: rName === "reportmart",
                isSnapshotExternal: rName === "npa_test",
                isOtherAgriculture100: rName === "report11",
                isRenewableEnergy: rName === "report14",
                isMajorCreditProposals: rName === "report15",
                isMajorBanks: rName === "report16",
                isSnapshot: rName === "report17",
                isExternalRating: rName === "report18",
                isRatingComparison: rName === "report20",
                isRatingUpgraded: rName === "report21",
                isRatingMigration: rName === "unavailed_data1",
                isOffBalancesheet: rName === "unavailed_data8",
                isRatingTurned: rName === "report22",
                isPortfolioQuality: rName === "report23",
                isBankscredit: rName === "interactive1"
            });


            // Add a page break after each report except the last
            if (idx < reportOrder.length - 1) pdf.addPage();
        });
        const pageCount = pdf.internal.getNumberOfPages();
        pdf.setFontSize(8);

        for (let i = 1; i <= pageCount; i++) {
            pdf.setPage(i);
            pdf.text(
                `Page ${i} of ${pageCount}`,
                pdf.internal.pageSize.getWidth() - 20, // right side
                pdf.internal.pageSize.getHeight() - 10, // bottom
                { align: 'right' }
            );
        }
        // Save the combined PDF
        pdf.save("Portfolio Analysis report.pdf");
    };

    // Handler for download button click

    // Sorting the data based on the selected column and direction
    const sortedData = [...filteredData].sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        // Check if both values are numeric
        const isNumeric = !isNaN(parseFloat(aValue)) && !isNaN(parseFloat(bValue));

        if (isNumeric) {
            // Numeric comparison
            return sortConfig.direction === 'asc'
                ? parseFloat(aValue) - parseFloat(bValue)
                : parseFloat(bValue) - parseFloat(aValue);
        } else {
            // Lexicographic comparison for strings
            if (aValue < bValue) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
        }
    });


    const handleDashboard = () => {
        navigate("/gapsyCdashboard");
    };

    const formatDate1 = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
    };


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            {/* {Isloading && (
                <div className="d-flex justify-content-center align-items-center mt-3">
                    <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )} */}

            {/* {Isloading && (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <UploadLoadingIcon />
                </div>
            )} */}

            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a className={`text-info ${styles.textInfo}`} onClick={handleDashboard} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    {/* <i className="bi bi-file-richtext me-2"></i> Trend Analysis Report */}
                                    <i className="bi bi-graph-up me-2"></i> Portfolio Report
                                </li>
                            </ol>
                        </nav>
                    </div>

                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            {/* left side Column code */}
                            <div className="col-lg-3 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <form className="w-100">
                                            {/* Custom Tab Navigation */}
                                            <div className={tabStyles.tabContainer}>
                                                <div
                                                    className={`${tabStyles.tab} ${activeTab === 'outline' ? tabStyles.activeTab : ''}`}
                                                    onClick={() => {
                                                        setActiveTab('outline');
                                                        setSearchQuery('');
                                                        setSelectedSector("");
                                                        // setFromDate('');
                                                        // setToDate('');
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faListAlt} className="me-1" />
                                                    Outline
                                                </div>
                                                {/* <div
                                                    className={`${tabStyles.tab} ${activeTab === 'filters' ? tabStyles.activeTab : ''}`}
                                                    onClick={() => {
                                                        setActiveTab('filters');
                                                        setSearchQuery('');
                                                        setSelectedSector("");
                                                        // setFromDate('');
                                                        // setToDate('');
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faFilter} className="me-1" />
                                                    Filters
                                                </div> */}
                                            </div>


                                            {/* Tab Content */}
                                            {activeTab === 'outline' && (
                                                <div className="row mb-2">
                                                    {/* Department display (read-only) */}
                                                    <div className="col-12 mb-2">
                                                        <label htmlFor="department" className="form-label text-black mb-2">
                                                            Department
                                                        </label>
                                                        <div>
                                                            {/* <DepartmentDropdown
                                                                selectedPrefix={selectedPrefix}
                                                                setSelectedPrefix={(prefix) => {
                                                                    setSelectedPrefix(prefix);          // update selected prefix
                                                                    setTempSelectedTable('');           // clear selected table
                                                                    setSelectedColumns([]);             // clear selected columns
                                                                    setColumns([]);                     // clear available columns
                                                                    setTableData([]);                   // clear table data
                                                                    setTableColumns([]);                // clear table column titles
                                                                }}
                                                                prefixes={prefixes}
                                                            /> */}
                                                            <DepartmentDropdown
                                                                selectedPrefix={department} // department from sessionStorage
                                                                setSelectedPrefix={() => { }} // do nothing, read-only
                                                                prefixes={[department]} // only one option to show
                                                            />

                                                        </div>
                                                    </div>
                                                    <div className="col-12 mb-3">
                                                        <label htmlFor="checkerUser" className="form-label text-black mb-2">
                                                            Table Selection
                                                        </label>

                                                        <div className="table-on-homepage-only">
                                                            <div className="dropdown position-relative">
                                                                <button
                                                                    className="btn btn-light btn-sm dropdown-toggle text-truncate d-flex justify-content-between align-items-center"
                                                                    type="button"
                                                                    id="tableDropdown"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ width: '100%', minWidth: '200px', textAlign: 'left', paddingRight: '1.5rem' }}
                                                                    disabled={!department}
                                                                >
                                                                    <span className="text-truncate">
                                                                        {tempSelectedTable
                                                                            ? (() => {
                                                                                // Find the display name for the selected table value
                                                                                const selectedTable = filteredRecords1.find(t => t.value === tempSelectedTable);
                                                                                return selectedTable ? selectedTable.display : toTitleCase(tempSelectedTable);
                                                                            })()
                                                                            : "Select Table"}
                                                                    </span>
                                                                    <i className="ms-auto dropdown-toggle-icon"></i>
                                                                </button>

                                                                <ul
                                                                    className={`dropdown-menu mt-1 w-100 ${styles.dropdownMenu}`}
                                                                    aria-labelledby="tableDropdown"
                                                                >
                                                                    {tableNames.map((tableName, idx) => (
                                                                        <li key={idx}>
                                                                            <a
                                                                                className={`dropdown-item small ${styles.dropdownItem}`}
                                                                                href="#"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleTableChange({ target: { value: tableName } });
                                                                                }}
                                                                            >
                                                                                {tableName}
                                                                            </a>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* Date selection and other components remain the same */}
                                                    {availableDates.length > 0 && (
                                                        <div className="col-12 mb-3">
                                                            <div className="mb-2">
                                                                <select
                                                                    className="form-select form-select-sm shadow-sm"
                                                                    value={fromDate}
                                                                    onChange={(e) => setFromDate(e.target.value)}
                                                                >
                                                                    <option value="">From Date</option>
                                                                    {availableDates
                                                                        .filter(date => date !== toDate)
                                                                        .map(date => (
                                                                            <option key={date} value={date}>{formatDate1(date)}</option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                            <div>
                                                                <select
                                                                    className="form-select form-select-sm shadow-sm"
                                                                    value={toDate}
                                                                    onChange={(e) => setToDate(e.target.value)}
                                                                >
                                                                    <option value="">To Date</option>
                                                                    {availableDates
                                                                        .filter(date => date !== fromDate)
                                                                        .map(date => (
                                                                            <option key={date} value={date}>{formatDate1(date)}</option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="col-12 mb-2">
                                                        <Button
                                                            variant="primary"
                                                            onClick={generateReport}
                                                            className="btn btn-sm border-0"
                                                            style={{ backgroundColor: '#366872', color: 'white' }}
                                                            disabled={!tempSelectedTable || !fromDate || !toDate}
                                                        >
                                                            Generate Report
                                                        </Button>
                                                    </div>

                                                    {reportGenerated && tableData.length > 0 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary mt-3"
                                                            onClick={downloadAllReports}
                                                        >
                                                            Download All Reports
                                                        </button>
                                                    )}

                                                </div>
                                            )}



                                        </form>
                                    </div>
                                </div>
                            </div>
                            {/* right Column with Table */}
                            <div className="col-lg-9 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body d-flex flex-column">

                                        <div className="row">
                                            {Isloading && (
                                                                                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                                                                                <UploadLoadingIcon />
                                                                                            </div>
                                                                                        )}
                                            {reportGenerated && tableData.length > 0 ? (() => {
                                                // Get all dates (fromDate and toDate)
                                                const dates = [fromDate, toDate].filter(date =>
                                                    date && transformReportData(
                                                        tableData.reduce((acc, row) => {
                                                            if (!acc[row.Date]) acc[row.Date] = {};
                                                            if (!acc[row.Date][row.Sector]) acc[row.Date][row.Sector] = row;
                                                            return acc;
                                                        }, {})
                                                    )[date]
                                                );

                                                // Get data for difference table (rows where Difference exists)
                                                const differenceRows = tableData.filter(row =>
                                                    row.Date === "Difference" || row.hasOwnProperty("Balance ")
                                                );

                                                const td = new Date(toDate);
                                                const toDay = String(td.getDate()).padStart(2, "0");
                                                const toMonth = String(td.getMonth() + 1).padStart(2, "0");
                                                const toYear = td.getFullYear();
                                                const formattedToDate = `${toDay}-${toMonth}-${toYear}`;

                                                const fd = new Date(fromDate);
                                                const fromDay = String(fd.getDate()).padStart(2, "0");
                                                const fromMonth = String(fd.getMonth() + 1).padStart(2, "0");
                                                const fromYear = fd.getFullYear();
                                                const formattedFromDate = `${fromDay}-${fromMonth}-${fromYear}`;

                                                return (
                                                    <>
                                                        {/* ---- DATE TABLES ---- */}

                                                        <div className="col-12 d-flex">

                                                            {/* {dates.map((date, dateIndex) => { */}
                                                            {selectedName !== "interactive1" && dates.map((date, dateIndex) => {
                                                                let columnsOrder = [];

                                                                if (selectedName === "unavailed_data") {
                                                                    // KCC (Interest Income + Yield only)
                                                                    columnsOrder = [
                                                                        "Sector",
                                                                        "Balance",
                                                                        "NPA",
                                                                        "NPA%",
                                                                        "Interest Income",
                                                                        "Yield on Advances"
                                                                    ];
                                                                } else if (selectedName === "npa_test1") {
                                                                    // KCC (Interest Income + Yield only)
                                                                    columnsOrder = [
                                                                        "Sector",
                                                                        "Balance",
                                                                        "% to Total"
                                                                    ];
                                                                }
                                                                // else if (selectedName === "reportmart") {
                                                                //     // KCC (Interest Income + Yield only)
                                                                //     columnsOrder = [
                                                                //         "Sector",
                                                                //         "Balance",
                                                                //         "% to Total"
                                                                //     ];
                                                                // } 
                                                                else if (selectedName === "reportmart") {
                                                                    // Include "Difference" column only for the latest (toDate) table
                                                                    const isLastDate = dateIndex === dates.length - 1;
                                                                    columnsOrder = [
                                                                        "Sector",
                                                                        "Balance",
                                                                        "% to Total",
                                                                        ...(isLastDate ? ["Difference"] : []) // ✅ add only for latest date
                                                                    ];
                                                                }


                                                                else if (selectedName === "report18") {
                                                                    // KCC (Interest Income + Yield only)
                                                                    columnsOrder = [
                                                                        "Sector",
                                                                        "Balance",
                                                                        "NPA",
                                                                    ];
                                                                } else {
                                                                    columnsOrder = [
                                                                        "Sector", "Balance", "NPA", "NPA%", "SMA1", "SMA1%",
                                                                        "SMA2", "SMA2%", "SMA1+2", "SMA1+2%"
                                                                    ];

                                                                    if (
                                                                        selectedName === "actcust" ||
                                                                        selectedName === "additional_gl_balance" ||
                                                                        selectedName === "distribution_exposure" ||
                                                                        selectedName === "exchange_rates" ||
                                                                        selectedName === "investment_depreciationamount" ||
                                                                        selectedName === "pf_superannuation" ||
                                                                        selectedName === "balance_sheet" ||
                                                                        selectedName === "profit_flag" ||
                                                                        selectedName === "bulkdatarecords4" ||
                                                                        selectedName === "report" ||
                                                                        selectedName === "report3" ||
                                                                        selectedName === "report4" ||
                                                                        selectedName === "report5" ||
                                                                        selectedName === "report6" ||
                                                                        selectedName === "bulkdatarecords5" ||
                                                                        selectedName === "report7" ||
                                                                        selectedName === "bulkdatarecords6" ||
                                                                        selectedName === "bulkuploads56" ||
                                                                        selectedName === "report13" ||
                                                                        selectedName === "fully_unavailed_tl" ||
                                                                        // selectedName === "bulkrecordsupload" ||
                                                                        selectedName === "report8" ||
                                                                        selectedName === "rating_override" ||
                                                                        selectedName === "restructured_data" ||
                                                                        selectedName === "report10" ||
                                                                        // selectedName === "report9" ||
                                                                        selectedName === "report11" ||
                                                                        // selectedName === "unavailed_data" ||
                                                                        selectedName === "report14" ||
                                                                        selectedName === "report15" ||
                                                                        selectedName === "report16" ||
                                                                        selectedName === "report17" ||
                                                                        selectedName === "report20" ||
                                                                        selectedName === "report21"
                                                                        // selectedName === "npa_test1"
                                                                    ) {
                                                                        columnsOrder.push("Yield on Advances");
                                                                    }
                                                                }


                                                                // --- Step 1: Build union of all sectors across all selected dates ---
                                                                // --- Step 1: Build union of all sectors across all selected dates (in stable order) ---
                                                                const allSectors = [
                                                                    ...new Set(
                                                                        tableData
                                                                            .filter(r => dates.includes(r.Date))
                                                                            .map(r => r.Sector)
                                                                    )
                                                                ];

                                                                // --- Step 2: Ensure "Grand Total" is always last ---
                                                                const sectorsWithoutGrandTotal = allSectors.filter(s => s !== "Grand Total");
                                                                const orderedSectors = [...sectorsWithoutGrandTotal, "Grand Total"];

                                                                // --- Step 3: Build rows for this date (fill missing with blanks) ---
                                                                const rows = orderedSectors.map(sector => {
                                                                    const found = tableData.find(r => r.Date === date && r.Sector === sector);
                                                                    if (found) return found;

                                                                    // Fill with empty values
                                                                    const emptyRow = { Date: date, Sector: sector };
                                                                    columnsOrder.forEach(col => {
                                                                        if (col !== "Sector") emptyRow[col] = "";
                                                                    });
                                                                    return emptyRow;
                                                                });


                                                                // --- Step 3: Ensure Grand Total is last (and only once) ---
                                                                const nonGrandTotalRows = rows.filter(r => r.Sector !== "Grand Total");
                                                                const grandTotalRow = rows.find(r => r.Sector === "Grand Total");
                                                                const uniqueRows = grandTotalRow ? [...nonGrandTotalRows, grandTotalRow] : nonGrandTotalRows;

                                                                // ... continue with displayColumns and table rendering using uniqueRows

                                                                // Now continue with your displayColumns / rendering logic

                                                                // if (selectedName === "actcust" || selectedName === "additional_gl_balance" || selectedName === "distribution_exposure" || selectedName === "exchange_rates" || selectedName === "investment_depreciationamount" || selectedName === "pf_superannuation" || selectedName === "profit_flag" || selectedName === "fully_unavailed_tl" || selectedName === "rating_override") {
                                                                //     columnsOrder.push("Yield on Advances");
                                                                // }

                                                                const displayColumns = dateIndex > 0
                                                                    ? columnsOrder
                                                                        .filter(col => col !== "Sector")
                                                                        .map(col => ({
                                                                            key: col,
                                                                            label:
                                                                                selectedName === "npa_test1" && col === "Balance"
                                                                                    ? "Exposure"
                                                                                    : selectedName === "reportmart" && col === "Balance"
                                                                                        ? "Exposure (Amt. in Cr)"
                                                                                        : selectedName === "reportmart" && col === "Difference"
                                                                                            ? "Increase / Decrease in Mar-25 viz-à-viz Dec-24"

                                                                                            : col // ✅ rename only the header label
                                                                        }))
                                                                    : columnsOrder.map(col => {
                                                                        if (col === "Sector") {
                                                                            if (selectedName === "distribution_exposure" || selectedName === "exchange_rates") {
                                                                                return { key: col, label: "Row Labels" };
                                                                            } else if (selectedName === "investment_depreciationamount" || selectedName === "pf_superannuation" || selectedName === "profit_flag" ||
                                                                                selectedName === "rating_override" || selectedName === "restructured_data" || selectedName === "balance_sheet" || selectedName === "bulkdatarecords4" ||
                                                                                selectedName === "report" || selectedName === "report3" || selectedName === "report4" || selectedName === "report5" || selectedName === "report6" || selectedName === "report7" ||
                                                                                selectedName === "report10" || selectedName === "actcust" || selectedName === "report13" || selectedName === "bulkdatarecords5" || selectedName === "bulkuploads56") {
                                                                                return { key: col, label: "Zone" };
                                                                            } else if (selectedName === "report8" || selectedName === "bulkrecordsupload" || selectedName === "report14" || selectedName === "report11") {
                                                                                return { key: col, label: "Scheme Code" };
                                                                            } else if (selectedName === "fully_unavailed_tl") {
                                                                                return { key: col, label: "NAME" };
                                                                            } else if (selectedName === "report18") {
                                                                                return { key: col, label: "Rating Grades" };
                                                                            } else if (selectedName === "accounting_data") {
                                                                                return { key: col, label: "Region" };
                                                                            } else if (selectedName === "additional_gl_balance") {
                                                                                return { key: col, label: "Segment" };
                                                                            } else if (selectedName === "npa_test1") {
                                                                                return { key: col, label: "Rating Category" };
                                                                            } else if (selectedName === "reportmart") {
                                                                                return { key: col, label: "Rating Grades" };
                                                                            }
                                                                        }
                                                                        if (selectedName === "npa_test1" && col === "Balance") {
                                                                            return { key: col, label: "Exposure" };
                                                                        } else if (selectedName === "reportmart" && col === "Balance") {
                                                                            return { key: col, label: "Exposure (Amt. in Cr)" };
                                                                        }
                                                                        return { key: col, label: col };
                                                                    });



                                                                return (
                                                                    // <div className="col-lg-3 col-md-6 col-sm-12" key={date}>

                                                                    <div
                                                                        className={`${(selectedName === "report9" || selectedName === "report18") && (date === fromDate || date === toDate)
                                                                            ? "col-lg-4 col-md-6 col-sm-12"
                                                                            : "col-lg-6 col-md-6 col-sm-12"
                                                                            }`}
                                                                        key={date}
                                                                    >

                                                                        {/* <h6 className="text-center fw-bold mb-2">{date}</h6> */}
                                                                        <h6 className="text-center fw-bold mb-2">
                                                                            <h6 className="text-center fw-bold mb-2">
                                                                                {(() => {
                                                                                    const d = new Date(date);
                                                                                    const day = String(d.getDate()).padStart(2, "0");
                                                                                    const month = String(d.getMonth() + 1).padStart(2, "0");
                                                                                    const year = d.getFullYear();
                                                                                    const formattedDate = `${day}-${month}-${year}`;

                                                                                    return selectedName === "additional_gl_balance"
                                                                                        ? `Co-Lending Portfolio as on – ${formattedDate}`
                                                                                        : selectedName === "distribution_exposure"
                                                                                            ? `Co-Lending Portfolio (Retail) as on – ${formattedDate}`
                                                                                            : selectedName === "exchange_rates"
                                                                                                ? `Co-Lending MSME as on – ${formattedDate}`
                                                                                                : selectedName === "investment_depreciationamount"
                                                                                                    ? `VYAPAR LOAN as on – ${formattedDate}`
                                                                                                    : selectedName === "pf_superannuation"
                                                                                                        ? `MORTGAGE LOAN – ${formattedDate}`
                                                                                                        : selectedName === "balance_sheet"
                                                                                                            ? `GST EASE - ${formattedDate}`
                                                                                                            : selectedName === "bulkdatarecords4"
                                                                                                                ? `CONTRACTOR PLUS - ${formattedDate}`
                                                                                                                : selectedName === "report3"
                                                                                                                    ? ` PSB APNA VAHAN - ${formattedDate}`
                                                                                                                    : selectedName === "report4"
                                                                                                                        ? ` PSB EDUCATION LOAN - ${formattedDate}`
                                                                                                                        : selectedName === "report5"
                                                                                                                            ? ` PSB GOLD LOAN - ${formattedDate}`
                                                                                                                            : selectedName === "report6"
                                                                                                                                ? ` PSB PERSONAL LOAN - ${formattedDate}`
                                                                                                                                : selectedName === "report"
                                                                                                                                    ? `PSB APNA GHAR - ${formattedDate}`
                                                                                                                                    : selectedName === "bulkdatarecords5"
                                                                                                                                        ? `GECL - ${formattedDate}`
                                                                                                                                        : selectedName === "report7"
                                                                                                                                            ? `OTHER RETAIL - ${formattedDate}`
                                                                                                                                            : selectedName === "bulkdatarecords6"
                                                                                                                                                ? `Other MSME - ${formattedDate}`
                                                                                                                                                : selectedName === "bulkuploads56"
                                                                                                                                                    ? `ZONEWISE RETAIL - ${formattedDate}`
                                                                                                                                                    : selectedName === "profit_flag"
                                                                                                                                                        ? `MUDRA – ${formattedDate}`
                                                                                                                                                        : selectedName === "fully_unavailed_tl"
                                                                                                                                                            ? `POOL ACCOUNTS as on – ${formattedDate}`
                                                                                                                                                            : selectedName === "bulkrecordsupload"
                                                                                                                                                                ? `Other MSME above Rs. 200 Cr – ${formattedDate}`
                                                                                                                                                                : selectedName === "report8"
                                                                                                                                                                    ? `Other RETAIL above Rs. 200 Cr – ${formattedDate}`
                                                                                                                                                                    : selectedName === "rating_override"
                                                                                                                                                                        ? `SME LIQUID PLUS – ${formattedDate}`
                                                                                                                                                                        : selectedName === "restructured_data"
                                                                                                                                                                            ? `Zonewise Agriculture – as on ${formattedDate}`
                                                                                                                                                                            : selectedName === "unavailed_data"
                                                                                                                                                                                ? `KCC – as on ${formattedDate}`
                                                                                                                                                                                : selectedName === "report10"
                                                                                                                                                                                    ? `Other Agriculture – as on ${formattedDate}`
                                                                                                                                                                                    : selectedName === "report11"
                                                                                                                                                                                        ? `Other Agricultural (Product Wise above 100 crore) – as on ${formattedDate}`
                                                                                                                                                                                        : selectedName === "report14"
                                                                                                                                                                                            ? `RENEWABLE ENERGY AS ON ${formattedDate}`
                                                                                                                                                                                            : formattedDate;
                                                                                })()}

                                                                            </h6>


                                                                        </h6>

                                                                        {/* <div className={`tableWrapper ${tableStyles.tableWrapper}`}> */}
                                                                        <div
                                                                            className={`tableWrapper ${tableStyles.tableWrapper}`}
                                                                            style={{ maxHeight: "141px" }}
                                                                        >

                                                                            <div className="custom-table-with-status-colors w-100 position-relative">
                                                                                <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                                                                    <thead className="sticky-header">
                                                                                        <tr>
                                                                                            {displayColumns.map((colObj, i) => (
                                                                                                <th
                                                                                                    key={i}
                                                                                                    style={{
                                                                                                        textAlign: "center",
                                                                                                        border: "1px solid black",
                                                                                                        padding: "5px",
                                                                                                        whiteSpace: "normal",
                                                                                                        minWidth: "60px",
                                                                                                        wordBreak: "break-word"
                                                                                                    }}
                                                                                                >
                                                                                                    {colObj.label}
                                                                                                </th>
                                                                                            ))}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody style={{ border: "1px solid #ddd", fontSize: "12px" }}>
                                                                                        {rows.map((row, rIndex) => (
                                                                                            <tr
                                                                                                key={rIndex}
                                                                                                style={{
                                                                                                    border: "1px solid #ddd",
                                                                                                    padding: "5px",
                                                                                                    backgroundColor: rIndex % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                                                                }}
                                                                                            >
                                                                                                {displayColumns.map((colObj, cIndex) => {
                                                                                                    let value = row[colObj.key];
                                                                                                    // Add "Difference" logic for reportmart
                                                                                                    if (selectedName === "reportmart" && colObj.key === "Difference") {
                                                                                                        const prevDate = dates[0]; // assuming date[0] is Dec-24, date[1] is Mar-25
                                                                                                        const currDate = date;     // current iteration date
                                                                                                        if (currDate !== prevDate) {
                                                                                                            const prevRows = tableData.filter(r => r.Date === prevDate);
                                                                                                            const prevRow = prevRows.find(r => r.Sector === row.Sector);

                                                                                                            const currBal = parseFloat((row["Balance"] || "0").toString().replace(/,/g, "")) || 0;
                                                                                                            const prevBal = parseFloat((prevRow?.["Balance"] || "0").toString().replace(/,/g, "")) || 0;
                                                                                                            const diff = currBal - prevBal;

                                                                                                            value = diff.toLocaleString("en-IN", { minimumFractionDigits: 0 });
                                                                                                        } else {
                                                                                                            value = ""; // no difference for the first date
                                                                                                        }
                                                                                                    }

                                                                                                    // Rename Grand Total -> CO-LENDING Total only for additional_gl_balance
                                                                                                    if (colObj.key === "Sector" && selectedName === "additional_gl_balance" && value === "Grand Total") {
                                                                                                        value = "CO-LENDING Total";
                                                                                                    }

                                                                                                    const formattedValue = typeof value === "number"
                                                                                                        ? value.toLocaleString("en-IN")
                                                                                                        : value;

                                                                                                    return (
                                                                                                        <td
                                                                                                            key={cIndex}
                                                                                                            style={{
                                                                                                                border: "1px solid #ddd",
                                                                                                                padding: "5px",
                                                                                                                fontSize: "12px",
                                                                                                                whiteSpace: "normal",
                                                                                                                wordBreak: "break-word"
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* {formattedValue} */}
                                                                                                            {formattedValue !== "" && formattedValue !== undefined && formattedValue !== null
                                                                                                                ? formattedValue
                                                                                                                : "\u00A0"  // non-breaking space keeps the cell visible with padding
                                                                                                            }

                                                                                                        </td>
                                                                                                    );
                                                                                                })}
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>

                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                            {/* </div> */}

                                                            {/* ---- DIFFERENCE TABLE ---- */}

                                                            {selectedName === "report15" && (
                                                                <div className="custom-table-with-status-colors w-100 position-relative">
                                                                    <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                                                        <thead className="sticky-header">
                                                                            <tr>
                                                                                {["Borrower", "Total Exposure", "Activity", "External Rating"].map((header, i) => (
                                                                                    <th key={i} style={{ textAlign: "center", border: "1px solid black", padding: "5px", minWidth: "80px" }}>
                                                                                        {header}
                                                                                    </th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody style={{ fontSize: "12px" }}>
                                                                            {processedReports?.report15?.flattenedData?.map((row, rIndex) => (
                                                                                <tr key={rIndex} style={{ backgroundColor: rIndex % 2 === 0 ? "#f9f9f9" : "#ffffff" }}>
                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{row.borrower}</td>
                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{row.totalExposureCr}</td>
                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{row.activity}</td>
                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{row.externalRating}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            )}

                                                            {selectedName === "report16" && tableData.length > 0 && (
                                                                <div
                                                                    className={`tableWrapper ${tableStyles.tableWrapper}`}
                                                                // style={{ maxHeight: "141px" }}
                                                                >

                                                                    <div className={`custom-table-with-status-colors w-100 position-relative ${tableStyles.customScrollTable}`}>
                                                                        <table className={`table table-bordered table-hover text-center `}>
                                                                            <thead className="sticky-header">
                                                                                <tr>
                                                                                    <th rowSpan={2} style={{ border: "1px solid black", padding: "5px" }}>NBFC Sub-sector</th>
                                                                                    {Object.keys(
                                                                                        tableData.reduce((acc, item) => {
                                                                                            if (!acc[item.reporting_date]) acc[item.reporting_date] = [];
                                                                                            acc[item.reporting_date].push(item);
                                                                                            return acc;
                                                                                        }, {})
                                                                                    ).map((date, idx) => (
                                                                                        <th key={idx} colSpan={4} style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            {date}
                                                                                        </th>
                                                                                    ))}
                                                                                </tr>
                                                                                <tr>
                                                                                    {Object.keys(
                                                                                        tableData.reduce((acc, item) => {
                                                                                            if (!acc[item.reporting_date]) acc[item.reporting_date] = [];
                                                                                            acc[item.reporting_date].push(item);
                                                                                            return acc;
                                                                                        }, {})
                                                                                    ).map((date, idx) => (
                                                                                        ["Total Exposure", "% to Total Exposure", "Total NPA", "NPA %"].map((header, hIdx) => (
                                                                                            <th key={`${idx}-${hIdx}`} style={{ border: "1px solid black", padding: "5px" }}>
                                                                                                {header}
                                                                                            </th>
                                                                                        ))
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody style={{ fontSize: "12px" }}>
                                                                                {/* Get unique NBFC Sub-sectors */}
                                                                                {Array.from(new Set(tableData.map(d => d.rep_param))).map((subSector, rIndex) => (
                                                                                    <tr key={rIndex} style={{ backgroundColor: rIndex % 2 === 0 ? "#f9f9f9" : "#ffffff" }}>
                                                                                        <td style={{ border: "1px solid #ddd", padding: "5px" }}>{subSector}</td>
                                                                                        {Object.entries(
                                                                                            tableData.reduce((acc, item) => {
                                                                                                if (!acc[item.reporting_date]) acc[item.reporting_date] = [];
                                                                                                acc[item.reporting_date].push(item);
                                                                                                return acc;
                                                                                            }, {})
                                                                                        ).map(([date, items], i) => {
                                                                                            const rowData = items.find(d => d.rep_param === subSector);
                                                                                            return rowData ? (
                                                                                                <>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{rowData.os_balance?.toLocaleString()}</td>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{rowData.roi}%</td>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{rowData.npa}</td>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{rowData.npa_percent}%</td>
                                                                                                </>
                                                                                            ) : (
                                                                                                // Empty cells if this sub-sector doesn't exist for that date
                                                                                                <>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>-</td>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>-</td>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>-</td>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>-</td>
                                                                                                </>
                                                                                            );
                                                                                        })}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {selectedName === "report20" && tableData.length > 0 && (() => {
                                                                // These should come from the parent JSON (set during handleTableChange)
                                                                const currentDate = toDate;     // current period
                                                                const previousDate = fromDate;  // previous period

                                                                // Helper to format date (YYYY-MM-DD → DD-MM-YYYY)
                                                                const formatDate = (dateString) => {
                                                                    if (!dateString) return "";
                                                                    const d = new Date(dateString);
                                                                    const day = String(d.getDate()).padStart(2, "0");
                                                                    const month = String(d.getMonth() + 1).padStart(2, "0");
                                                                    const year = d.getFullYear();
                                                                    return `${day}-${month}-${year}`;
                                                                };

                                                                const balanceDate = formatDate(previousDate);  // same as previous period
                                                                const ratingCurrDate = formatDate(currentDate);
                                                                const ratingPrevDate = formatDate(previousDate);

                                                                return (
                                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <div className={`custom-table-with-status-colors w-100 position-relative ${tableStyles.customScrollTable}`}>
                                                                            <table className={`table table-bordered table-hover text-center`}>
                                                                                <thead className="sticky-header">
                                                                                    <tr>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>Sr No</th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>Name</th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Balance as on {balanceDate}
                                                                                        </th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Rating {ratingCurrDate}
                                                                                        </th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Rating {ratingPrevDate}
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody style={{ fontSize: "12px" }}>
                                                                                    {tableData.map((item, index) => (
                                                                                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Sr_No}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.NAME}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Balance_as_on}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Rating_Curr}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Rating_Prev}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })()}



                                                            {selectedName === "unavailed_data8" && tableData.length > 0 && (
                                                                <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                    <div className={`custom-table-with-status-colors w-100 position-relative ${tableStyles.customScrollTable}`}>
                                                                        <table className={`table table-bordered table-hover text-center`}>
                                                                            <thead className="sticky-header" style={{ background: "#007bff", color: "white" }}>
                                                                                <tr>
                                                                                    <th style={{ border: "1px solid black", padding: "5px" }}>Description</th>
                                                                                    <th style={{ border: "1px solid black", padding: "5px" }}>Scheme Code</th>

                                                                                    {/* ✅ Dynamically render dates from processedReports */}
                                                                                    {processedReports?.unavailed_data8?.dates?.map((date, idx) => (
                                                                                        <th key={idx} style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            {new Date(date).toLocaleDateString("en-GB")}
                                                                                        </th>
                                                                                    ))}

                                                                                    <th style={{ border: "1px solid black", padding: "5px" }}>Change</th>
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody style={{ fontSize: "12px" }}>
                                                                                {tableData.map((item, index) => {
                                                                                    // ===== Header Row (Bank Guarantees / Letter of Credit) =====
                                                                                    if (item.type === "header") {
                                                                                        return (
                                                                                            <tr key={index} style={{ backgroundColor: "#eaf3ff", fontWeight: "bold" }}>
                                                                                                <td colSpan={5} style={{ textAlign: "center", padding: "5px" }}>
                                                                                                    {item.Rep_Type}
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    }

                                                                                    // ===== Subtotal Row =====
                                                                                    if (item.type === "subtotal") {
                                                                                        return (
                                                                                            <tr key={index} style={{ backgroundColor: "#f1f1f1", fontWeight: "bold" }}>
                                                                                                <td colSpan={2} style={{ textAlign: "right", padding: "5px" }}>{item.Scheme_Desc}</td>
                                                                                                <td style={{ padding: "5px" }}>{item.Prev_Value?.toFixed(2)}</td>
                                                                                                <td style={{ padding: "5px" }}>{item.Curr_Value?.toFixed(2)}</td>
                                                                                                <td style={{ padding: "5px" }}>{item.Change?.toFixed(2)}</td>
                                                                                            </tr>
                                                                                        );
                                                                                    }

                                                                                    // ===== Grand Total Row =====
                                                                                    if (item.type === "grandtotal") {
                                                                                        return (
                                                                                            <tr key={index} style={{ backgroundColor: "#d9edf7", fontWeight: "bold" }}>
                                                                                                <td colSpan={2} style={{ textAlign: "right", padding: "5px" }}>{item.Scheme_Desc}</td>
                                                                                                <td style={{ padding: "5px" }}>{item.Prev_Value?.toFixed(2)}</td>
                                                                                                <td style={{ padding: "5px" }}>{item.Curr_Value?.toFixed(2)}</td>
                                                                                                <td style={{ padding: "5px" }}>{item.Change?.toFixed(2)}</td>
                                                                                            </tr>
                                                                                        );
                                                                                    }

                                                                                    // ===== Regular Data Row =====
                                                                                    return (
                                                                                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9" }}>
                                                                                            <td style={{ textAlign: "left", border: "1px solid #ddd", padding: "5px" }}>
                                                                                                {item.Scheme_Desc}
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.BG_LC_Type}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Prev_Value?.toFixed(2)}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Curr_Value?.toFixed(2)}</td>
                                                                                            <td
                                                                                                style={{
                                                                                                    border: "1px solid #ddd",
                                                                                                    padding: "5px",
                                                                                                    color: item.Change > 0 ? "green" : item.Change < 0 ? "red" : "black",
                                                                                                    fontWeight: item.Change !== 0 ? "bold" : "normal"
                                                                                                }}
                                                                                            >
                                                                                                {item.Change?.toFixed(2)}
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {selectedName === "report21" && tableData.length > 0 && (() => {

                                                                const currentDate = toDate;     // current period
                                                                const previousDate = fromDate;  // previous period

                                                                // Helper to format date (YYYY-MM-DD → DD-MM-YYYY)
                                                                const formatDate = (dateString) => {
                                                                    if (!dateString) return "";
                                                                    const d = new Date(dateString);
                                                                    const day = String(d.getDate()).padStart(2, "0");
                                                                    const month = String(d.getMonth() + 1).padStart(2, "0");
                                                                    const year = d.getFullYear();
                                                                    return `${day}-${month}-${year}`;
                                                                };

                                                                const balanceDate = formatDate(previousDate);  // same as previous period
                                                                const ratingCurrDate = formatDate(currentDate);
                                                                const ratingPrevDate = formatDate(previousDate);

                                                                return (
                                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <div className={`custom-table-with-status-colors w-100 position-relative ${tableStyles.customScrollTable}`}>
                                                                            <table className={`table table-bordered table-hover text-center`}>
                                                                                <thead className="sticky-header">
                                                                                    <tr>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>Sr No</th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>Name</th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Balance as on {balanceDate}
                                                                                        </th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Rating {ratingCurrDate}
                                                                                        </th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Rating {ratingPrevDate}
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody style={{ fontSize: "12px" }}>
                                                                                    {tableData.map((item, index) => (
                                                                                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Sr_No}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.NAME}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Balance_as_on}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Rating_Curr}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Rating_Prev}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })()}

                                                            {selectedName === "unavailed_data1" && tableData.length > 0 && (
                                                                <>
                                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <div className={`custom-table-with-status-colors w-100 position-relative ${tableStyles.customScrollTable}`}>
                                                                            <table className="table table-bordered table-hover text-center">
                                                                                <thead className="sticky-header">
                                                                                    <tr>
                                                                                        <th>Previous Rating</th>
                                                                                        <th>Total</th>
                                                                                        {Object.keys(tableData[0])
                                                                                            .filter(k =>
                                                                                                ![
                                                                                                    "Previous_Rating",
                                                                                                    "Total_Accounts",
                                                                                                    "Closed",
                                                                                                    "NPA",
                                                                                                    "Balance Accounts",
                                                                                                    "Default Rate",
                                                                                                    "Stability Rate",
                                                                                                ].includes(k)
                                                                                            )
                                                                                            .map((rating, idx) => (
                                                                                                <th key={idx}>{rating}</th>
                                                                                            ))}
                                                                                        <th>Closed</th>
                                                                                        <th>NPA</th>
                                                                                        <th>Balance Accounts</th>
                                                                                        <th>Default Rate</th>
                                                                                        <th>Stability Rate</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {tableData.map((item, index) => (
                                                                                        <tr
                                                                                            key={index}
                                                                                            style={{
                                                                                                fontWeight: item.Previous_Rating === "Grand Total" ? "bold" : "normal",  // Updated to "Grand Total"
                                                                                                backgroundColor: item.Previous_Rating === "Grand Total" ? "#e9ecef" : "white",  // Updated to "Grand Total"
                                                                                            }}
                                                                                        >
                                                                                            <td>{item.Previous_Rating}</td>
                                                                                            <td>{item.Total_Accounts}</td>
                                                                                            {Object.keys(item)
                                                                                                .filter(k =>
                                                                                                    ![
                                                                                                        "Previous_Rating",
                                                                                                        "Total_Accounts",
                                                                                                        "Closed",
                                                                                                        "NPA",
                                                                                                        "Balance Accounts",
                                                                                                        "Default Rate",
                                                                                                        "Stability Rate",
                                                                                                    ].includes(k)
                                                                                                )
                                                                                                .map((ratingKey, i) => (
                                                                                                    <td
                                                                                                        key={i}
                                                                                                        style={{
                                                                                                            backgroundColor:
                                                                                                                item.Previous_Rating !== "Grand Total" &&  // Updated to "Grand Total"
                                                                                                                    item.Previous_Rating === ratingKey &&
                                                                                                                    item[ratingKey] > 0
                                                                                                                    ? "#d1e7dd"
                                                                                                                    : item.Previous_Rating !== "Grand Total" && item[ratingKey] > 0  // Updated to "Grand Total"
                                                                                                                        ? "#fff3cd"
                                                                                                                        : "white",
                                                                                                        }}
                                                                                                    >
                                                                                                        {item[ratingKey]}
                                                                                                    </td>
                                                                                                ))}
                                                                                            <td>{item.Closed}</td>
                                                                                            <td>{item.NPA}</td>
                                                                                            <td>{item["Balance Accounts"]}</td>
                                                                                            <td>{item["Default Rate"]}</td>
                                                                                            <td>{item["Stability Rate"]}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div style={{ textAlign: "center", fontWeight: "bold" }}>
                                                                            Overall Rating Stability = {overallStability}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            {selectedName === "report23" && tableData.length > 0 && (
                                                                <div className="mt-2" style={{ marginLeft: "230px" }}>
                                                                    <div style={{ width: "100%" }}>
                                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                            <div
                                                                                className={`custom-table-with-status-colors position-relative ${tableStyles.customScrollTable}`}
                                                                            >
                                                                                <table className="table table-bordered table-hover text-center w-100">
                                                                                    <thead className="sticky-header">
                                                                                        <tr>

                                                                                            <th style={{ border: "1px solid black", padding: "5px" }}>Period</th>
                                                                                            <th style={{ border: "1px solid black", padding: "5px" }}>Portfolio Quality Index</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody style={{ fontSize: "12px" }}>
                                                                                        {tableData.map((item, index) => (
                                                                                            <tr
                                                                                                key={index}
                                                                                                style={{
                                                                                                    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                                                                                                }}
                                                                                            >

                                                                                                <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Period}</td>
                                                                                                <td style={{ border: "1px solid #ddd", padding: "5px" }}>
                                                                                                    {item["Portfolio Quality Index"]}
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>

                                                                        {/* PQI Curve Graph */}
                                                                        {/* PQI Curve Graph */}
                                                                        {/* PQI Curve Graph */}
                                                                        <div className="mt-2">
                                                                            <div style={{ border: "2px solid #ccc", borderRadius: "10px" }}>
                                                                                <h5 className="text-center mb-3" style={{ fontWeight: "bold" }}>
                                                                                    PQI Curve: NBFC
                                                                                </h5>

                                                                                <ResponsiveContainer width="100%" height={150}>
                                                                                    <LineChart data={tableData} margin={{ top: 30, right: 40, left: 20, bottom: 40 }}>
                                                                                        <XAxis
                                                                                            dataKey="Period"
                                                                                            tick={{ fontSize: 12 }}
                                                                                            interval={0}
                                                                                            angle={-20}
                                                                                            textAnchor="end"
                                                                                            height={60}
                                                                                        />
                                                                                        <YAxis tick={{ fontSize: 12 }} />
                                                                                        <Tooltip
                                                                                            formatter={(value) => [`${value}`, "PQI"]}
                                                                                            contentStyle={{
                                                                                                backgroundColor: "#fff",
                                                                                                border: "1px solid #ccc",
                                                                                                borderRadius: "8px",
                                                                                            }}
                                                                                        />

                                                                                        <Line
                                                                                            type="monotone"
                                                                                            dataKey="Portfolio Quality Index"
                                                                                            stroke="#d62728"
                                                                                            strokeWidth={3}
                                                                                            dot={({ cx, cy, value }) => (
                                                                                                <g>
                                                                                                    {/* Red circular ball */}
                                                                                                    <circle cx={cx} cy={cy} r={14} fill="#d62728" />
                                                                                                    {/* Value text inside the circle */}
                                                                                                    <text
                                                                                                        x={cx}
                                                                                                        y={cy + 4}
                                                                                                        textAnchor="middle"
                                                                                                        fontSize="10"
                                                                                                        fontWeight="bold"
                                                                                                        fill="#fff"
                                                                                                    >
                                                                                                        {value}
                                                                                                    </text>
                                                                                                </g>
                                                                                            )}
                                                                                            activeDot={{ r: 16 }}
                                                                                        />
                                                                                    </LineChart>
                                                                                </ResponsiveContainer>
                                                                            </div>
                                                                        </div>


                                                                    </div>
                                                                </div>
                                                            )}

                                                            {selectedName === "report22" && tableData.length > 0 && (() => {

                                                                const currentDate = toDate;     // current period
                                                                const previousDate = fromDate;  // previous period

                                                                // Helper to format date (YYYY-MM-DD → DD-MM-YYYY)
                                                                const formatDate = (dateString) => {
                                                                    if (!dateString) return "";
                                                                    const d = new Date(dateString);
                                                                    const day = String(d.getDate()).padStart(2, "0");
                                                                    const month = String(d.getMonth() + 1).padStart(2, "0");
                                                                    const year = d.getFullYear();
                                                                    return `${day}-${month}-${year}`;
                                                                };

                                                                const balanceDate = formatDate(previousDate);  // same as previous period
                                                                const ratingCurrDate = formatDate(currentDate);
                                                                const ratingPrevDate = formatDate(previousDate);

                                                                return (
                                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <div className={`custom-table-with-status-colors w-100 position-relative ${tableStyles.customScrollTable}`}>
                                                                            <table className={`table table-bordered table-hover text-center`}>
                                                                                <thead className="sticky-header">
                                                                                    <tr>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>Sr No</th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>Name</th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Balance as on {balanceDate}
                                                                                        </th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Rating {ratingCurrDate}
                                                                                        </th>
                                                                                        <th style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            Rating {ratingPrevDate}
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody style={{ fontSize: "12px" }}>
                                                                                    {tableData.map((item, index) => (
                                                                                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Sr_No}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.NAME}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Balance_as_on}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Rating_Curr}</td>
                                                                                            <td style={{ border: "1px solid #ddd", padding: "5px" }}>{item.Rating_Prev}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })()}


                                                            {selectedName === "report17" && tableData.length > 0 && (
                                                                <div
                                                                    className={`tableWrapper ${tableStyles.tableWrapper}`}
                                                                // style={{ maxHeight: "141px" }}
                                                                >

                                                                    <div className={`custom-table-with-status-colors w-100 position-relative ${tableStyles.customScrollTable}`}>
                                                                        <table className={`table table-bordered table-hover text-center `}>
                                                                            <thead className="sticky-header">
                                                                                <tr>
                                                                                    <th rowSpan={2} style={{ border: "1px solid black", padding: "5px" }}>Rating Category</th>
                                                                                    {Object.keys(
                                                                                        tableData.reduce((acc, item) => {
                                                                                            if (!acc[item.reporting_date]) acc[item.reporting_date] = [];
                                                                                            acc[item.reporting_date].push(item);
                                                                                            return acc;
                                                                                        }, {})
                                                                                    ).map((date, idx) => (
                                                                                        <th key={idx} colSpan={2} style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            {date}
                                                                                        </th>
                                                                                    ))}
                                                                                </tr>
                                                                                <tr>
                                                                                    {Object.keys(
                                                                                        tableData.reduce((acc, item) => {
                                                                                            if (!acc[item.reporting_date]) acc[item.reporting_date] = [];
                                                                                            acc[item.reporting_date].push(item);
                                                                                            return acc;
                                                                                        }, {})
                                                                                    ).map((date, idx) => (
                                                                                        ["Exposure", "% to Total"].map((header, hIdx) => (
                                                                                            <th key={`${idx}-${hIdx}`} style={{ border: "1px solid black", padding: "5px" }}>
                                                                                                {header}
                                                                                            </th>
                                                                                        ))
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody style={{ fontSize: "12px" }}>
                                                                                {/* Get unique NBFC Sub-sectors */}
                                                                                {Array.from(new Set(tableData.map(d => d.rep_param))).map((subSector, rIndex) => (
                                                                                    <tr key={rIndex} style={{ backgroundColor: rIndex % 2 === 0 ? "#f9f9f9" : "#ffffff" }}>
                                                                                        <td style={{ border: "1px solid #ddd", padding: "5px" }}>{subSector}</td>
                                                                                        {Object.entries(
                                                                                            tableData.reduce((acc, item) => {
                                                                                                if (!acc[item.reporting_date]) acc[item.reporting_date] = [];
                                                                                                acc[item.reporting_date].push(item);
                                                                                                return acc;
                                                                                            }, {})
                                                                                        ).map(([date, items], i) => {
                                                                                            const rowData = items.find(d => d.rep_param === subSector);
                                                                                            return rowData ? (
                                                                                                <>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>{rowData.os_balance?.toLocaleString()}</td>

                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>
                                                                                                        {rowData.percentage ?? 0}%
                                                                                                    </td>

                                                                                                </>
                                                                                            ) : (
                                                                                                // Empty cells if this sub-sector doesn't exist for that date
                                                                                                <>
                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>-</td>

                                                                                                    <td style={{ border: "1px solid #ddd", padding: "5px" }}>-</td>
                                                                                                </>
                                                                                            );
                                                                                        })}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {selectedName === "report9" && differenceTable.length > 0 && (
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <h6 className="text-center fw-bold mb-2">Difference</h6>
                                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "141px" }}>
                                                                        <div className="custom-table-with-status-colors w-100 position-relative">
                                                                            <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                                                                <thead className="sticky-header">
                                                                                    <tr>
                                                                                        {["Balance ", "NPA ", "SMA "].map((col, i) => (
                                                                                            <th
                                                                                                key={i}
                                                                                                style={{
                                                                                                    textAlign: "center",
                                                                                                    border: "1px solid black",
                                                                                                    padding: "5px",
                                                                                                    whiteSpace: "normal",
                                                                                                    minWidth: "60px",
                                                                                                    wordBreak: "break-word"
                                                                                                }}
                                                                                            >
                                                                                                {col}
                                                                                            </th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody style={{ border: "1px solid #ddd", fontSize: "12px" }}>
                                                                                    {differenceTable.map((row, rIndex) => (
                                                                                        <tr
                                                                                            key={rIndex}
                                                                                            style={{
                                                                                                border: "1px solid #ddd",
                                                                                                padding: "5px",
                                                                                                backgroundColor: rIndex % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                                                            }}
                                                                                        >
                                                                                            {["Balance ", "NPA ", "SMA "].map((col, cIndex) => {
                                                                                                const value = row[col];
                                                                                                return (
                                                                                                    <td
                                                                                                        key={cIndex}
                                                                                                        style={{
                                                                                                            border: "1px solid #ddd",
                                                                                                            padding: "5px",
                                                                                                            fontSize: "12px",
                                                                                                            whiteSpace: "normal",
                                                                                                            wordBreak: "break-word"
                                                                                                        }}
                                                                                                    >
                                                                                                        {typeof value === "number" ? value.toLocaleString("en-IN") : value}
                                                                                                    </td>
                                                                                                );
                                                                                            })}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {selectedName === "interactive1" && (
                                                                <div className="w-100">
                                                                    <h6 className="text-center mb-2 fw-bold">
                                                                        NBFC Exposure and NPA Trend
                                                                    </h6>

                                                                    <ResponsiveContainer width="100%" height={350}>
                                                                        <LineChart
                                                                            data={tableData}
                                                                            margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                                                                        >
                                                                            <CartesianGrid strokeDasharray="3 3" />

                                                                            {/* ✅ Add padding to prevent edge labels from touching */}
                                                                            <XAxis
                                                                                dataKey="Date"
                                                                                tick={{ fontSize: 12 }}
                                                                                padding={{ left: 30, right: 30 }} // 👈 adds horizontal padding
                                                                            />

                                                                            <YAxis
                                                                                tick={{ fontSize: 12 }}
                                                                                domain={[0, (dataMax) => Math.ceil(dataMax / 1000) * 1000]}
                                                                                ticks={Array.from(
                                                                                    {
                                                                                        length: Math.ceil((Math.max(...tableData.map(d =>
                                                                                            Math.max(d["Bank's Exposure in NBFC"], d["Bank's NPA in NBFC"])
                                                                                        )) || 0) / 1000) + 1
                                                                                    },
                                                                                    (_, i) => i * 1000
                                                                                )}
                                                                                tickFormatter={(v) => `${v.toLocaleString()}`}
                                                                            />

                                                                            <Tooltip formatter={(v) => `${v.toLocaleString()} ₹ Cr`} />
                                                                            <Legend />

                                                                            <Line
                                                                                type="monotone"
                                                                                dataKey="Bank's Exposure in NBFC"
                                                                                stroke="#007bff"
                                                                                strokeWidth={2.5}
                                                                                dot={{ r: 4 }}
                                                                                label={{ position: "top", fontSize: 11 }}
                                                                            />
                                                                            <Line
                                                                                type="monotone"
                                                                                dataKey="Bank's NPA in NBFC"
                                                                                stroke="#dc3545"
                                                                                strokeWidth={2.5}
                                                                                dot={{ r: 4 }}
                                                                                label={{ position: "top", fontSize: 11 }}
                                                                            />
                                                                        </LineChart>
                                                                    </ResponsiveContainer>
                                                                </div>
                                                            )}



                                                            {selectedName === "report18" && differenceTable1.length > 0 && (
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <h6 className="text-center fw-bold mb-2">Difference</h6>
                                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "141px" }}>
                                                                        <div className="custom-table-with-status-colors w-100 position-relative">
                                                                            <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                                                                <thead className="sticky-header">
                                                                                    <tr>
                                                                                        {[`Increase / Decrease in ${formattedFromDate} viz-a-viz ${formattedToDate}`].map((col, i) => (
                                                                                            <th
                                                                                                key={i}
                                                                                                style={{
                                                                                                    textAlign: "center",
                                                                                                    border: "1px solid black",
                                                                                                    padding: "5px",
                                                                                                    whiteSpace: "normal",
                                                                                                    minWidth: "60px",
                                                                                                    wordBreak: "break-word"
                                                                                                }}
                                                                                            >
                                                                                                {col}
                                                                                            </th>
                                                                                        ))}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody style={{ border: "1px solid #ddd", fontSize: "12px" }}>
                                                                                    {differenceTable1.map((row, rIndex) => (
                                                                                        <tr
                                                                                            key={rIndex}
                                                                                            style={{
                                                                                                border: "1px solid #ddd",
                                                                                                padding: "5px",
                                                                                                backgroundColor: rIndex % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                                                            }}
                                                                                        >
                                                                                            {["Balance "].map((col, cIndex) => {
                                                                                                const value = row[col];
                                                                                                return (
                                                                                                    <td
                                                                                                        key={cIndex}
                                                                                                        style={{
                                                                                                            border: "1px solid #ddd",
                                                                                                            padding: "5px",
                                                                                                            fontSize: "12px",
                                                                                                            whiteSpace: "normal",
                                                                                                            wordBreak: "break-word"
                                                                                                        }}
                                                                                                    >
                                                                                                        {typeof value === "number" ? value.toLocaleString("en-IN") : value}
                                                                                                    </td>
                                                                                                );
                                                                                            })}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                        </div >
                                                    </>
                                                );
                                            })() : (
                                                <p className="text-center text-muted">No data available.</p>
                                            )}
                                        </div>



                                        {reportGenerated && tableData.length > 0 &&
                                            (
                                                selectedName === "actcust" ||
                                                selectedName === "additional_gl_balance" ||
                                                selectedName === "distribution_exposure" ||
                                                selectedName === "exchange_rates" ||
                                                selectedName === "investment_depreciationamount" ||
                                                selectedName === "pf_superannuation" ||
                                                selectedName === "profit_flag" ||
                                                // selectedName === "fully_unavailed_tl" ||
                                                selectedName === "rating_override" ||
                                                selectedName === "restructured_data" ||
                                                selectedName === "balance_sheet" ||
                                                selectedName === "bulkdatarecords4" ||
                                                selectedName === "bulkdatarecords5" ||
                                                selectedName === "bulkdatarecords6" ||
                                                selectedName === "bulkrecordsupload" ||
                                                selectedName === "bulkuploads56" ||
                                                selectedName === "report" ||
                                                selectedName === "report3" ||
                                                selectedName === "report4" ||
                                                selectedName === "report5" ||
                                                selectedName === "report6" ||
                                                selectedName === "report7" ||
                                                selectedName === "report8" ||
                                                // selectedName === "report9" ||
                                                selectedName === "report10" ||
                                                selectedName === "report11" ||
                                                selectedName === "unavailed_data" ||
                                                selectedName === "report13"
                                                // selectedName === "npa_test1"
                                                // selectedName === "report14"
                                            ) && (() => {

                                                let overallYield = "0.00%";
                                                let standardYield = "0.00%";

                                                // =========================
                                                // Case 1: actcust / bulkupload variants
                                                // =========================
                                                if (
                                                    selectedName === "actcust" ||
                                                    selectedName === "bulkdatarecords5" ||
                                                    selectedName === "bulkdatarecords6" ||
                                                    selectedName === "bulkuploads56" ||
                                                    selectedName === "report13"
                                                ) {
                                                    const grandTotalRow = tableData.find(row => row.Sector === "Grand Total");

                                                    if (grandTotalRow) {
                                                        const totalBalance = Number(grandTotalRow["Balance"] || 0);
                                                        const totalInterest = Number(grandTotalRow["INTEREST"] || 0);

                                                        // 1️⃣ Overall yield directly from column
                                                        overallYield = `${grandTotalRow["Yield on Advances"]}`;

                                                        // 2️⃣ Standard yield = Interest ÷ Balance × 100
                                                        standardYield =
                                                            totalBalance > 0
                                                                ? `${((totalInterest / totalBalance) * 100).toFixed(2)}%`
                                                                : "0.00%";
                                                    }
                                                }

                                                // =========================
                                                // Case 2: All other reports (report9, unavailed_data, etc.)
                                                // =========================
                                                else if (
                                                    selectedName === "additional_gl_balance" ||
                                                    selectedName === "distribution_exposure" ||
                                                    selectedName === "exchange_rates" ||
                                                    selectedName === "investment_depreciationamount" ||
                                                    selectedName === "pf_superannuation" ||
                                                    selectedName === "profit_flag" ||
                                                    // selectedName === "fully_unavailed_tl" ||
                                                    selectedName === "rating_override" ||
                                                    selectedName === "restructured_data" ||
                                                    selectedName === "balance_sheet" ||
                                                    selectedName === "bulkdatarecords4" ||
                                                    // selectedName === "bulkrecordsupload" ||
                                                    selectedName === "report" ||
                                                    selectedName === "report3" ||
                                                    selectedName === "report4" ||
                                                    selectedName === "report5" ||
                                                    selectedName === "report6" ||
                                                    selectedName === "report7" ||
                                                    selectedName === "report8" ||
                                                    selectedName === "report9" ||
                                                    selectedName === "report10" ||
                                                    selectedName === "report11" ||
                                                    selectedName === "unavailed_data" ||
                                                    // selectedName === "npa_test1" ||
                                                    // selectedName === "report14" ||
                                                    selectedName === "report18") {
                                                    const fromGrandTotal = tableData.find(
                                                        row => row.Date === fromDate && row.Sector === "Grand Total"
                                                    );
                                                    const toGrandTotal = tableData.find(
                                                        row => row.Date === toDate && row.Sector === "Grand Total"
                                                    );

                                                    if (toGrandTotal) {
                                                        const totalBalance = Number(toGrandTotal["Balance"] || 0);
                                                        const totalInterest = Number(toGrandTotal["INTEREST"] || 0);

                                                        // 1️⃣ Overall Portfolio Yield (weighted % from table)
                                                        overallYield = `${toGrandTotal["Yield on Advances"]}`;

                                                        // 2️⃣ Portfolio Yield on Standard Accounts (Interest ÷ Balance × 100)
                                                        standardYield =
                                                            totalBalance > 0
                                                                ? `${((totalInterest / totalBalance) * 100).toFixed(2)}%`
                                                                : "0.00%";
                                                    } else {
                                                        overallYield = "0.00%";
                                                        standardYield = "0.00%";
                                                    }
                                                }

                                                // =========================
                                                // Render both yields
                                                // =========================
                                                return (
                                                    <div className="col-8 d-flex justify-content-end">
                                                        <table className="table table-bordered w-auto text-start">
                                                            <tbody>
                                                                <tr>
                                                                    <td>Overall Portfolio yield</td>
                                                                    <td className="text-end">
                                                                        {processedReports[selectedName]?.overallPortfolioYield != null
                                                                            ? Number(processedReports[selectedName].overallPortfolioYield).toFixed(2)
                                                                            : "0.00"}%
                                                                    </td>


                                                                </tr>
                                                                <tr>
                                                                    <td>Portfolio yield on Standard accounts</td>
                                                                    <td className="text-end">
                                                                        {processedReports[selectedName]?.stdActsPortfolioYield != null
                                                                            ? Number(processedReports[selectedName].stdActsPortfolioYield).toFixed(2)
                                                                            : "0.00"}%
                                                                    </td>

                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                );
                                            })()
                                        }


                                        {reportGenerated && tableData.length > 0 ? (
                                            <div className="mb-1">
                                                <strong>Following are the major observations of the segment:</strong>
                                                <br />

                                                <div style={{ maxHeight: "120px", overflowY: "auto", marginLeft: "20px", marginTop: "2px" }}>
                                                    {npaDescription ? (
                                                        <ul>
                                                            <ul>
                                                                {npaDescription.split("||").map((point, index) =>
                                                                    point.trim() ? <li key={index}>{point.trim()}</li> : null
                                                                )}
                                                            </ul>

                                                        </ul>
                                                    ) : (
                                                        <span>No data available for selected period.</span>
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main >
            <Footer />
        </div >
    );

}

export default GapsyReport;
